import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  NaiveDateTime: string;
  UUID: any;
};

export type AcceptActivityInput = {
  /** The Activity Id to submit for validation. */
  id: Scalars['ID'];
};

export type AcceptActivityPayload = {
  __typename?: 'AcceptActivityPayload';
  /** The accepted Activity. */
  activity: Activity;
};

export type AcceptBookingStageInput = {
  acceptedById: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type AcceptBookingStagePayload = {
  __typename?: 'AcceptBookingStagePayload';
  booking: Booking;
};

export type AcceptUserInCommunityInput = {
  id: Scalars['ID'];
};

export type AcceptUserInCommunityPayload = {
  __typename?: 'AcceptUserInCommunityPayload';
  user: User;
};

/** An accommodation describes a place to stay which is owned by a host. */
export type Accommodation = {
  __typename?: 'Accommodation';
  /** The accommodation type. */
  accommodationType: Maybe<AccommodationType>;
  /** The animals present within the accommodation. */
  animals: Maybe<Animals>;
  /** Time at which the accomodation was archived. */
  archivedAt: Maybe<Scalars['DateTime']>;
  /** The room area */
  area: Areas;
  atLeastNineSqmRoom: Maybe<Scalars['Boolean']>;
  /** The accommodation available from date. */
  availableFrom: Maybe<Scalars['Date']>;
  /** A paginated list of bookings linked to the accommodation. */
  bookings: Maybe<BookingConnection>;
  /** The charter of the accommodation. */
  charter: Maybe<Charter>;
  /** The accommodation comment. */
  comment: Maybe<Scalars['String']>;
  /** Time at which the accomodation was completed. */
  completedAt: Maybe<Scalars['DateTime']>;
  /** The accommodation description. */
  description: Maybe<Scalars['String']>;
  /** The equipment of the accommodation. */
  equipment: Maybe<Array<EquipmentType>>;
  /** The accommodation featured picture. */
  featuredPicture: Maybe<Picture>;
  /** The preferred housemate gender */
  genderPreference: Maybe<GenderPreferences>;
  generalState: Maybe<Scalars['String']>;
  /** The default guest fixed fee for the room */
  guestFixedFee: Scalars['Int'];
  /** The default guest variable fee for the room */
  guestVariableFee: Scalars['Float'];
  /** The accommodation headline. */
  headline: Maybe<Scalars['String']>;
  /** The preferred housemate homeworking frequency */
  homeworkingFrequencyPreference: Maybe<HomeworkingFrequencies>;
  /** The host of the accommodation. */
  host: Host;
  /** The default host fixed fee for the room */
  hostFixedFee: Scalars['Int'];
  /** The gender of the host (to be used for matching) */
  hostGender: Maybe<Gender>;
  /** The default host variable fee for the room */
  hostVariableFee: Scalars['Float'];
  /** The housing type. */
  housingType: Maybe<HousingType>;
  /** The accommodation id. */
  id: Scalars['ID'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  /** Whether the accommodation is eligible for housing assistance */
  isEligibleForHousingAssistance: Scalars['Boolean'];
  /** The preferred housemate kitchen use frequency */
  kitchenUsePreference: Maybe<KitchenUseFrequencies>;
  /** The preferred housemate spoken language */
  languagePreference: Maybe<LanguagePreferences>;
  /** The location of the accommodation. */
  location: Maybe<Location>;
  /** The max request count */
  maxRequestCount: Scalars['Int'];
  meetsSafetyStandards: Maybe<Scalars['Boolean']>;
  numberOfBedrooms: Maybe<Scalars['Int']>;
  numberOfRoomsAccessibleToGuest: Maybe<Scalars['Int']>;
  /** The owner of the accommodation. */
  owner: User;
  /** The accommodation pictures. */
  pictures: Maybe<Array<Picture>>;
  /** The price of the accommodation. */
  price: Maybe<Price>;
  privateRoomForGuest: Maybe<Scalars['Boolean']>;
  /** The private rooms of the accommodation. */
  privateRooms: Maybe<Array<Rooms>>;
  professionalPicturesValidatedAt: Maybe<Scalars['DateTime']>;
  /** Whether the accommodation is published or not */
  published: Scalars['Boolean'];
  rentDuration: RentDuration;
  /** The rented room of the accommodation. */
  room: Room;
  roomAvailable: Maybe<Scalars['Boolean']>;
  schoolYear: Maybe<Scalars['Boolean']>;
  /** The shared rooms of the accommodation. */
  sharedRooms: Maybe<Array<Rooms>>;
  /** The accommodation shared size in square meters. */
  sharedSize: Maybe<Scalars['Int']>;
  /** The accommodation size in square meters. */
  size: Maybe<Scalars['Int']>;
  /** The accommodation subheading. */
  subheading: Maybe<Scalars['String']>;
  t3OrBigger: Maybe<Scalars['Boolean']>;
  /** The transit stations located near the accommodation. */
  transitStations: Maybe<Array<TransitStation>>;
  updatedAt: Maybe<Scalars['NaiveDateTime']>;
  visitedAt: Maybe<Scalars['DateTime']>;
};


/** An accommodation describes a place to stay which is owned by a host. */
export type AccommodationBookingsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A paginated list of accommodations. */
export type AccommodationConnection = {
  __typename?: 'AccommodationConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<AccommodationEdge>>>;
  pageInfo: PageInfo;
};

export type AccommodationEdge = {
  __typename?: 'AccommodationEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Accommodation>;
};

/** The possible accommodation types */
export enum AccommodationType {
  BedroomInPrivateHome = 'BEDROOM_IN_PRIVATE_HOME',
  IndependentBedroom = 'INDEPENDENT_BEDROOM',
  IndependentStudio = 'INDEPENDENT_STUDIO',
  StudioInPrivateHome = 'STUDIO_IN_PRIVATE_HOME'
}

/** Describes available filters when listing accommodations. */
export type AccommodationsFilterInput = {
  availability: InputMaybe<AvailabilityFilterInput>;
  bookable: InputMaybe<Scalars['Boolean']>;
  equipment: InputMaybe<Array<InputMaybe<EquipmentFilterInput>>>;
  preference: InputMaybe<PreferenceFilterInput>;
  price: InputMaybe<PriceFilterInput>;
  privateRooms: InputMaybe<Array<InputMaybe<PrivateRoomsFilterInput>>>;
  rooms: InputMaybe<Array<InputMaybe<RoomsFilterInput>>>;
};

/** An account. */
export type Account = {
  __typename?: 'Account';
  /** The account balance. */
  balance: Scalars['Int'];
  /** The account currency */
  currency: AccountCurrencies;
  /** Returns the account's entries */
  entries: Maybe<EntryConnection>;
  /** The account id. */
  id: Scalars['ID'];
  /** The account lower limit */
  lowerLimit: Maybe<Scalars['Int']>;
  /** The account reserved amount */
  reserved: Scalars['Int'];
  /** The account upper limit */
  upperLimit: Maybe<Scalars['Int']>;
};


/** An account. */
export type AccountEntriesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The possible account currencies */
export enum AccountCurrencies {
  Col = 'COL'
}

export type ActivateUserInput = {
  id: Scalars['UUID'];
};

export type ActivateUserPayload = {
  __typename?: 'ActivateUserPayload';
  user: User;
};

/** An activity. */
export type Activity = {
  __typename?: 'Activity';
  /** The activity validation time. */
  acceptedAt: Maybe<Scalars['DateTime']>;
  /** The activity archivation time. */
  archivedAt: Maybe<Scalars['DateTime']>;
  /** A paginated list of attendances for that activity. */
  attendances: Maybe<ActivityAttendanceConnection>;
  /** The current number of attendess */
  attendeeCount: Scalars['Int'];
  /** The list of categories associated to the activity. */
  categories: Maybe<Array<Category>>;
  /** The activity's class if any */
  class: Maybe<ActivityClasses>;
  /** Value that indicates whether or not the activity was initially created by a Colette admin. */
  createdByColette: Scalars['Boolean'];
  /** The activity's creator. */
  creator: Maybe<User>;
  /** The activity description. */
  description: Scalars['String'];
  /** The activity duration (in minutes). */
  duration: Scalars['Int'];
  /** The activity headline. */
  headline: Scalars['String'];
  /** The activity id. */
  id: Scalars['ID'];
  /** The time at which the activity was created. */
  insertedAt: Scalars['NaiveDateTime'];
  /** The activity location (either a URL or a geographic address). */
  location: Maybe<Scalars['String']>;
  /** The maximum number of attendees. */
  maxAttendees: Scalars['Int'];
  /** Whether the activity is exclusively for mobile or not. */
  mobileExclusive: Scalars['Boolean'];
  /** The activity name. */
  name: Scalars['String'];
  /** The activity's organizer. */
  organizer: Maybe<User>;
  /** The activity's organizer name. */
  organizerName: Maybe<Scalars['String']>;
  /** The activity picture. */
  picture: Maybe<Picture>;
  /** The price of the activity. */
  price: Price;
  /** The time at which the activity is published. */
  publicationTime: Maybe<Scalars['DateTime']>;
  /** Whether the activity is published or not. */
  published: Scalars['Boolean'];
  /** The activity rejection time. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The activity's scene (either online or offline). */
  scene: ActivitySceneTypes;
  /** The time at which the activity starts. */
  startTime: Scalars['DateTime'];
  /** The status of the activity */
  status: ActivityStatuses;
  /** The activity submission time for validation. */
  submittedForValidationAt: Maybe<Scalars['DateTime']>;
  /** The activity thread. */
  thread: Thread;
  /** The timezone of the activity. */
  timezone: Scalars['String'];
  /** The activity type. */
  type: ActivityTypes;
};


/** An activity. */
export type ActivityAttendancesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ActivityAttendancesFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** An activity attendance. */
export type ActivityAttendance = {
  __typename?: 'ActivityAttendance';
  /** The activity */
  activity: Activity;
  /** The activity ID */
  activityId: Scalars['ID'];
  /** The activity duration (in minutes). */
  attendanceConfirmation: ActivityAttendanceConfirmationStates;
  /** The activity attendance id. */
  id: Scalars['ID'];
  /** The time at which the attendance was registered. */
  insertedAt: Scalars['NaiveDateTime'];
  /** The activity rating by the user. */
  rating: Maybe<Scalars['Int']>;
  /** Whether the user registered to the activity by herself or not. */
  selfRegistered: Maybe<Scalars['Boolean']>;
  /** The user */
  user: Maybe<User>;
  /** The user ID */
  userId: Scalars['ID'];
};

/** The possible states of an activity attendance confirmation. */
export enum ActivityAttendanceConfirmationStates {
  Confirmed = 'CONFIRMED',
  Disconfirmed = 'DISCONFIRMED',
  Pending = 'PENDING'
}

/** A paginated list of activity attendances. */
export type ActivityAttendanceConnection = {
  __typename?: 'ActivityAttendanceConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<ActivityAttendanceEdge>>>;
  pageInfo: PageInfo;
};

export type ActivityAttendanceEdge = {
  __typename?: 'ActivityAttendanceEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<ActivityAttendance>;
};

export type ActivityAttendancesFilterInput = {
  attendanceConfirmation: InputMaybe<ActivityAttendanceConfirmationStates>;
};

/** The possible classes of an activity. */
export enum ActivityClasses {
  Community = 'COMMUNITY',
  Meeting = 'MEETING',
  Professional = 'PROFESSIONAL'
}

/** A paginated list of activities. */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<ActivityEdge>>>;
  pageInfo: PageInfo;
};

/** Date range filter for activities. */
export type ActivityDateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

/** Duration filter for activities. */
export type ActivityDuration = {
  operator: ActivityOperator;
  value: Scalars['Int'];
};

/** Time qualifier filter for activities. */
export enum ActivityDuring {
  Afternoon = 'AFTERNOON',
  Day = 'DAY',
  DinnerTime = 'DINNER_TIME',
  LunchTime = 'LUNCH_TIME',
  Morning = 'MORNING',
  Night = 'NIGHT'
}

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Activity>;
};

/** Describes available filters when listing activities. */
export type ActivityFilterInput = {
  /** Filters activities by validation time. */
  acceptedAt: InputMaybe<ActivityDateRange>;
  /** Filters activities by archivation time. */
  archivedAt: InputMaybe<ActivityDateRange>;
  /** Filters activities based on whether they're linked to at least the provided UUIDs or not */
  categoryIds: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Filters activities by class. */
  class: InputMaybe<ActivityClasses>;
  /** Filters activities based on whether or not they've been created by a Colette admin. */
  createdByColette: InputMaybe<Scalars['Boolean']>;
  /** Filters activities based on whom they were created by. */
  creatorIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filters activities by start time. */
  dateRange: InputMaybe<ActivityDateRange>;
  /** Filters activities by duration. */
  duration: InputMaybe<ActivityDuration>;
  /** Filters activities based on their scheduled start time. */
  during: InputMaybe<ActivityDuring>;
  /** Filters activities based on whether they're exclusively for mobile or not */
  mobileExclusive: InputMaybe<Scalars['Boolean']>;
  /** Filters activities based on whom they were created by. */
  organizerIds: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filters activities by price. */
  price: InputMaybe<ActivityPrice>;
  /** Filters activities by whether they were published at the given time or not. */
  publishedAt: InputMaybe<Scalars['DateTime']>;
  /** Filters activities by rejection time. */
  rejectedAt: InputMaybe<ActivityDateRange>;
  /** Filters activities based on their scene (online/offline). */
  scene: InputMaybe<ActivityScene>;
  /** Filters activities by search expression. */
  search: InputMaybe<Scalars['String']>;
  /** Filters activities by seat_availability. */
  seatAvailability: InputMaybe<ActivitySeatAvailability>;
  /** Filters activities by size (number of attendees). */
  size: InputMaybe<ActivitySize>;
  /** Filters activities by statuses. */
  statuses: InputMaybe<Array<ActivityStatuses>>;
  /** Filters activities by submission time (for validation). */
  submittedForValidationAt: InputMaybe<ActivityDateRange>;
  /** Filters activities by type. */
  type: InputMaybe<ActivityTypes>;
};

export enum ActivityOperator {
  Equal = 'EQUAL',
  Less = 'LESS',
  More = 'MORE'
}

/** The attributes that are eligible to order activities by */
export enum ActivityOrderByAttributes {
  InsertedAt = 'INSERTED_AT',
  StartsIn = 'STARTS_IN',
  StartTime = 'START_TIME'
}

/** Describes available order by expressions when listing activities. */
export type ActivityOrderByInput = {
  /** Available attribute options to order activities */
  attribute: ActivityOrderByAttributes;
  /** Possible directions to order activities by */
  direction: OrderByDirection;
};

/** Price filter for activities. */
export type ActivityPrice = {
  currency: Scalars['String'];
  operator: ActivityOperator;
  value: Scalars['Int'];
};

/** Input for price */
export type ActivityPriceInput = {
  /** Amount in cents */
  amount: InputMaybe<Scalars['Int']>;
  /** Currency code like EUR */
  currency: InputMaybe<CurrencyType>;
};

/** Scene filter for activities. */
export enum ActivityScene {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

/** The possible scenes of an activity. */
export enum ActivitySceneTypes {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

/** Seat availability filter for activities. */
export type ActivitySeatAvailability = {
  operator: ActivityOperator;
  value: Scalars['Int'];
};

/** Size (number of attendees) filter for activities. */
export type ActivitySize = {
  from: Scalars['Int'];
  to: InputMaybe<Scalars['Int']>;
};

/** The possible statuses of an activity. */
export enum ActivityStatuses {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  SubmittedForValidation = 'SUBMITTED_FOR_VALIDATION'
}

/** The possible types of an activity. */
export enum ActivityTypes {
  Activity = 'ACTIVITY',
  Baptism = 'BAPTISM',
  FreeActivity = 'FREE_ACTIVITY'
}

export type AddAccommodationPicturesInput = {
  accommodationId: Scalars['String'];
  pictures: InputMaybe<Array<InputMaybe<PictureInput>>>;
};

export type AddAccommodationPicturesPayload = {
  __typename?: 'AddAccommodationPicturesPayload';
  accommodation: Accommodation;
};

export type AddCommentInput = {
  /** The comment's body. */
  body: Scalars['String'];
  /** The commentable's ID. */
  commentableId: Scalars['ID'];
  /** The commentable's type. */
  commentableType: CommentableType;
};

export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  comment: Comment;
};

export type AddUserToDiscussionGroupInput = {
  discussionGroupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type AddUserToDiscussionGroupPayload = {
  __typename?: 'AddUserToDiscussionGroupPayload';
  discussionGroup: DiscussionGroup;
};

export type AmenitiesInput = {
  dishwasher: InputMaybe<Scalars['Boolean']>;
  dryer: InputMaybe<Scalars['Boolean']>;
  elevator: InputMaybe<Scalars['Boolean']>;
  fridge: InputMaybe<Scalars['Boolean']>;
  internet: InputMaybe<Scalars['Boolean']>;
  microwaveOven: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
  oven: InputMaybe<Scalars['Boolean']>;
  tv: InputMaybe<Scalars['Boolean']>;
  washingMachine: InputMaybe<Scalars['Boolean']>;
  wifi: InputMaybe<Scalars['Boolean']>;
};

/** Animals present within an accommodation. */
export type Animals = {
  __typename?: 'Animals';
  cat: Scalars['Boolean'];
  dog: Scalars['Boolean'];
  other: Maybe<Scalars['String']>;
};

export type AnimalsInput = {
  cat: InputMaybe<Scalars['Boolean']>;
  dog: InputMaybe<Scalars['Boolean']>;
  nothing: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
};

export type ApplyEntryInput = {
  /** The account ID */
  accountId: Scalars['ID'];
  /** The amount in cents.  Might be positive (credit) or negative (debit) but not null. */
  amount: Scalars['Int'];
  /** The entry communication */
  communication: InputMaybe<Scalars['String']>;
};

export type ApplyEntryPayload = {
  __typename?: 'ApplyEntryPayload';
  account: Account;
};

export type ArchiveAccommodationInput = {
  id: Scalars['String'];
};

export type ArchiveAccommodationPayload = {
  __typename?: 'ArchiveAccommodationPayload';
  accommodation: Accommodation;
};

export type ArchiveActivityInput = {
  /** The Activity Id to submit for validation. */
  id: Scalars['ID'];
};

export type ArchiveActivityPayload = {
  __typename?: 'ArchiveActivityPayload';
  /** The archived Activity. */
  activity: Activity;
};

export type ArchiveDiscussionGroupInput = {
  /** The discussion group ID to archive */
  id: Scalars['UUID'];
};

export type ArchiveDiscussionGroupPayload = {
  __typename?: 'ArchiveDiscussionGroupPayload';
  /** The archived discussion group. */
  discussionGroup: DiscussionGroup;
};

export type ArchiveThreadInput = {
  /** The thread ID */
  id: Scalars['UUID'];
};

export type ArchiveThreadPayload = {
  __typename?: 'ArchiveThreadPayload';
  thread: Thread;
};

/** The possible areas */
export enum Areas {
  Bordeaux = 'BORDEAUX',
  Lyon = 'LYON',
  Paris = 'PARIS'
}

/** Describes a filter used to perform basic filtering against an array. */
export type ArrayFilterInput = {
  /** Searches for records which includes given values in the array. */
  in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Searches for records which does not include given values in the array. */
  nin: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AuthenticateAdminByEmailInput = {
  /** The admin's email address. */
  email: Scalars['String'];
  /** The user's password. */
  password: Scalars['String'];
};

export type AuthenticateAdminByEmailPayload = {
  __typename?: 'AuthenticateAdminByEmailPayload';
  /** The authentication token generated for the authenticated user. */
  token: Scalars['String'];
  /** The authenticated user. */
  user: User;
};

/** Describes accommodation's availability filter. */
export type AvailabilityFilterInput = {
  available: InputMaybe<Scalars['Boolean']>;
  from: InputMaybe<Scalars['String']>;
  to: InputMaybe<Scalars['String']>;
};

/** An avatar accessible through a URL. */
export type Avatar = {
  __typename?: 'Avatar';
  basename: Maybe<Scalars['String']>;
  ext: Maybe<Scalars['String']>;
  md5hash: Maybe<Scalars['String']>;
  mime: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  public: Maybe<Scalars['Boolean']>;
  size: Maybe<Scalars['Int']>;
  url: Maybe<Scalars['String']>;
};

/** A room's balcony. */
export type Balcony = {
  __typename?: 'Balcony';
  isAvailable: Scalars['Boolean'];
};

export type BanUserInput = {
  id: Scalars['String'];
};

export type BanUserPayload = {
  __typename?: 'BanUserPayload';
  user: User;
};

export type BaptizeUserInput = {
  id: Scalars['ID'];
};

export type BaptizeUserPayload = {
  __typename?: 'BaptizeUserPayload';
  user: User;
};

/** A room's bathroom. */
export type Bathroom = {
  __typename?: 'Bathroom';
  hasBathtub: Scalars['Boolean'];
  hasShower: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
};

export type BathroomInput = {
  bathtub: InputMaybe<Scalars['Boolean']>;
  shower: InputMaybe<Scalars['Boolean']>;
};

/** A room's bed. */
export type Bed = {
  __typename?: 'Bed';
  bedding: Maybe<Scalars['String']>;
  hasBlanket: Scalars['Boolean'];
  hasDuvet: Scalars['Boolean'];
};

export type BedLinenInput = {
  blanket: InputMaybe<Scalars['Boolean']>;
  duvet: InputMaybe<Scalars['Boolean']>;
};

/**
 * A booking describes a request between a guest and a host to book a
 * stay for a given accommodation and stay period.
 */
export type Booking = {
  __typename?: 'Booking';
  /** The booking confirmation */
  bookingConfirmation: Maybe<BookingConfirmation>;
  /** The booking report linked to the booking. */
  bookingReport: Maybe<BookingReport>;
  /** The booking request */
  bookingRequest: Maybe<BookingRequest>;
  /** The booking's date of cancellation. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The user who cancelled the booking if any. */
  cancelledBy: Maybe<User>;
  /** The person's ID who cancelled the booking. */
  cancelledById: Maybe<Scalars['String']>;
  /** The contact request that initiated the booking. */
  contactRequest: ContactRequest;
  currentPhase: Maybe<BookingPhase>;
  currentStage: BookingStages;
  /** The booking's date of money deposit. */
  depositPaidAt: Maybe<Scalars['DateTime']>;
  /** The booking's date the stay ends at. */
  endDate: Scalars['Date'];
  /** The booking's end reason. */
  endReason: Maybe<Scalars['String']>;
  /** The guest subject to the booking. */
  guest: User;
  /** The booking's guest end NPS */
  guestEndNps: Maybe<Scalars['Int']>;
  /** The booking's guest start NPS */
  guestStartNps: Maybe<Scalars['Int']>;
  /** The host subject to the booking. */
  host: User;
  /** The booking's host end NPS */
  hostEndNps: Maybe<Scalars['Int']>;
  /** The booking's host start NPS */
  hostStartNps: Maybe<Scalars['Int']>;
  /** The booking's id. */
  id: Scalars['ID'];
  /** The booking's date of creation. */
  insertedAt: Scalars['DateTime'];
  phases: Maybe<Array<BookingPhase>>;
  /** The booking's price. */
  price: Price;
  /** The booking's private end reason. */
  privateEndReason: Maybe<Scalars['String']>;
  /** The booking's date of rejection. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The user who rejected the booking if any. */
  rejectedBy: Maybe<User>;
  /** The person's ID who rejected the booking. */
  rejectedById: Maybe<Scalars['String']>;
  /** The rental linked to the booking. */
  rental: Maybe<Rental>;
  /** The booking's date it was rescheduled at. */
  rescheduledAt: Maybe<Scalars['DateTime']>;
  /** The room subject to the booking. */
  room: Accommodation;
  /** The room ID subject to the booking. */
  roomId: Scalars['String'];
  /** The booking's date the stay starts at. */
  startDate: Scalars['Date'];
  status: BookingStatuses;
  /** The booking's date of termination. */
  terminatedAt: Maybe<Scalars['DateTime']>;
  /** The user who terminated the booking if any. */
  terminatedBy: Maybe<User>;
  /** The person's ID who terminated the booking. */
  terminatedById: Maybe<Scalars['String']>;
};

/**
 * A booking confirmation describes the last stage of a booking where the guest
 * confirms her intent to house-share.
 */
export type BookingConfirmation = {
  __typename?: 'BookingConfirmation';
  /** The booking confirmation's date of acceptation by the host. */
  acceptedAt: Maybe<Scalars['DateTime']>;
  /** The user who accepted the booking confirmation if any. */
  acceptedBy: Maybe<User>;
  /** The ID of the user who accepted the booking confirmation. */
  acceptedById: Maybe<Scalars['ID']>;
  /** The booking confirmation's date of cancellation. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The user who cancelled the booking confirmation if any. */
  cancelledBy: Maybe<User>;
  /** The ID of the user who initiated the booking confirmation's cancellation. */
  cancelledById: Maybe<Scalars['ID']>;
  /** The booking confirmation's date the stay will end. */
  endDate: Scalars['Date'];
  /** The booking end reason. */
  endReason: Maybe<Scalars['String']>;
  /** The booking confirmation's id. */
  id: Scalars['ID'];
  /** The booking confirmation's date of creation. */
  insertedAt: Scalars['DateTime'];
  /** The booking confirmation's price. */
  price: Price;
  /** The booking private end reason. */
  privateEndReason: Maybe<Scalars['String']>;
  /** The booking confirmation's date of rejection by the host. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The user who rejected the booking confirmation if any. */
  rejectedBy: Maybe<User>;
  /** The ID of the user who initiated the rejection of the booking confirmation. */
  rejectedById: Maybe<Scalars['ID']>;
  /** The booking confirmation's date the stay will start. */
  startDate: Scalars['Date'];
  /** The booking confirmation's status. */
  status: BookingConfirmationStatusType;
};

/** The possible status for a booking request. */
export enum BookingConfirmationStatusType {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** A paginated list of bookings. */
export type BookingConnection = {
  __typename?: 'BookingConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<BookingEdge>>>;
  pageInfo: PageInfo;
};

export type BookingEdge = {
  __typename?: 'BookingEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Booking>;
};

export enum BookingEndReasons {
  Apl = 'APL',
  BadGuestProfile = 'BAD_GUEST_PROFILE',
  BadHostProfile = 'BAD_HOST_PROFILE',
  BadLivingConditions = 'BAD_LIVING_CONDITIONS',
  BadMatch = 'BAD_MATCH',
  ByPass = 'BY_PASS',
  Covid = 'COVID',
  Finance = 'FINANCE',
  FoundANewPlace = 'FOUND_A_NEW_PLACE',
  HealthIssues = 'HEALTH_ISSUES',
  MoreIndependence = 'MORE_INDEPENDENCE',
  Reliability = 'RELIABILITY',
  RoomNotAvailableAnymore = 'ROOM_NOT_AVAILABLE_ANYMORE',
  RoomPrice = 'ROOM_PRICE',
  UnexpectedEvent = 'UNEXPECTED_EVENT',
  Visa = 'VISA'
}

/** Available filters when listing bookings. */
export type BookingFilterInput = {
  /** Filters bookings depending on whether they have a booking report linked or not. */
  bookingReport: InputMaybe<Scalars['Boolean']>;
  /** Filters bookings by their actual end date (only returns the one that ended after the provided date). */
  endedAfter: InputMaybe<Scalars['Date']>;
  /** Filters bookings by a end date time range */
  endsBetween: InputMaybe<TimeRangeInput>;
  /** Filters bookings by guest (user) id. */
  guestId: InputMaybe<Scalars['ID']>;
  /** Filters bookings by host (user) id. */
  hostId: InputMaybe<Scalars['ID']>;
  /** Filters bookings by room id. */
  roomId: InputMaybe<Scalars['ID']>;
  /** Filters bookings by stage. */
  stage: InputMaybe<BookingStages>;
  /** Filters bookings by a start date time range */
  startsBetween: InputMaybe<TimeRangeInput>;
  /** Filters bookings by status. */
  statuses: InputMaybe<Array<InputMaybe<BookingStatuses>>>;
};

/** A booking phase. */
export type BookingPhase = {
  __typename?: 'BookingPhase';
  /** The time the phase has been cancelled */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The user who cancelled the booking phase if any. */
  cancelledBy: Maybe<User>;
  /** The ID of the user who initiated the cancellation */
  cancelledById: Maybe<Scalars['ID']>;
  /** The phase end date */
  endDate: Scalars['Date'];
  /** The end reason */
  endReason: Maybe<Scalars['String']>;
  /** The moment the phase ended in favor of a new one */
  endedAt: Maybe<Scalars['DateTime']>;
  /** The phase guest fixed fee (in cents). */
  guestFixedFee: Maybe<Scalars['Int']>;
  /** The phase guest variable fee (a percentage). */
  guestVariableFee: Maybe<Scalars['Float']>;
  /** The phase host fixed fee (in cents). */
  hostFixedFee: Maybe<Scalars['Int']>;
  /** The phase host variable fee (a percentage). */
  hostVariableFee: Maybe<Scalars['Float']>;
  /** The booking phase id. */
  id: Scalars['ID'];
  /** The phase's date of creation. */
  insertedAt: Scalars['DateTime'];
  /** The phase price. */
  price: Price;
  /** The time the phase price has been changed */
  priceChangedAt: Maybe<Scalars['DateTime']>;
  /** The user who changed the price of the booking if any. */
  priceChangedBy: Maybe<User>;
  /** The ID of the user who changed the phase price */
  priceChangedById: Maybe<Scalars['ID']>;
  /** The private end reason */
  privateEndReason: Maybe<Scalars['String']>;
  /** The time the phase has been rescheduled */
  rescheduledAt: Maybe<Scalars['DateTime']>;
  /** The user who rescheduled the booking if any. */
  rescheduledBy: Maybe<User>;
  /** The ID of the user who rescheduled the phase */
  rescheduledById: Maybe<Scalars['ID']>;
  /** The start date. */
  startDate: Scalars['Date'];
  /** The time the phase has been terminated */
  terminatedAt: Maybe<Scalars['DateTime']>;
  /** The user who terminated the booking if any. */
  terminatedBy: Maybe<User>;
  /** The ID of the user who initiated the termination */
  terminatedById: Maybe<Scalars['ID']>;
};

/** A booking report tracks how a booking went. */
export type BookingReport = {
  __typename?: 'BookingReport';
  /** The ID of the linked booking */
  bookingId: Scalars['ID'];
  /** The status of the linked booking */
  bookingStatus: BookingReportBookingStatus;
  /** A comment about the booking */
  comment: Maybe<Scalars['String']>;
  /** Whether we could have prevented the sudden end of the booking (when cancelled or terminated) */
  couldHaveBeenPrevented: Maybe<Scalars['Boolean']>;
  /** The reason the booking ended (when cancelled or terminated) */
  endReason: Maybe<BookingEndReasons>;
  /** The ID of the user who triggered the end of the booking (when it's terminated or cancelled) */
  endTriggeredBy: Maybe<Scalars['ID']>;
  /** Whether the guest has been rehoused (when cancelled or terminated) */
  guestRehoused: Maybe<Scalars['Boolean']>;
  /** Whether we'd like to retain the host or not (when booking finished) */
  hostDesiredRetention: Maybe<Scalars['Boolean']>;
  /** Whether the host has a new guest (when cancelled or terminated) */
  hostHasNewGuest: Maybe<Scalars['Boolean']>;
  /** Whether the host is still renting via Colette (when cancelled or terminated) */
  hostStillRenting: Maybe<Scalars['Boolean']>;
  /** The booking report's id. */
  id: Scalars['ID'];
  /** The issue with the host (when finished and we don't want to retain the host) */
  issueWithHost: Maybe<IssuesWithHost>;
  /** Whether a notice has been provided or not (when it's terminated) */
  noticeGiven: Maybe<Scalars['Boolean']>;
  /** Whether the host is a top host (when finished and we want to retain the host) */
  topHost: Maybe<Scalars['Boolean']>;
};

export enum BookingReportBookingStatus {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Terminated = 'TERMINATED'
}

/**
 * A booking request describes a request between a guest and a host to book a
 * stay for a given accommodation and stay period.
 */
export type BookingRequest = {
  __typename?: 'BookingRequest';
  /** The booking request's date of acceptation by the host. */
  acceptedAt: Maybe<Scalars['DateTime']>;
  /** The user who accepted the booking request if any. */
  acceptedBy: Maybe<User>;
  /** The ID of the user who accepted the booking request. */
  acceptedById: Maybe<Scalars['ID']>;
  /** The booking request's date of cancellation. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The user who cancelled the booking request if any. */
  cancelledBy: Maybe<User>;
  /** The ID of the user who initiated the booking request's cancellation. */
  cancelledById: Maybe<Scalars['ID']>;
  /** The booking request's date the stay will end. */
  endDate: Scalars['Date'];
  /** The booking request's end reason. */
  endReason: Maybe<Scalars['String']>;
  /** The booking request's id. */
  id: Scalars['ID'];
  /** The booking request's date of creation. */
  insertedAt: Scalars['DateTime'];
  /** The booking request's price. */
  price: Price;
  /** The booking request's private end reason. */
  privateEndReason: Maybe<Scalars['String']>;
  /** The booking request's date of rejection by the host. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The user who rejected the booking request if any. */
  rejectedBy: Maybe<User>;
  /** The ID of the user who initiated the rejection of the booking request. */
  rejectedById: Maybe<Scalars['ID']>;
  /** The booking request's date the stay will start. */
  startDate: Scalars['Date'];
  /** The booking request's status. */
  status: BookingRequestStatusType;
};

/** The possible status for a booking request. */
export enum BookingRequestStatusType {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** The possible stages for a booking. */
export enum BookingStages {
  BookingConfirmation = 'BOOKING_CONFIRMATION',
  BookingRequest = 'BOOKING_REQUEST',
  ContactRequest = 'CONTACT_REQUEST',
  HouseShare = 'HOUSE_SHARE'
}

/** The possible statuses for a booking. */
export enum BookingStatuses {
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING',
  Ready = 'READY',
  Rejected = 'REJECTED',
  Terminated = 'TERMINATED',
  Unpaid = 'UNPAID'
}

/** Describes available order by expressions when listing bookings. */
export type BookingsOrderByInput = {
  /** Desired rental duration for a guest. */
  endAt: InputMaybe<OrderByDirection>;
  /** Time at which the user was inserted. */
  insertedAt: InputMaybe<OrderByDirection>;
};

/** Describes user's budget filter. */
export type BudgetFilterInput = {
  /** Maximum budget in cents. */
  max: InputMaybe<Scalars['Int']>;
  /** Minimum budget in cents. */
  min: InputMaybe<Scalars['Int']>;
};

export type CancelBookingInput = {
  bookingId: Scalars['ID'];
  cancelledById: InputMaybe<Scalars['ID']>;
  endReason: InputMaybe<Scalars['String']>;
  privateEndReason: InputMaybe<Scalars['String']>;
};

export type CancelBookingPayload = {
  __typename?: 'CancelBookingPayload';
  booking: Booking;
};

export type CancelDepositInput = {
  rentalId: Scalars['ID'];
};

export type CancelDepositPayload = {
  __typename?: 'CancelDepositPayload';
  rental: Rental;
};

export type CancelPhotographerInput = {
  hostId: Scalars['String'];
};

export type CancelPhotographerPayload = {
  __typename?: 'CancelPhotographerPayload';
  host: Host;
};

export type CancelSubscriptionInput = {
  id: Scalars['ID'];
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  subscription: ClubSubscription;
};

export type CancelUserDeletionInput = {
  /** The user ID. */
  userId: Scalars['UUID'];
};

export type CancelUserDeletionPayload = {
  __typename?: 'CancelUserDeletionPayload';
  /** The updated user. */
  user: User;
};

/** A category */
export type Category = {
  __typename?: 'Category';
  /** The category id. */
  id: Scalars['ID'];
  /** The time at which the category was created. */
  insertedAt: Scalars['NaiveDateTime'];
  /** The category name */
  name: Scalars['String'];
};

/** A paginated list of categories. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<CategoryEdge>>>;
  pageInfo: PageInfo;
};

export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Category>;
};

/** Describes available filters when listing categories. */
export type CategoryFilterInput = {
  /** Filters categories by UUIDs */
  ids: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Filters categories by names */
  names: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An accommodation's charter. */
export type Charter = {
  __typename?: 'Charter';
  accommodationId: Scalars['String'];
  additionalElements: Maybe<Array<Maybe<CharterElement>>>;
  canDrinkAlcohol: Maybe<Scalars['Boolean']>;
  canInviteFamily: Maybe<Scalars['Boolean']>;
  canInviteFriends: Maybe<Scalars['Boolean']>;
  canInviteFriendsForASleepover: Maybe<Scalars['Boolean']>;
  canInvitePartner: Maybe<Scalars['Boolean']>;
  canReceiveDeliveries: Maybe<Scalars['Boolean']>;
  canSmoke: Maybe<Scalars['Boolean']>;
  comment: Maybe<Scalars['String']>;
  hostId: Scalars['String'];
  id: Scalars['String'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  updatedAt: Maybe<Scalars['NaiveDateTime']>;
};

/** An additional charter element */
export type CharterElement = {
  __typename?: 'CharterElement';
  authorized: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['String']>;
};

export type CharterElementInput = {
  authorized: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

/** The possible cleanliness preferences. */
export enum CleanlinessPreferences {
  Clean = 'CLEAN',
  Indifferent = 'INDIFFERENT',
  Obsessive = 'OBSESSIVE',
  Tidy = 'TIDY'
}

/** A club subscription. */
export type ClubSubscription = {
  __typename?: 'ClubSubscription';
  cancelAt: Maybe<Scalars['DateTime']>;
  cancelledAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  /** The subscription id */
  id: Scalars['ID'];
  /** The price. */
  price: Price;
  /** The scope. */
  scope: Scalars['String'];
  /** The subscription status */
  status: SubscriptionStatuses;
  stripeData: Maybe<SubscriptionStripeData>;
  /** The user */
  user: User;
  /** The user ID. */
  userId: Scalars['ID'];
};

/** A paginated list of subscriptions. */
export type ClubSubscriptionConnection = {
  __typename?: 'ClubSubscriptionConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<ClubSubscriptionEdge>>>;
  pageInfo: PageInfo;
};

export type ClubSubscriptionEdge = {
  __typename?: 'ClubSubscriptionEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<ClubSubscription>;
};

/** A comment. */
export type Comment = {
  __typename?: 'Comment';
  /** The comment's author. */
  author: User;
  /** The comment's body. */
  body: Scalars['String'];
  /** The comment's id. */
  id: Scalars['ID'];
  /** The time at which the comment has been created. */
  insertedAt: Scalars['DateTime'];
  /** The time at which the comment has been updated. */
  updatedAt: Scalars['DateTime'];
};

/** A paginated list of comments. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<CommentEdge>>>;
  pageInfo: PageInfo;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Comment>;
};

/** Describes commentable filter. */
export type CommentableFilterInput = {
  id: Scalars['ID'];
  type: CommentableType;
};

/** The possible types for a commentable object. */
export enum CommentableType {
  Candidate = 'CANDIDATE',
  User = 'USER'
}

/** Describes available filters when listing comments. */
export type CommentsFilterInput = {
  commentable: InputMaybe<CommentableFilterInput>;
};

/** The possible community vetting statuses */
export enum CommunityVettingStatuses {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Describes the user's completion score filter. */
export type CompletionScoreFilterInput = {
  /** Operator */
  operator: InputMaybe<CompletionScoreOperator>;
  /** Value as an integer. */
  value: InputMaybe<Scalars['Int']>;
};

export enum CompletionScoreOperator {
  Equal = 'EQUAL',
  Less = 'LESS',
  More = 'MORE'
}

export type ConfirmActivityAttendanceInput = {
  activityAttendanceId: Scalars['ID'];
};

export type ConfirmActivityAttendancePayload = {
  __typename?: 'ConfirmActivityAttendancePayload';
  activityAttendance: ActivityAttendance;
};

export type ConfirmUserEmailInput = {
  email: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ConfirmUserEmailPayload = {
  __typename?: 'ConfirmUserEmailPayload';
  user: User;
};

export type ConfirmUserPhoneNumberInput = {
  id: Scalars['String'];
  phoneNumber: InputMaybe<Scalars['String']>;
};

export type ConfirmUserPhoneNumberPayload = {
  __typename?: 'ConfirmUserPhoneNumberPayload';
  user: User;
};

/** A contact information object */
export type ContactInformation = {
  __typename?: 'ContactInformation';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  phoneNumber: Maybe<Scalars['String']>;
};

/** Input for contact information */
export type ContactInformationInput = {
  email: InputMaybe<Scalars['String']>;
  firstName: InputMaybe<Scalars['String']>;
  lastName: InputMaybe<Scalars['String']>;
  phoneNumber: InputMaybe<Scalars['String']>;
};

/**
 * A contact request describes a request from the guest to get the host's contact
 * information for a given accommodation and stay period.
 */
export type ContactRequest = {
  __typename?: 'ContactRequest';
  /** The contact request's date of acceptation. */
  acceptedAt: Maybe<Scalars['DateTime']>;
  /** The user who accepted the contact request if any. */
  acceptedBy: Maybe<User>;
  /** The ID of the user who accepted the contact request. */
  acceptedById: Maybe<Scalars['ID']>;
  /** The contact request's date of cancellation. */
  cancelledAt: Maybe<Scalars['DateTime']>;
  /** The user who cancelled the contact request if any. */
  cancelledBy: Maybe<User>;
  /** The ID of the user who initiated the contact request's cancellation. */
  cancelledById: Maybe<Scalars['ID']>;
  /** The contact request's date the stay would end. */
  endDate: Scalars['Date'];
  /** The contact request's end reason. */
  endReason: Maybe<Scalars['String']>;
  /** The contact request's id. */
  id: Scalars['ID'];
  /** The contact request's date of creation. */
  insertedAt: Scalars['DateTime'];
  /** The contact request's price. */
  price: Price;
  /** The contact request's private end reason. */
  privateEndReason: Maybe<Scalars['String']>;
  /** The contact request's date of rejection by the host. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The user who rejected the contact request if any. */
  rejectedBy: Maybe<User>;
  /** The ID of the user who initiated the rejection of the contact request. */
  rejectedById: Maybe<Scalars['ID']>;
  /** The contact request's date the stay would start. */
  startDate: Scalars['Date'];
  /** The contact request's status. */
  status: ContactRequestStatus;
};

/** The possible statuses for a contact request. */
export enum ContactRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CopyAccommodationInput = {
  accommodationId: Scalars['String'];
};

export type CopyAccommodationPayload = {
  __typename?: 'CopyAccommodationPayload';
  accommodation: Accommodation;
};

export type CreateAccommodationInput = {
  accommodationType: InputMaybe<AccommodationType>;
  addressLineOne: InputMaybe<Scalars['String']>;
  addressLineTwo: InputMaybe<Scalars['String']>;
  amenitiesAccessibleToGuest: InputMaybe<AmenitiesInput>;
  animals: InputMaybe<AnimalsInput>;
  area: Areas;
  availableFrom: InputMaybe<Scalars['String']>;
  bathroom: InputMaybe<BathroomInput>;
  bedLinen: InputMaybe<BedLinenInput>;
  city: InputMaybe<Scalars['String']>;
  cleaningIncluded: InputMaybe<Scalars['Boolean']>;
  comment: InputMaybe<Scalars['String']>;
  countryIsoCode: InputMaybe<Scalars['String']>;
  currency: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  dwellingSizeInSqm: InputMaybe<Scalars['Int']>;
  eligibleForHousingAssistance: InputMaybe<Scalars['Boolean']>;
  flooring: InputMaybe<FlooringInput>;
  formattedAddress: InputMaybe<Scalars['String']>;
  genderPreference: InputMaybe<GenderPreferences>;
  /** The default guest fixed fee for the room */
  guestFixedFee: InputMaybe<Scalars['Int']>;
  /** The default guest variable fee for the room */
  guestVariableFee: InputMaybe<Scalars['Float']>;
  halfBoardPossible: InputMaybe<Scalars['Boolean']>;
  headline: InputMaybe<Scalars['String']>;
  homeworkingFrequencyPreference: InputMaybe<HomeworkingFrequencies>;
  /** The default host fixed fee for the room */
  hostFixedFee: InputMaybe<Scalars['Int']>;
  /** The default host variable fee for the room */
  hostVariableFee: InputMaybe<Scalars['Float']>;
  housingType: InputMaybe<HousingType>;
  kitchenUsePreference: InputMaybe<KitchenUseFrequencies>;
  languagePreference: InputMaybe<LanguagePreferences>;
  latitude: InputMaybe<Scalars['Float']>;
  longitude: InputMaybe<Scalars['Float']>;
  numberOfBedrooms: InputMaybe<Scalars['Int']>;
  numberOfRoomsAccessibleToGuest: InputMaybe<Scalars['Int']>;
  numberOfWindowsInRoom: InputMaybe<Scalars['Int']>;
  postalCode: InputMaybe<Scalars['String']>;
  priceInCents: InputMaybe<Scalars['Int']>;
  privateRooms: InputMaybe<PrivateRoomsInput>;
  providedEquipment: InputMaybe<EquipmentInput>;
  rentDuration: InputMaybe<RentDurationInput>;
  roomAvailable: InputMaybe<Scalars['Boolean']>;
  roomBedding: InputMaybe<Scalars['String']>;
  roomFurniture: InputMaybe<FurnitureInput>;
  roomSizeInSqm: InputMaybe<Scalars['Int']>;
  roomStorage: InputMaybe<StorageInput>;
  roomWindowType: InputMaybe<Scalars['String']>;
  roomWithLockAndKeys: InputMaybe<Scalars['Boolean']>;
  roomsAccessibleToGuest: InputMaybe<RoomsInput>;
  sharedAreaSizeInSqm: InputMaybe<Scalars['Int']>;
  subheading: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type CreateAccommodationPayload = {
  __typename?: 'CreateAccommodationPayload';
  accommodation: Accommodation;
};

export type CreateAccountInput = {
  ownerId: Scalars['ID'];
};

export type CreateAccountPayload = {
  __typename?: 'CreateAccountPayload';
  account: Account;
};

export type CreateActivityInput = {
  /**
   * This is the list of names of categories the activity is linked to.
   * If provided, it must be the exhaustive list of category names.
   */
  categories: InputMaybe<Array<Scalars['String']>>;
  class: InputMaybe<ActivityClasses>;
  description: Scalars['String'];
  /** Duration in minutes */
  duration: Scalars['Int'];
  headline: Scalars['String'];
  location: InputMaybe<Scalars['String']>;
  maxAttendees: Scalars['Int'];
  mobileExclusive: Scalars['Boolean'];
  name: Scalars['String'];
  organizerId: InputMaybe<Scalars['ID']>;
  organizerName: InputMaybe<Scalars['String']>;
  picture: PictureInput;
  price: ActivityPriceInput;
  publicationTime: InputMaybe<Scalars['NaiveDateTime']>;
  scene: ActivitySceneTypes;
  startTime: Scalars['NaiveDateTime'];
  timezone: Scalars['String'];
  type: ActivityTypes;
};

export type CreateActivityPayload = {
  __typename?: 'CreateActivityPayload';
  activity: Activity;
};

export type CreateBookingInput = {
  addressLine1: Scalars['String'];
  addressLine2: Scalars['String'];
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  currency: Scalars['String'];
  description: Scalars['String'];
  endDate: Scalars['Date'];
  guestFixedFee: Scalars['Int'];
  guestId: Scalars['ID'];
  hostId: Scalars['ID'];
  hostVariableFee: Scalars['Float'];
  introductionMessage: Scalars['String'];
  postalCode: Scalars['String'];
  priceInCents: Scalars['Int'];
  roomId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type CreateBookingPayload = {
  __typename?: 'CreateBookingPayload';
  booking: Booking;
};

export type CreateBookingReportInput = {
  bookingId: Scalars['ID'];
  comment: InputMaybe<Scalars['String']>;
  couldHaveBeenPrevented: InputMaybe<Scalars['Boolean']>;
  endReason: InputMaybe<BookingEndReasons>;
  endTriggeredBy: InputMaybe<Scalars['ID']>;
  guestRehoused: InputMaybe<Scalars['Boolean']>;
  hostDesiredRetention: InputMaybe<Scalars['Boolean']>;
  hostHasNewGuest: InputMaybe<Scalars['Boolean']>;
  hostStillRenting: InputMaybe<Scalars['Boolean']>;
  issueWithHost: InputMaybe<IssuesWithHost>;
  noticeGiven: InputMaybe<Scalars['Boolean']>;
  topHost: InputMaybe<Scalars['Boolean']>;
};

export type CreateBookingReportPayload = {
  __typename?: 'CreateBookingReportPayload';
  bookingReport: BookingReport;
};

export type CreateCategoryInput = {
  name: Scalars['String'];
};

export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category: Category;
};

export type CreateCharterInput = {
  accommodationId: Scalars['String'];
  additionalElements: InputMaybe<Array<InputMaybe<CharterElementInput>>>;
  comment: InputMaybe<Scalars['String']>;
  deliveries: InputMaybe<Scalars['Boolean']>;
  drinkAlcohol: InputMaybe<Scalars['Boolean']>;
  inviteFamily: InputMaybe<Scalars['Boolean']>;
  inviteFriends: InputMaybe<Scalars['Boolean']>;
  inviteFriendsForASleepover: InputMaybe<Scalars['Boolean']>;
  invitePartner: InputMaybe<Scalars['Boolean']>;
  smoke: InputMaybe<Scalars['Boolean']>;
};

export type CreateCharterPayload = {
  __typename?: 'CreateCharterPayload';
  charter: Charter;
};

export type CreateCustomerInput = {
  userId: Scalars['String'];
};

export type CreateCustomerPayload = {
  __typename?: 'CreateCustomerPayload';
  customer: Customer;
};

export type CreateDiscussionGroupInput = {
  /**
   * This is the list of names of categories the discussion group is linked to.
   * If provided, it must be the exhaustive list of category names.
   */
  categories: InputMaybe<Array<Scalars['String']>>;
  coverPicture: PictureInput;
  description: Scalars['String'];
  name: Scalars['String'];
};

export type CreateDiscussionGroupPayload = {
  __typename?: 'CreateDiscussionGroupPayload';
  discussionGroup: DiscussionGroup;
};

export type CreateDiscussionGroupThreadInput = {
  /** The first message body */
  body: Scalars['String'];
  /** The discussion group ID */
  discussionGroupId: Scalars['UUID'];
  /** The thread hashtags */
  hashtags: InputMaybe<Array<Scalars['String']>>;
  /** The thread name */
  name: Scalars['String'];
};

export type CreateDiscussionGroupThreadPayload = {
  __typename?: 'CreateDiscussionGroupThreadPayload';
  thread: Thread;
};

export type CreatePlaceInput = {
  /** The name of the place to create and search details for. */
  name: InputMaybe<Scalars['String']>;
  /**
   * The search expression of the place to search details for. It will be
   * used a its name unless a name to use is specified.
   */
  search: Scalars['String'];
};

export type CreatePlacePayload = {
  __typename?: 'CreatePlacePayload';
  /** The created place. */
  place: Place;
};

export type CreateRentalDiscountInput = {
  rentalId: Scalars['UUID'];
};

export type CreateRentalDiscountPayload = {
  __typename?: 'CreateRentalDiscountPayload';
  rentalDiscount: RentalDiscount;
};

export type CreateStripeAccountInput = {
  customerId: Scalars['ID'];
};

export type CreateStripeAccountPayload = {
  __typename?: 'CreateStripeAccountPayload';
  /** The updated customer with the stripe account id */
  customer: Customer;
};

export type CreateSubscriptionInput = {
  userId: Scalars['ID'];
};

export type CreateSubscriptionPayload = {
  __typename?: 'CreateSubscriptionPayload';
  subscription: ClubSubscription;
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  type: Roles;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

export type CreateUserReviewInput = {
  /** The booking's ID. */
  bookingId: InputMaybe<Scalars['ID']>;
  /** The review's comment. */
  comment: Scalars['String'];
  /** The creation date of the review */
  insertedAt: InputMaybe<Scalars['DateTime']>;
  /** The review's rating. */
  rating: Scalars['Int'];
  /** The person who got reviewed. */
  revieweeId: Scalars['ID'];
  /** The person who made the review. */
  reviewerId: Scalars['ID'];
  /** The room's ID. */
  roomId: InputMaybe<Scalars['ID']>;
};

export type CreateUserReviewPayload = {
  __typename?: 'CreateUserReviewPayload';
  /** The created review */
  userReview: UserReview;
};

/** The possible currencies. */
export enum CurrencyType {
  Col = 'COL',
  Eur = 'EUR',
  Usd = 'USD'
}

/** A person who purchases services such as a co-habitation. */
export type Customer = {
  __typename?: 'Customer';
  firstName: Scalars['String'];
  /** Whether the customer has a Stripe account. */
  hasStripeAccount: Scalars['Boolean'];
  /** The customer's id. */
  id: Scalars['ID'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  lastName: Scalars['String'];
  /** The customer's Stripe links. */
  stripeLinks: Maybe<Array<StripeLink>>;
  updatedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The customer's user. */
  user: Maybe<User>;
  userId: Scalars['ID'];
};

export type DeactivateUserInput = {
  id: Scalars['UUID'];
};

export type DeactivateUserPayload = {
  __typename?: 'DeactivateUserPayload';
  user: User;
};

export type DeleteAccommodationInput = {
  accommodationId: Scalars['String'];
};

export type DeleteAccommodationPayload = {
  __typename?: 'DeleteAccommodationPayload';
  accommodation: Accommodation;
};

export type DeleteAccommodationPicturesInput = {
  accommodationId: Scalars['String'];
  pictureIds: Array<InputMaybe<Scalars['String']>>;
};

export type DeleteAccommodationPicturesPayload = {
  __typename?: 'DeleteAccommodationPicturesPayload';
  accommodation: Accommodation;
};

export type DeleteCategoryInput = {
  id: Scalars['ID'];
};

export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  category: Category;
};

export type DeleteUserReviewInput = {
  /** The review's ID. */
  id: Scalars['ID'];
};

export type DeleteUserReviewPayload = {
  __typename?: 'DeleteUserReviewPayload';
  /** The deleted review */
  userReview: UserReview;
};

/** The desired housemate personality traits */
export enum DesiredHousematePersonalityTraits {
  ExtravertedDynamicIndependent = 'EXTRAVERTED_DYNAMIC_INDEPENDENT',
  ExtravertedEnthusiastSociable = 'EXTRAVERTED_ENTHUSIAST_SOCIABLE',
  Indifferent = 'INDIFFERENT',
  IntrovertQuietThoughtful = 'INTROVERT_QUIET_THOUGHTFUL',
  IntrovertReserved = 'INTROVERT_RESERVED'
}

/** The possible values for the desired location. */
export enum DesiredLocationOptions {
  Bordeaux = 'BORDEAUX',
  IleDeFrance = 'ILE_DE_FRANCE',
  Lyon = 'LYON',
  Other = 'OTHER',
  Paris = 'PARIS',
  ParisAndIleDeFrance = 'PARIS_AND_ILE_DE_FRANCE'
}

export type DisableRentalDiscountInput = {
  id: Scalars['UUID'];
};

export type DisableRentalDiscountPayload = {
  __typename?: 'DisableRentalDiscountPayload';
  rentalDiscount: RentalDiscount;
};

export type DisconfirmActivityAttendanceInput = {
  activityAttendanceId: Scalars['ID'];
};

export type DisconfirmActivityAttendancePayload = {
  __typename?: 'DisconfirmActivityAttendancePayload';
  activityAttendance: ActivityAttendance;
};

/** A discussion group. */
export type DiscussionGroup = {
  __typename?: 'DiscussionGroup';
  /** The time the discussion group was archived. */
  archivedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The list of categories associated to the discussion group. */
  categories: Maybe<Array<Category>>;
  /** The list of flags required to access the group */
  conditionFlags: Maybe<Array<Flag>>;
  /** The discussion group cover picture. */
  coverPicture: Picture;
  /** The discussion group description. */
  description: Scalars['String'];
  /** The discussion group id. */
  id: Scalars['UUID'];
  /** The time the discussion group was locked. */
  lockedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The discussion group name. */
  name: Scalars['String'];
  /** A paginated list of participants to the discussion group. */
  participants: UserConnection;
  /** A paginated list of threads belonging to the discussion group. */
  threads: ThreadConnection;
};


/** A discussion group. */
export type DiscussionGroupParticipantsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


/** A discussion group. */
export type DiscussionGroupThreadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ThreadsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A paginated list of discussion groups. */
export type DiscussionGroupConnection = {
  __typename?: 'DiscussionGroupConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<DiscussionGroupEdge>>>;
  pageInfo: PageInfo;
};

export type DiscussionGroupEdge = {
  __typename?: 'DiscussionGroupEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<DiscussionGroup>;
};

/** Describes available filters when listing discussion groups. */
export type DiscussionGroupFilterInput = {
  /** Returns only archived or not archived discussion groups */
  archived: InputMaybe<Scalars['Boolean']>;
  /** Filters discussion groups based on whether they're linked to at least the provided category IDs or not */
  categoryIds: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Filters discussion groups to return only the ones the participant is part of */
  participant: InputMaybe<Scalars['UUID']>;
  /** Filters discussion groups by the search expression `text`. */
  text: InputMaybe<Scalars['String']>;
  /** Filters discussion groups to return only the ones the participant is not part of */
  withoutParticipant: InputMaybe<Scalars['UUID']>;
};

export type DuplicateActivityInput = {
  /** The activity ID */
  id: Scalars['ID'];
};

export type DuplicateActivityPayload = {
  __typename?: 'DuplicateActivityPayload';
  activity: Activity;
};

/** Describes guest's desired rental duration filter. */
export type DurationFilterInput = {
  /** Operator */
  operator: InputMaybe<DurationOperator>;
  /** Value in days. */
  value: InputMaybe<Scalars['Int']>;
};

export enum DurationOperator {
  Equal = 'EQUAL',
  Less = 'LESS',
  More = 'MORE'
}

/** An entry. */
export type Entry = {
  __typename?: 'Entry';
  /** The entry amount. */
  amount: Scalars['Int'];
  /** The entry communication message. */
  communication: Maybe<Scalars['String']>;
  /** The entry event. */
  event: EntryEvents;
  /** Whether the entry is a hold or not. */
  hold: Scalars['Boolean'];
  /** The entry id. */
  id: Scalars['ID'];
  /** The creation time of the entry */
  insertedAt: Scalars['DateTime'];
  /** Linked entry ID */
  linkedEntryId: Maybe<Scalars['ID']>;
  /** The entry resource description. */
  resourceDescription: Maybe<Scalars['String']>;
  /** The entry resource ID. */
  resourceId: Scalars['ID'];
  /** The entry resource type. */
  resourceType: Scalars['String'];
  /** The entry sequence number. */
  sequenceNumber: Scalars['Int'];
  /** The entry type. */
  type: EntryTypes;
};

/** A paginated list of entries. */
export type EntryConnection = {
  __typename?: 'EntryConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<EntryEdge>>>;
  pageInfo: PageInfo;
};

export type EntryEdge = {
  __typename?: 'EntryEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Entry>;
};

/** The possible events linked to an entry. */
export enum EntryEvents {
  AccountCreated = 'ACCOUNT_CREATED',
  ActivityAttendanceConfirmed = 'ACTIVITY_ATTENDANCE_CONFIRMED',
  ActivityAttendanceDisconfirmed = 'ACTIVITY_ATTENDANCE_DISCONFIRMED',
  ManualOperation = 'MANUAL_OPERATION',
  UserRegisteredToActivity = 'USER_REGISTERED_TO_ACTIVITY',
  UserUnregisteredFromActivity = 'USER_UNREGISTERED_FROM_ACTIVITY'
}

/** The possible types of an entry. */
export enum EntryTypes {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** Describes accommodation's equipment filter. */
export type EquipmentFilterInput = {
  available: Scalars['Boolean'];
  name: EquipmentType;
};

export type EquipmentInput = {
  bathroomLinen: InputMaybe<Scalars['Boolean']>;
  bedLinen: InputMaybe<Scalars['Boolean']>;
};

/** The available equipment for an accommodation. */
export enum EquipmentType {
  BathroomLinen = 'BATHROOM_LINEN',
  BedLinen = 'BED_LINEN',
  Dishwasher = 'DISHWASHER',
  Dryer = 'DRYER',
  Elevator = 'ELEVATOR',
  Fridge = 'FRIDGE',
  Internet = 'INTERNET',
  MicrowaveOven = 'MICROWAVE_OVEN',
  Oven = 'OVEN',
  Tv = 'TV',
  WashingMachine = 'WASHING_MACHINE',
  Wifi = 'WIFI'
}

/** The possible flags */
export enum Flag {
  Colettetest = 'COLETTETEST',
  Communityaccepted = 'COMMUNITYACCEPTED',
  Communityrejected = 'COMMUNITYREJECTED',
  Frneighborhood77 = 'FRNEIGHBORHOOD77',
  Frneighborhood78 = 'FRNEIGHBORHOOD78',
  Frneighborhood91 = 'FRNEIGHBORHOOD91',
  Frneighborhood92 = 'FRNEIGHBORHOOD92',
  Frneighborhood93 = 'FRNEIGHBORHOOD93',
  Frneighborhood94 = 'FRNEIGHBORHOOD94',
  Frneighborhood95 = 'FRNEIGHBORHOOD95',
  Initial = 'INITIAL',
  Parisneighborhood1 = 'PARISNEIGHBORHOOD1',
  Parisneighborhood2 = 'PARISNEIGHBORHOOD2',
  Parisneighborhood3 = 'PARISNEIGHBORHOOD3',
  Parisneighborhood4 = 'PARISNEIGHBORHOOD4',
  Parisneighborhood5 = 'PARISNEIGHBORHOOD5',
  Parisneighborhood6 = 'PARISNEIGHBORHOOD6',
  Parisneighborhood7 = 'PARISNEIGHBORHOOD7',
  Parisneighborhood8 = 'PARISNEIGHBORHOOD8',
  Parisneighborhood9 = 'PARISNEIGHBORHOOD9',
  Parisneighborhood10 = 'PARISNEIGHBORHOOD10',
  Parisneighborhood11 = 'PARISNEIGHBORHOOD11',
  Parisneighborhood12 = 'PARISNEIGHBORHOOD12',
  Parisneighborhood13 = 'PARISNEIGHBORHOOD13',
  Parisneighborhood14 = 'PARISNEIGHBORHOOD14',
  Parisneighborhood15 = 'PARISNEIGHBORHOOD15',
  Parisneighborhood16 = 'PARISNEIGHBORHOOD16',
  Parisneighborhood17 = 'PARISNEIGHBORHOOD17',
  Parisneighborhood18 = 'PARISNEIGHBORHOOD18',
  Parisneighborhood19 = 'PARISNEIGHBORHOOD19',
  Parisneighborhood20 = 'PARISNEIGHBORHOOD20'
}

/** A room's flooring. */
export type Flooring = {
  __typename?: 'Flooring';
  hasCarpet: Scalars['Boolean'];
  hasParquet: Scalars['Boolean'];
  hasTiles: Scalars['Boolean'];
  other: Maybe<Scalars['String']>;
};

export type FlooringInput = {
  carpet: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
  parquet: InputMaybe<Scalars['Boolean']>;
  tiles: InputMaybe<Scalars['Boolean']>;
};

/** The possible follow-up statuses */
export enum FollowUpStatus {
  FirstContact = 'FIRST_CONTACT',
  FirstReminder = 'FIRST_REMINDER',
  LastChance = 'LAST_CHANCE',
  SecondReminder = 'SECOND_REMINDER'
}

/** A room's furniture. */
export type Furniture = {
  __typename?: 'Furniture';
  hasBedsideTable: Scalars['Boolean'];
  hasChair: Scalars['Boolean'];
  hasDesk: Scalars['Boolean'];
  hasLight: Scalars['Boolean'];
};

export type FurnitureInput = {
  bedsideTable: InputMaybe<Scalars['Boolean']>;
  chair: InputMaybe<Scalars['Boolean']>;
  desk: InputMaybe<Scalars['Boolean']>;
  light: InputMaybe<Scalars['Boolean']>;
};

/** The possible types for genders. */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/** The possible gender preferences. */
export enum GenderPreferences {
  Female = 'FEMALE',
  Indifferent = 'INDIFFERENT',
  Male = 'MALE'
}

/** A gift. */
export type Gift = {
  __typename?: 'Gift';
  amountOff: Maybe<Price>;
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  code: Scalars['String'];
  deletedAt: Maybe<Scalars['DateTime']>;
  deliverAt: Maybe<Scalars['DateTime']>;
  deliveredAt: Maybe<Scalars['DateTime']>;
  duration: GiftDuration;
  durationInMonths: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  message: Maybe<Scalars['String']>;
  name: Scalars['String'];
  percentOff: Maybe<Scalars['Float']>;
  product: Product;
  recipientEmail: Scalars['String'];
  recipientName: Scalars['String'];
  redeemBy: Maybe<Scalars['DateTime']>;
  redeemedAt: Maybe<Scalars['DateTime']>;
  redeemedBy: Maybe<User>;
};

/** A paginated list of gifts. */
export type GiftConnection = {
  __typename?: 'GiftConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<GiftEdge>>>;
  pageInfo: PageInfo;
};

/** The possible gift durations */
export enum GiftDuration {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

export type GiftEdge = {
  __typename?: 'GiftEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Gift>;
};

/** Available filters when listing gifts. */
export type GiftFilterInput = {
  /** Filters gifts by whether they have been delivered or not. */
  delivered: InputMaybe<Scalars['Boolean']>;
  /** Filters gift by the duration in months. */
  durationInMonths: InputMaybe<Scalars['Int']>;
  /** Filters gifts by product ID. */
  productId: InputMaybe<Scalars['ID']>;
  /** Filters gifts by whether they have been redeemed or not. */
  redeemed: InputMaybe<Scalars['Boolean']>;
  /** Filters gifts by redeemed_by (user id). */
  redeemedBy: InputMaybe<Scalars['ID']>;
  /** Filters gift by a search expression. */
  search: InputMaybe<Scalars['String']>;
};

export type GroupByStringMetricsEntry = {
  __typename?: 'GroupByStringMetricsEntry';
  count: Maybe<Scalars['Int']>;
  value: Maybe<Scalars['String']>;
};

/** The homeworking frequencies. */
export enum HomeworkingFrequencies {
  NotAtAll = 'NOT_AT_ALL',
  NoLimits = 'NO_LIMITS',
  OnceOrTwicePerWeek = 'ONCE_OR_TWICE_PER_WEEK'
}

/** A host is a person who accepts guests to stay in an accommodation they own. */
export type Host = Role & {
  __typename?: 'Host';
  /** The ID of the host. */
  id: Scalars['ID'];
  photographerRequestDispatchDelayInSeconds: Maybe<Scalars['Int']>;
  photographerRequestSentAt: Maybe<Scalars['DateTime']>;
  photographerRequestedAt: Maybe<Scalars['DateTime']>;
};

export type HostTransfer = {
  __typename?: 'HostTransfer';
  amount: Scalars['Int'];
  bookingId: Scalars['ID'];
  currency: Scalars['String'];
  description: Maybe<Scalars['String']>;
  expectedArrivalAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  rentalId: Scalars['ID'];
};

/** A paginated list of host transfers. */
export type HostTransferConnection = {
  __typename?: 'HostTransferConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<HostTransferEdge>>>;
  pageInfo: PageInfo;
};

export type HostTransferEdge = {
  __typename?: 'HostTransferEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<HostTransfer>;
};

/** The list of hosted people by a user */
export type HostedPeople = {
  __typename?: 'HostedPeople';
  cohabitant: Scalars['Boolean'];
  family: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  other: Maybe<Scalars['String']>;
  parent: Scalars['Boolean'];
};

/** Input for hosted people */
export type HostedPeopleInput = {
  cohabitant: InputMaybe<Scalars['Boolean']>;
  family: InputMaybe<Scalars['Boolean']>;
  friend: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
  parent: InputMaybe<Scalars['Boolean']>;
};

export enum HouseShareStatus {
  None = 'NONE',
  Ongoing = 'ONGOING',
  Ready = 'READY'
}

/** The house-sharing expectations. */
export enum HouseSharingExpectations {
  CasualInteraction = 'CASUAL_INTERACTION',
  NoneBusyLifestyle = 'NONE_BUSY_LIFESTYLE',
  RegularInteraction = 'REGULAR_INTERACTION'
}

/** The house-sharing reasons. */
export enum HouseSharingReasons {
  AffordableSolution = 'AFFORDABLE_SOLUTION',
  ComfortAndReassurance = 'COMFORT_AND_REASSURANCE',
  FindAStudent = 'FIND_A_STUDENT',
  FindAYoungProfessional = 'FIND_A_YOUNG_PROFESSIONAL'
}

/** The possible housing types */
export enum HousingType {
  Flat = 'FLAT',
  House = 'HOUSE'
}

/**
 * An identity is a set of data points and resources related to and owned by
 * the user.
 */
export type Identity = {
  __typename?: 'Identity';
  /** The ID of the identity. */
  id: Maybe<Scalars['ID']>;
  /** The time at which the user's identity verification has been requested. */
  verificationRequestedAt: Maybe<Scalars['DateTime']>;
  /** Whether the user's identity has been verified or not. */
  verified: Scalars['Boolean'];
  /** The time at which the user's identity has been verified. */
  verifiedAt: Maybe<Scalars['DateTime']>;
};

export type ImpersonateUserWithMagicLinkInput = {
  userId: Scalars['String'];
};

export type ImpersonateUserWithMagicLinkPayload = {
  __typename?: 'ImpersonateUserWithMagicLinkPayload';
  user: User;
};

export type InvalidateAccommodationProfessionalPicturesInput = {
  id: Scalars['String'];
};

export type InvalidateAccommodationProfessionalPicturesPayload = {
  __typename?: 'InvalidateAccommodationProfessionalPicturesPayload';
  accommodation: Accommodation;
};

export enum IssuesWithHost {
  BadBehavior = 'BAD_BEHAVIOR',
  HealthIssues = 'HEALTH_ISSUES',
  NonEligibleRoom = 'NON_ELIGIBLE_ROOM',
  Reliability = 'RELIABILITY',
  UnacceptableBehavior = 'UNACCEPTABLE_BEHAVIOR',
  ViolateColettePolicy = 'VIOLATE_COLETTE_POLICY'
}

/** A room's kitchen. */
export type Kitchen = {
  __typename?: 'Kitchen';
  isAvailable: Scalars['Boolean'];
};

/** The possible kitchen use frequencies. */
export enum KitchenUseFrequencies {
  NoLimits = 'NO_LIMITS',
  TimeLimited = 'TIME_LIMITED',
  VeryRestricted = 'VERY_RESTRICTED'
}

/** The possible language preferences. */
export enum LanguagePreferences {
  ForeignLanguage = 'FOREIGN_LANGUAGE',
  French = 'FRENCH',
  Indifferent = 'INDIFFERENT'
}

/** A list of languages */
export type Languages = {
  __typename?: 'Languages';
  english: Scalars['Boolean'];
  french: Scalars['Boolean'];
  german: Scalars['Boolean'];
  italian: Scalars['Boolean'];
  other: Maybe<Scalars['String']>;
  portuguese: Scalars['Boolean'];
  spanish: Scalars['Boolean'];
};

/** Input for languages */
export type LanguagesInput = {
  english: InputMaybe<Scalars['Boolean']>;
  french: InputMaybe<Scalars['Boolean']>;
  german: InputMaybe<Scalars['Boolean']>;
  italian: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
  portuguese: InputMaybe<Scalars['Boolean']>;
  spanish: InputMaybe<Scalars['Boolean']>;
};

/** The possible lead sources */
export enum LeadSource {
  Club = 'CLUB',
  Competitors = 'COMPETITORS',
  Content = 'CONTENT',
  Display = 'DISPLAY',
  Emailing = 'EMAILING',
  Inbound = 'INBOUND',
  Offline = 'OFFLINE',
  Outbound = 'OUTBOUND',
  Paid = 'PAID',
  PaidAcquisition = 'PAID_ACQUISITION',
  Partners = 'PARTNERS',
  Referral = 'REFERRAL',
  Search = 'SEARCH',
  SocialMedia = 'SOCIAL_MEDIA'
}

/** The possible lead source details */
export enum LeadSourceDetail {
  App = 'APP',
  BlogNewsletter = 'BLOG_NEWSLETTER',
  CompetitorsAirbnb = 'COMPETITORS_AIRBNB',
  CompetitorsGdc = 'COMPETITORS_GDC',
  CompetitorsLaCarteDesColocs = 'COMPETITORS_LA_CARTE_DES_COLOCS',
  CompetitorsLeboncoin = 'COMPETITORS_LEBONCOIN',
  CompetitorsRoomlala = 'COMPETITORS_ROOMLALA',
  ExhibitionEvent = 'EXHIBITION_EVENT',
  IncomingCall = 'INCOMING_CALL',
  Listing = 'LISTING',
  Others = 'OTHERS',
  PressRelations = 'PRESS_RELATIONS',
  SocialMedia = 'SOCIAL_MEDIA'
}

export type LikeMessageInput = {
  /** The message ID */
  id: Scalars['UUID'];
};

export type LikeMessagePayload = {
  __typename?: 'LikeMessagePayload';
  /** The message */
  message: Message;
};

/** A location. */
export type Location = {
  __typename?: 'Location';
  addressLineOne: Maybe<Scalars['String']>;
  addressLineTwo: Maybe<Scalars['String']>;
  addressSupplement: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  countryIsoCode: Maybe<Scalars['String']>;
  formattedAddress: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  postalCode: Maybe<Scalars['String']>;
};

/** Input for a location. */
export type LocationInput = {
  addressLineOne: InputMaybe<Scalars['String']>;
  addressLineTwo: InputMaybe<Scalars['String']>;
  addressSupplement: InputMaybe<Scalars['String']>;
  city: InputMaybe<Scalars['String']>;
  countryIsoCode: InputMaybe<Scalars['String']>;
  formattedAddress: InputMaybe<Scalars['String']>;
  latitude: InputMaybe<Scalars['Float']>;
  longitude: InputMaybe<Scalars['Float']>;
  postalCode: InputMaybe<Scalars['String']>;
};

/** A room's lock. */
export type Lock = {
  __typename?: 'Lock';
  isAvailable: Scalars['Boolean'];
};

export type LockDiscussionGroupInput = {
  /** The discussion group ID */
  id: Scalars['UUID'];
};

export type LockDiscussionGroupPayload = {
  __typename?: 'LockDiscussionGroupPayload';
  /** The locked discussion group. */
  discussionGroup: DiscussionGroup;
};

export type LockThreadInput = {
  /** The thread ID */
  id: Scalars['UUID'];
};

export type LockThreadPayload = {
  __typename?: 'LockThreadPayload';
  thread: Thread;
};

export type MakeUserAmbassadorInput = {
  id: Scalars['ID'];
};

export type MakeUserAmbassadorPayload = {
  __typename?: 'MakeUserAmbassadorPayload';
  user: User;
};

/** The possible marital statuses. */
export enum MaritalStatuses {
  Couple = 'COUPLE',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Single = 'SINGLE',
  Unknown = 'UNKNOWN',
  Widower = 'WIDOWER'
}

/** The possible member types for a user. */
export enum MemberTypes {
  Insider = 'INSIDER',
  Outsider = 'OUTSIDER'
}

/** A message */
export type Message = {
  __typename?: 'Message';
  /** The message body */
  body: Scalars['String'];
  /** The message deletion time */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Indicates whether or not the message was flagged for inappropriate content */
  flagged: Maybe<Scalars['Boolean']>;
  /** The time the message was flagged for inappropriate content */
  flaggedAt: Maybe<Scalars['DateTime']>;
  /** The message id */
  id: Scalars['UUID'];
  /** The message creation time */
  insertedAt: Scalars['DateTime'];
  /** The message like count */
  likeCount: Scalars['Int'];
  /** Whether the message has been liked by the viewer or not */
  liked: Scalars['Boolean'];
  /** The message moderation time */
  moderatedAt: Maybe<Scalars['DateTime']>;
  /** The message moderation result */
  moderationResult: Maybe<ModerationResult>;
  /** Whether the message has previously been read by the viewer or not */
  new: Scalars['Boolean'];
  /** The message pictures */
  pictures: Maybe<Array<Picture>>;
  /** Whether the message has been read by all the thread participants or not */
  read: Scalars['Boolean'];
  /** The message redaction time */
  redactedAt: Maybe<Scalars['DateTime']>;
  /** The message redaction reason */
  redactionReason: Maybe<RedactionReason>;
  /** The message report count */
  reportCount: Scalars['Int'];
  /** Whether the message has been reported by the viewer or not */
  reported: Scalars['Boolean'];
  /** The message sender */
  sender: User;
  /** The message thread */
  thread: Thread;
};

/** A paginated list of messages. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<MessageEdge>>>;
  pageInfo: PageInfo;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Message>;
};

/** The metrics */
export type Metrics = {
  __typename?: 'Metrics';
  bookings: Maybe<Array<Maybe<MetricsEntry>>>;
  cancelledBookings: Maybe<Array<Maybe<MetricsEntry>>>;
  guests: Maybe<Array<Maybe<MetricsEntry>>>;
  hosts: Maybe<Array<Maybe<MetricsEntry>>>;
  hostsByLeadSource: Maybe<Array<Maybe<GroupByStringMetricsEntry>>>;
  hostsByRegistrationChannel: Maybe<Array<Maybe<GroupByStringMetricsEntry>>>;
  paidBookings: Maybe<Array<Maybe<MetricsEntry>>>;
  rooms: Maybe<Array<Maybe<MetricsEntry>>>;
  terminatedBookings: Maybe<Array<Maybe<MetricsEntry>>>;
  users: Maybe<Array<Maybe<MetricsEntry>>>;
};

/** A metric entry */
export type MetricsEntry = {
  __typename?: 'MetricsEntry';
  count: Maybe<Scalars['Int']>;
  date: Maybe<Scalars['Date']>;
};

/** The possible moderation results of a message */
export type ModerationResult = {
  __typename?: 'ModerationResult';
  hate: Scalars['Float'];
  rude: Scalars['Float'];
  selfHarm: Scalars['Float'];
  sexual: Scalars['Float'];
  violence: Scalars['Float'];
};

/** The possible values for the nationality. */
export enum Nationalities {
  Afghan = 'AFGHAN',
  Albanian = 'ALBANIAN',
  Algerian = 'ALGERIAN',
  American = 'AMERICAN',
  AmericanSamoan = 'AMERICAN_SAMOAN',
  Andorran = 'ANDORRAN',
  Angolan = 'ANGOLAN',
  Anguillian = 'ANGUILLIAN',
  AntiguanBarbudan = 'ANTIGUAN_BARBUDAN',
  Argentinean = 'ARGENTINEAN',
  Armenian = 'ARMENIAN',
  Aruban = 'ARUBAN',
  Australian = 'AUSTRALIAN',
  Austrian = 'AUSTRIAN',
  Azerbaijani = 'AZERBAIJANI',
  Bahamian = 'BAHAMIAN',
  Bahraini = 'BAHRAINI',
  Bangladeshi = 'BANGLADESHI',
  Barbadian = 'BARBADIAN',
  Belarusian = 'BELARUSIAN',
  Belgian = 'BELGIAN',
  Belizean = 'BELIZEAN',
  Beninese = 'BENINESE',
  Bermudian = 'BERMUDIAN',
  Bhutanese = 'BHUTANESE',
  Bolivian = 'BOLIVIAN',
  BosnianHerzegovinian = 'BOSNIAN_HERZEGOVINIAN',
  Brazilian = 'BRAZILIAN',
  British = 'BRITISH',
  Bruneian = 'BRUNEIAN',
  Bulgarian = 'BULGARIAN',
  Burkinabe = 'BURKINABE',
  Burundian = 'BURUNDIAN',
  Cambodian = 'CAMBODIAN',
  Cameroonian = 'CAMEROONIAN',
  Canadian = 'CANADIAN',
  CapeVerdian = 'CAPE_VERDIAN',
  Caymanian = 'CAYMANIAN',
  CentralAfrican = 'CENTRAL_AFRICAN',
  Chadian = 'CHADIAN',
  ChannelIslander = 'CHANNEL_ISLANDER',
  Chilean = 'CHILEAN',
  Chinese = 'CHINESE',
  ChristmasIsland = 'CHRISTMAS_ISLAND',
  CocosIslander = 'COCOS_ISLANDER',
  Colombian = 'COLOMBIAN',
  Comoran = 'COMORAN',
  Congolese = 'CONGOLESE',
  CookIslander = 'COOK_ISLANDER',
  CostaRican = 'COSTA_RICAN',
  Croatian = 'CROATIAN',
  Cuban = 'CUBAN',
  Cypriot = 'CYPRIOT',
  Czech = 'CZECH',
  Danish = 'DANISH',
  Djibouti = 'DJIBOUTI',
  Dominican = 'DOMINICAN',
  Dutch = 'DUTCH',
  EastTimorese = 'EAST_TIMORESE',
  Ecuadorean = 'ECUADOREAN',
  Egyptian = 'EGYPTIAN',
  Emirian = 'EMIRIAN',
  EquatorialGuinean = 'EQUATORIAL_GUINEAN',
  Eritrean = 'ERITREAN',
  Estonian = 'ESTONIAN',
  Ethiopian = 'ETHIOPIAN',
  FalklandIslander = 'FALKLAND_ISLANDER',
  Faroese = 'FAROESE',
  Fijian = 'FIJIAN',
  Filipino = 'FILIPINO',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  FrenchGuianan = 'FRENCH_GUIANAN',
  FrenchPolynesian = 'FRENCH_POLYNESIAN',
  Gabonese = 'GABONESE',
  Gambian = 'GAMBIAN',
  Georgian = 'GEORGIAN',
  German = 'GERMAN',
  Ghanaian = 'GHANAIAN',
  Gibraltar = 'GIBRALTAR',
  Greek = 'GREEK',
  Greenlandic = 'GREENLANDIC',
  Grenadian = 'GRENADIAN',
  Guadeloupian = 'GUADELOUPIAN',
  Guamanian = 'GUAMANIAN',
  Guatemalan = 'GUATEMALAN',
  Guinean = 'GUINEAN',
  GuineaBissauan = 'GUINEA_BISSAUAN',
  Guyanese = 'GUYANESE',
  Haitian = 'HAITIAN',
  HeardAndMcDonaldIslander = 'HEARD_AND_MC_DONALD_ISLANDER',
  Honduran = 'HONDURAN',
  HongKongese = 'HONG_KONGESE',
  Hungarian = 'HUNGARIAN',
  Icelander = 'ICELANDER',
  Indian = 'INDIAN',
  Indonesian = 'INDONESIAN',
  Iranian = 'IRANIAN',
  Iraqi = 'IRAQI',
  Irish = 'IRISH',
  Israeli = 'ISRAELI',
  Italian = 'ITALIAN',
  Ivorian = 'IVORIAN',
  IKiribati = 'I_KIRIBATI',
  Jamaican = 'JAMAICAN',
  Japanese = 'JAPANESE',
  Jordanian = 'JORDANIAN',
  Kazakhstani = 'KAZAKHSTANI',
  Kenyan = 'KENYAN',
  Kirghiz = 'KIRGHIZ',
  KittianAndNevisian = 'KITTIAN_AND_NEVISIAN',
  Kuwaiti = 'KUWAITI',
  Laotian = 'LAOTIAN',
  Latvian = 'LATVIAN',
  Lebanese = 'LEBANESE',
  Liberian = 'LIBERIAN',
  Libyan = 'LIBYAN',
  Liechtensteiner = 'LIECHTENSTEINER',
  Lithuanian = 'LITHUANIAN',
  Luxembourger = 'LUXEMBOURGER',
  Macedonian = 'MACEDONIAN',
  Malagasy = 'MALAGASY',
  Malawian = 'MALAWIAN',
  Malaysian = 'MALAYSIAN',
  Maldivan = 'MALDIVAN',
  Malian = 'MALIAN',
  Maltese = 'MALTESE',
  Manx = 'MANX',
  Marshallese = 'MARSHALLESE',
  Mauritanian = 'MAURITANIAN',
  Mauritian = 'MAURITIAN',
  Mexican = 'MEXICAN',
  Micronesian = 'MICRONESIAN',
  Moldovan = 'MOLDOVAN',
  Monegasque = 'MONEGASQUE',
  Mongolian = 'MONGOLIAN',
  Montenegrin = 'MONTENEGRIN',
  Montserratian = 'MONTSERRATIAN',
  Moroccan = 'MOROCCAN',
  Mosotho = 'MOSOTHO',
  Motswana = 'MOTSWANA',
  Mozambican = 'MOZAMBICAN',
  Myanmarian = 'MYANMARIAN',
  Namibian = 'NAMIBIAN',
  Nauruan = 'NAURUAN',
  Nepalese = 'NEPALESE',
  NewCaledonian = 'NEW_CALEDONIAN',
  NewZealander = 'NEW_ZEALANDER',
  Nicaraguan = 'NICARAGUAN',
  Nigerian = 'NIGERIAN',
  Niuean = 'NIUEAN',
  NiVanuatu = 'NI_VANUATU',
  NorfolkIslander = 'NORFOLK_ISLANDER',
  NorthKorean = 'NORTH_KOREAN',
  Norwegian = 'NORWEGIAN',
  Omani = 'OMANI',
  Pakistani = 'PAKISTANI',
  Palauan = 'PALAUAN',
  Palestinian = 'PALESTINIAN',
  Panamanian = 'PANAMANIAN',
  PapuaNewGuinean = 'PAPUA_NEW_GUINEAN',
  Paraguayan = 'PARAGUAYAN',
  Peruvian = 'PERUVIAN',
  PitcairnIslander = 'PITCAIRN_ISLANDER',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  PuertoRican = 'PUERTO_RICAN',
  Qatari = 'QATARI',
  Romanian = 'ROMANIAN',
  Russian = 'RUSSIAN',
  Rwandan = 'RWANDAN',
  Sahrawi = 'SAHRAWI',
  SaintBarthelemyIslander = 'SAINT_BARTHELEMY_ISLANDER',
  SaintHelenian = 'SAINT_HELENIAN',
  SaintLucian = 'SAINT_LUCIAN',
  SaintMartinIslander = 'SAINT_MARTIN_ISLANDER',
  SaintVincentian = 'SAINT_VINCENTIAN',
  Salvadoran = 'SALVADORAN',
  Sammarinese = 'SAMMARINESE',
  Samoan = 'SAMOAN',
  SaoTomean = 'SAO_TOMEAN',
  SaudiArabian = 'SAUDI_ARABIAN',
  Senegalese = 'SENEGALESE',
  Serbian = 'SERBIAN',
  Seychellois = 'SEYCHELLOIS',
  SierraLeonean = 'SIERRA_LEONEAN',
  Singaporean = 'SINGAPOREAN',
  Slovak = 'SLOVAK',
  Slovene = 'SLOVENE',
  SolomonIslander = 'SOLOMON_ISLANDER',
  Somali = 'SOMALI',
  SouthAfrican = 'SOUTH_AFRICAN',
  SouthGeorgiaAndTheSouthSandwichIslander = 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDER',
  SouthKorean = 'SOUTH_KOREAN',
  SouthSudanese = 'SOUTH_SUDANESE',
  Spanish = 'SPANISH',
  SriLankan = 'SRI_LANKAN',
  Sudanese = 'SUDANESE',
  Surinamer = 'SURINAMER',
  Swazi = 'SWAZI',
  Swedish = 'SWEDISH',
  Swiss = 'SWISS',
  Syrian = 'SYRIAN',
  Tadzhik = 'TADZHIK',
  Taiwanese = 'TAIWANESE',
  Tanzanian = 'TANZANIAN',
  Thai = 'THAI',
  Togolese = 'TOGOLESE',
  Tokelauan = 'TOKELAUAN',
  Tongan = 'TONGAN',
  Trinidadian = 'TRINIDADIAN',
  Tunisian = 'TUNISIAN',
  Turkish = 'TURKISH',
  Turkmen = 'TURKMEN',
  TurksAndCaicosIslander = 'TURKS_AND_CAICOS_ISLANDER',
  Tuvaluan = 'TUVALUAN',
  Ugandan = 'UGANDAN',
  Ukrainian = 'UKRAINIAN',
  Uruguayan = 'URUGUAYAN',
  Uzbekistani = 'UZBEKISTANI',
  Venezuelan = 'VENEZUELAN',
  Vietnamese = 'VIETNAMESE',
  VirginIslander = 'VIRGIN_ISLANDER',
  WallisAndFutunaIslander = 'WALLIS_AND_FUTUNA_ISLANDER',
  Yemeni = 'YEMENI',
  Zambian = 'ZAMBIAN',
  Zimbabwean = 'ZIMBABWEAN'
}

export type OnboardUserInput = {
  about: InputMaybe<Scalars['String']>;
  aboutSecondPhoneNumber: InputMaybe<Scalars['String']>;
  accessToCommonAreasGiven: InputMaybe<Scalars['Boolean']>;
  allChargesIncludedPolicyAccepted: InputMaybe<Scalars['Boolean']>;
  alreadyHouseShared: InputMaybe<Scalars['Boolean']>;
  alreadyRentedARoom: InputMaybe<Scalars['Boolean']>;
  availableRoomCount: InputMaybe<Scalars['Int']>;
  birthdate: InputMaybe<Scalars['Date']>;
  budgetCurrency: InputMaybe<Scalars['String']>;
  budgetInCents: InputMaybe<Scalars['Int']>;
  cleanAndTidyFlat: InputMaybe<Scalars['Boolean']>;
  cleanlinessPreference: InputMaybe<CleanlinessPreferences>;
  coletteContractAccepted: InputMaybe<Scalars['Boolean']>;
  coletteFeesAccepted: InputMaybe<Scalars['Boolean']>;
  colettePaymentAccepted: InputMaybe<Scalars['Boolean']>;
  comment: InputMaybe<Scalars['String']>;
  concerns: InputMaybe<Scalars['String']>;
  desiredHousematePersonalityTraits: InputMaybe<DesiredHousematePersonalityTraits>;
  desiredLocation: InputMaybe<DesiredLocationOptions>;
  durationInDays: InputMaybe<Scalars['Int']>;
  email: InputMaybe<Scalars['String']>;
  emergencyContact: InputMaybe<ContactInformationInput>;
  expectationsAndWishes: InputMaybe<Scalars['String']>;
  familyUnderstandsIntergenerationalHouseSharing: InputMaybe<Scalars['Boolean']>;
  firstName: InputMaybe<Scalars['String']>;
  gender: InputMaybe<Gender>;
  genderPreference: InputMaybe<GenderPreferences>;
  goodFirstImpression: InputMaybe<Scalars['Boolean']>;
  hasDependentChildren: InputMaybe<Scalars['Boolean']>;
  hobbies: InputMaybe<Scalars['String']>;
  homeworkingFrequency: InputMaybe<HomeworkingFrequencies>;
  hostedPeople: InputMaybe<HostedPeopleInput>;
  houseSharingExpectations: InputMaybe<HouseSharingExpectations>;
  houseSharingReasons: InputMaybe<HouseSharingReasons>;
  housingAssistanceAccepted: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  idealHostDescription: InputMaybe<Scalars['String']>;
  internalAbout: InputMaybe<Scalars['String']>;
  internalHobbies: InputMaybe<Scalars['String']>;
  internalLifestyle: InputMaybe<Scalars['String']>;
  internalStudyAndWork: InputMaybe<Scalars['String']>;
  kitchenUse: InputMaybe<KitchenUseFrequencies>;
  languagePreference: InputMaybe<LanguagePreferences>;
  lastName: InputMaybe<Scalars['String']>;
  leadSource: InputMaybe<LeadSource>;
  leadSourceDetail: InputMaybe<LeadSourceDetail>;
  linkedin: InputMaybe<Scalars['String']>;
  locale: InputMaybe<Scalars['String']>;
  mainResidence: InputMaybe<Scalars['Boolean']>;
  maritalStatus: InputMaybe<MaritalStatuses>;
  nationality: InputMaybe<Nationalities>;
  numberOfChildren: InputMaybe<Scalars['Int']>;
  oldEnough: InputMaybe<Scalars['Boolean']>;
  organization: InputMaybe<Scalars['String']>;
  ownerOrTenant: InputMaybe<OwnerOrTenantOptions>;
  pastHousingExperience: InputMaybe<Scalars['String']>;
  pastRentingExperience: InputMaybe<Scalars['String']>;
  personalHistory: InputMaybe<Scalars['String']>;
  personality: InputMaybe<Scalars['String']>;
  personalityTraits: InputMaybe<PersonalityTraitsInput>;
  phoneNumber: InputMaybe<Scalars['String']>;
  placeId: InputMaybe<Scalars['ID']>;
  placeOfResidence: InputMaybe<Scalars['String']>;
  postalAddress: InputMaybe<LocationInput>;
  profileCategory: InputMaybe<Scalars['String']>;
  referencePerson: InputMaybe<ContactInformationInput>;
  roomInReadinessForGuest: InputMaybe<Scalars['Boolean']>;
  secondPhoneNumber: InputMaybe<Scalars['String']>;
  spokenLanguages: InputMaybe<LanguagesInput>;
  startDate: InputMaybe<Scalars['Date']>;
  studyAndWork: InputMaybe<Scalars['String']>;
  type: InputMaybe<Roles>;
  wellBehaving: InputMaybe<Scalars['Boolean']>;
  whyColette: InputMaybe<Scalars['String']>;
  workSituation: InputMaybe<WorkSituations>;
};

export type OnboardUserPayload = {
  __typename?: 'OnboardUserPayload';
  user: User;
};

/** Describes the possible order directions. */
export enum OrderByDirection {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** Whether the user is owner or tenant. */
export enum OwnerOrTenantOptions {
  Owner = 'OWNER',
  TenantPrivateDwelling = 'TENANT_PRIVATE_DWELLING',
  TenantSocialDwelling = 'TENANT_SOCIAL_DWELLING'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

/** A Payment */
export type Payment = {
  __typename?: 'Payment';
  amountInCents: Maybe<Scalars['Int']>;
  applicationFeeAmount: Maybe<Scalars['Int']>;
  currency: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The payment's payment dispute, if any. */
  paymentDispute: Maybe<PaymentDispute>;
  rental: Maybe<Rental>;
  rentalId: Maybe<Scalars['ID']>;
  status: Maybe<Scalars['String']>;
  stripeCreated: Maybe<Scalars['NaiveDateTime']>;
  stripeCustomerId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['NaiveDateTime']>;
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<PaymentEdge>>>;
  pageInfo: PageInfo;
};

/**
 * A dispute occurs when a customer questions your charge with their card issuer.
 * When this happens, you're given the opportunity to respond to the dispute with
 * evidence that shows that the charge is legitimate.
 */
export type PaymentDispute = {
  __typename?: 'PaymentDispute';
  /** The payment dispute's ID. */
  id: Scalars['ID'];
  /** Time at which the payment dispute was inserted. */
  insertedAt: Scalars['DateTime'];
  /** The payment dispute's payment. */
  payment: Maybe<Payment>;
  /** The price of the payment dispute. */
  price: Maybe<Price>;
  /** The payment dispute's reason. */
  reason: Maybe<PaymentDisputeReasonType>;
  /** The payment dispute's status. */
  status: Maybe<PaymentDisputeStatusType>;
  /** The payment dispute's stripe payment intent ID. */
  stripePaymentIntentId: Maybe<Scalars['String']>;
  /** Time at which the payment dispute was updated. */
  updatedAt: Scalars['DateTime'];
};

/** The possible reasons for a payment dispute. */
export enum PaymentDisputeReasonType {
  BankCannotProcess = 'BANK_CANNOT_PROCESS',
  CheckReturned = 'CHECK_RETURNED',
  CreditNotProcessed = 'CREDIT_NOT_PROCESSED',
  CustomerInitiated = 'CUSTOMER_INITIATED',
  DebitNotAuthorized = 'DEBIT_NOT_AUTHORIZED',
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  General = 'GENERAL',
  IncorrectAccountDetails = 'INCORRECT_ACCOUNT_DETAILS',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  ProductNotReceived = 'PRODUCT_NOT_RECEIVED',
  ProductUnacceptable = 'PRODUCT_UNACCEPTABLE',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  Unrecognized = 'UNRECOGNIZED'
}

/** The possible statuses for a payment dispute. */
export enum PaymentDisputeStatusType {
  ChargeRefunded = 'CHARGE_REFUNDED',
  Lost = 'LOST',
  NeedsResponse = 'NEEDS_RESPONSE',
  UnderReview = 'UNDER_REVIEW',
  WarningClosed = 'WARNING_CLOSED',
  WarningNeedsResponse = 'WARNING_NEEDS_RESPONSE',
  WarningUnderReview = 'WARNING_UNDER_REVIEW',
  Won = 'WON'
}

export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Payment>;
};

/** A payment intent. */
export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  description: Scalars['String'];
  id: Scalars['ID'];
  price: Price;
};

/** A list of personality traits */
export type PersonalityTraits = {
  __typename?: 'PersonalityTraits';
  demanding: Maybe<Scalars['Boolean']>;
  direct: Maybe<Scalars['Boolean']>;
  impulsive: Maybe<Scalars['Boolean']>;
  independent: Maybe<Scalars['Boolean']>;
  patient: Maybe<Scalars['Boolean']>;
  quiet: Maybe<Scalars['Boolean']>;
  reserved: Maybe<Scalars['Boolean']>;
  sociable: Maybe<Scalars['Boolean']>;
  thoughtful: Maybe<Scalars['Boolean']>;
};

/** The personality traits input */
export type PersonalityTraitsInput = {
  demanding: InputMaybe<Scalars['Boolean']>;
  direct: InputMaybe<Scalars['Boolean']>;
  impulsive: InputMaybe<Scalars['Boolean']>;
  independent: InputMaybe<Scalars['Boolean']>;
  patient: InputMaybe<Scalars['Boolean']>;
  quiet: InputMaybe<Scalars['Boolean']>;
  reserved: InputMaybe<Scalars['Boolean']>;
  sociable: InputMaybe<Scalars['Boolean']>;
  thoughtful: InputMaybe<Scalars['Boolean']>;
};

/** An accommodation's picture. */
export type Picture = {
  __typename?: 'Picture';
  id: Scalars['ID'];
  isFeatured: Scalars['Boolean'];
  url: Scalars['String'];
};

export type PictureInput = {
  id: InputMaybe<Scalars['UUID']>;
  url: InputMaybe<Scalars['String']>;
};

/** An establishment, geographic location, or prominent point of interest. */
export type Place = {
  __typename?: 'Place';
  /** The place's city. */
  city: Maybe<Scalars['String']>;
  /** The place's two-letter country code (ISO 3166-1 alpha-2). */
  country: Scalars['String'];
  /** The place's formatted address. */
  formattedAddress: Scalars['String'];
  /** The place's ID. */
  id: Scalars['ID'];
  /** Time at which the place was inserted. */
  insertedAt: Scalars['DateTime'];
  /** The place's latitude. */
  latitude: Scalars['Float'];
  /** The place's longitude. */
  longitude: Scalars['Float'];
  /** The place's name. */
  name: Scalars['String'];
  /** The place's postal code. */
  postalCode: Maybe<Scalars['String']>;
  /** The place's types. */
  types: Array<Scalars['String']>;
  /** Time at which the place was updated. */
  updatedAt: Scalars['DateTime'];
};

/** A paginated list of places. */
export type PlaceConnection = {
  __typename?: 'PlaceConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<PlaceEdge>>>;
  pageInfo: PageInfo;
};

export type PlaceEdge = {
  __typename?: 'PlaceEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Place>;
};

/** Describes available filters when listing onboarding places. */
export type PlacesFilterInput = {
  /**
   * Searches for `city` in place's cities in a case insensitive manner given
   * a set of operators.
   */
  city: InputMaybe<TextSearchFilterInput>;
  /** Scopes places by given country. */
  country: InputMaybe<Scalars['String']>;
  /**
   * Searches for `name` in place's names in a case insensitive manner given
   * a set of operators.
   */
  name: InputMaybe<TextSearchFilterInput>;
  /** Scopes places by given types. */
  types: InputMaybe<ArrayFilterInput>;
};

/** Describes accommodation's preference filter. */
export type PreferenceFilterInput = {
  gender: InputMaybe<GenderPreferences>;
};

/** An amount of money represented by a given currency. */
export type Price = {
  __typename?: 'Price';
  /**
   * The money amount as a non-negative integer in the smallest currency unit
   * (that is, 100 cents to describe €1.00).
   */
  amount: Scalars['Int'];
  /** Three-letter ISO Currency code. */
  currency: CurrencyType;
};

/** Describes accommodation's price filter. */
export type PriceFilterInput = {
  /** Maximum price in cents. */
  max: InputMaybe<Scalars['Int']>;
  /** Minimum price in cents. */
  min: InputMaybe<Scalars['Int']>;
};

/** The available private rooms for an accommodation. */
export enum PrivateRoomType {
  Balcony = 'BALCONY',
  Bathroom = 'BATHROOM',
  Kitchen = 'KITCHEN',
  Toilet = 'TOILET'
}

/** Describes accommodation's private rooms filter. */
export type PrivateRoomsFilterInput = {
  available: Scalars['Boolean'];
  name: PrivateRoomType;
};

export type PrivateRoomsInput = {
  balcony: InputMaybe<Scalars['Boolean']>;
  bathroom: InputMaybe<Scalars['Boolean']>;
  kitchen: InputMaybe<Scalars['Boolean']>;
  toilet: InputMaybe<Scalars['Boolean']>;
};

/** A gift. */
export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Price;
};

/** The user's profile. */
export type Profile = {
  __typename?: 'Profile';
  about: Maybe<Scalars['String']>;
  aboutSecondPhoneNumber: Maybe<Scalars['String']>;
  avatar: Maybe<Avatar>;
  becameAmbassadorAt: Maybe<Scalars['DateTime']>;
  birthdate: Maybe<Scalars['Date']>;
  completionScore: Scalars['Int'];
  gender: Maybe<Gender>;
  hobbies: Maybe<Scalars['String']>;
  /** The ID of the profile (mostly used for caching purposes) */
  id: Scalars['ID'];
  idCardOrPassportUrl: Maybe<Scalars['String']>;
  linkedin: Maybe<Scalars['String']>;
  maritalStatus: Maybe<MaritalStatuses>;
  nationality: Maybe<Nationalities>;
  numberOfChildren: Maybe<Scalars['Int']>;
  /** The user's organization. */
  organization: Maybe<Scalars['String']>;
  ownerOrTenant: Maybe<OwnerOrTenantOptions>;
  personalityTraits: Maybe<PersonalityTraits>;
  placeOfResidence: Maybe<Scalars['String']>;
  /** The user's postal address. */
  postalAddress: Maybe<Location>;
  secondPhoneNumber: Maybe<Scalars['String']>;
  spokenLanguages: Maybe<Languages>;
  studyAndWork: Maybe<Scalars['String']>;
  video: Maybe<Video>;
  visaUrl: Maybe<Scalars['String']>;
  workOrSchoolCertificateUrl: Maybe<Scalars['String']>;
  /** The user's work situation. */
  workSituation: Maybe<WorkSituations>;
};

/** The possible profile categories */
export enum ProfileCategories {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type PublishAccommodationInput = {
  id: Scalars['String'];
};

export type PublishAccommodationPayload = {
  __typename?: 'PublishAccommodationPayload';
  accommodation: Accommodation;
};

/** A person recommended to someone. */
export type Recommendation = {
  __typename?: 'Recommendation';
  /** A short text about the recommendee writen by the recommender upon acceptance. */
  about: Maybe<Scalars['String']>;
  /** The time at which the recommendation was accepted. */
  acceptedAt: Maybe<Scalars['DateTime']>;
  /** The recommendation's id. */
  id: Scalars['ID'];
  /** The time at which the recommendation was requested. */
  insertedAt: Scalars['DateTime'];
  /** Whether the recommendation is published or not. */
  published: Maybe<Scalars['Boolean']>;
  /** The time at which the recommendation was published. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** The recommendee. */
  recommendee: User;
  /** The recommender. */
  recommender: Maybe<User>;
  /** The recommender email. */
  recommenderEmail: Scalars['String'];
  /** The recommender first name. */
  recommenderFirstName: Maybe<Scalars['String']>;
  /** The recommender first name. */
  recommenderLastName: Maybe<Scalars['String']>;
  /** The time at which the recommendation was rejected. */
  rejectedAt: Maybe<Scalars['DateTime']>;
  /** The reason for which the recommendation was rejected. */
  rejectionReason: Maybe<Scalars['String']>;
  /** The recommendation's relationship between recommendee and recommender. */
  relationship: RecommendationRelationshipType;
  /** The recommendation's status. */
  status: RecommendationStatusType;
};

/** A paginated list of recommendations. */
export type RecommendationConnection = {
  __typename?: 'RecommendationConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<RecommendationEdge>>>;
  pageInfo: PageInfo;
};

export type RecommendationEdge = {
  __typename?: 'RecommendationEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Recommendation>;
};

/** The possible relationships for a recommendation. */
export enum RecommendationRelationshipType {
  Cohabitant = 'COHABITANT',
  Colleague = 'COLLEAGUE',
  Family = 'FAMILY',
  Friend = 'FRIEND',
  Other = 'OTHER'
}

/** The possible status for a recommendation. */
export enum RecommendationStatusType {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Describes available filters when listing recommendations. */
export type RecommendationsFilterInput = {
  /** Filters recommendations whether they are published or not. */
  published: InputMaybe<Scalars['Boolean']>;
  /** Filters recommendations by given recommendee ID. */
  recommendeeId: InputMaybe<Scalars['ID']>;
  /** Filters recommendations by recommendee role. */
  recommendeeRole: InputMaybe<Roles>;
  /** Filters recommendations by given recommender ID. */
  recommenderId: InputMaybe<Scalars['ID']>;
  /** Filters recommendations by given status. */
  status: InputMaybe<Array<RecommendationStatusType>>;
};

export type RedactMessageInput = {
  /** The message ID */
  id: Scalars['UUID'];
  /** The message redaction reason */
  redactionReason: RedactionReason;
};

export type RedactMessagePayload = {
  __typename?: 'RedactMessagePayload';
  message: Message;
};

/** The possible redaction reasons of a message */
export enum RedactionReason {
  InappropriateContent = 'INAPPROPRIATE_CONTENT'
}

export type RegisterUserToActivityInput = {
  activityId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RegisterUserToActivityPayload = {
  __typename?: 'RegisterUserToActivityPayload';
  activityAttendance: ActivityAttendance;
};

export type RejectActivityInput = {
  /** The Activity Id to submit for validation. */
  id: Scalars['ID'];
};

export type RejectActivityPayload = {
  __typename?: 'RejectActivityPayload';
  /** The rejected Activity. */
  activity: Activity;
};

export type RejectBookingStageInput = {
  endReason: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  privateEndReason: InputMaybe<Scalars['String']>;
  rejectedById: InputMaybe<Scalars['ID']>;
};

export type RejectBookingStagePayload = {
  __typename?: 'RejectBookingStagePayload';
  booking: Booking;
};

export type RejectUserFromCommunityInput = {
  id: Scalars['ID'];
};

export type RejectUserFromCommunityPayload = {
  __typename?: 'RejectUserFromCommunityPayload';
  user: User;
};

export type RejectUserInput = {
  id: Scalars['String'];
  reason: InputMaybe<Scalars['String']>;
};

export type RejectUserPayload = {
  __typename?: 'RejectUserPayload';
  user: User;
};

/** A relationship */
export type Relationship = {
  __typename?: 'Relationship';
  /** The connection */
  connection: User;
  /** The ID of the relationship. */
  id: Scalars['UUID'];
  /** The time the relationship was created */
  insertedAt: Scalars['NaiveDateTime'];
  /** The user whose relationship belongs to */
  user: User;
};

/** A paginated list of relationships. */
export type RelationshipConnection = {
  __typename?: 'RelationshipConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<RelationshipEdge>>>;
  pageInfo: PageInfo;
};

export type RelationshipEdge = {
  __typename?: 'RelationshipEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Relationship>;
};

export type RemoveUserAmbassadorStatusInput = {
  id: Scalars['ID'];
};

export type RemoveUserAmbassadorStatusPayload = {
  __typename?: 'RemoveUserAmbassadorStatusPayload';
  user: User;
};

export type RemoveUserFromDiscussionGroupInput = {
  discussionGroupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RemoveUserFromDiscussionGroupPayload = {
  __typename?: 'RemoveUserFromDiscussionGroupPayload';
  discussionGroup: DiscussionGroup;
};

/** An accommodation possible rent durations */
export type RentDuration = {
  __typename?: 'RentDuration';
  betweenThreeAndSixMonths: Maybe<Scalars['Boolean']>;
  lessThanThreeMonths: Maybe<Scalars['Boolean']>;
  moreThanSixMonths: Maybe<Scalars['Boolean']>;
};

export type RentDurationInput = {
  betweenThreeAndSixMonths: Scalars['Boolean'];
  lessThanThreeMonths: Scalars['Boolean'];
  moreThanSixMonths: Scalars['Boolean'];
};

/** A Rental */
export type Rental = {
  __typename?: 'Rental';
  addressLineOne: Maybe<Scalars['String']>;
  addressLineTwo: Maybe<Scalars['String']>;
  bookingId: Scalars['String'];
  cancelledAt: Maybe<Scalars['DateTime']>;
  city: Maybe<Scalars['String']>;
  countryIsoCode: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  depositPaidAt: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['Date']>;
  guestCustomer: Maybe<Customer>;
  guestFixedFee: Maybe<Scalars['Int']>;
  guestVariableFee: Maybe<Scalars['Float']>;
  hostCustomer: Maybe<Customer>;
  hostFixedFee: Maybe<Scalars['Int']>;
  hostVariableFee: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  postalCode: Maybe<Scalars['String']>;
  priceInCents: Maybe<Scalars['Int']>;
  startDate: Maybe<Scalars['Date']>;
  stripePaymentIntentId: Maybe<Scalars['String']>;
  terminatedAt: Maybe<Scalars['DateTime']>;
  updatedAt: Maybe<Scalars['NaiveDateTime']>;
};

/** A Rental Discount */
export type RentalDiscount = {
  __typename?: 'RentalDiscount';
  amountOff: Maybe<Scalars['Int']>;
  createdBy: Maybe<User>;
  currency: Maybe<Scalars['String']>;
  guestFixedFee: Maybe<Scalars['Int']>;
  guestVariableFee: Maybe<Scalars['Float']>;
  hostFixedFee: Maybe<Scalars['Int']>;
  hostVariableFee: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  maxApplications: Maybe<Scalars['Int']>;
  percentOff: Maybe<Scalars['Float']>;
  rentalId: Scalars['UUID'];
  timesApplied: Maybe<Scalars['Int']>;
};

/** A paginated list of subscriptions. */
export type RentalDiscountConnection = {
  __typename?: 'RentalDiscountConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<RentalDiscountEdge>>>;
  pageInfo: PageInfo;
};

export type RentalDiscountEdge = {
  __typename?: 'RentalDiscountEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<RentalDiscount>;
};

/** Available filters when listing rental discounts. */
export type RentalDiscountFilterInput = {
  /** Filters rental discounts by applicable status. */
  applicable: InputMaybe<Scalars['Boolean']>;
  /** Filters rental discounts by rental ID. */
  rentalId: Scalars['UUID'];
};

export type ReportMessageInput = {
  /** The message ID */
  id: Scalars['UUID'];
};

export type ReportMessagePayload = {
  __typename?: 'ReportMessagePayload';
  /** The message */
  message: Message;
};

export type RequestPhotographerInput = {
  hostId: Scalars['String'];
};

export type RequestPhotographerPayload = {
  __typename?: 'RequestPhotographerPayload';
  host: Host;
};

export type RescheduleBookingInput = {
  bookingId: Scalars['ID'];
  endDate: InputMaybe<Scalars['Date']>;
  nextInvoiceDate: Scalars['Date'];
  rescheduledById: InputMaybe<Scalars['ID']>;
  startDate: InputMaybe<Scalars['Date']>;
};

export type RescheduleBookingPayload = {
  __typename?: 'RescheduleBookingPayload';
  booking: Booking;
};

/**
 * A role is an abstraction intended to represent a person with a specific role
 * within the application. For example, it can be either a host or a guest.
 */
export type Role = {
  /** The ID of the user within its role. */
  id: Scalars['ID'];
};

/** The possible roles of the user. */
export enum Roles {
  Guest = 'GUEST',
  Host = 'HOST'
}

export enum RolesInput {
  Guest = 'GUEST',
  Host = 'HOST',
  None = 'NONE'
}

/** The room rented within an accommodation. */
export type Room = {
  __typename?: 'Room';
  balcony: Maybe<Balcony>;
  bathroom: Maybe<Bathroom>;
  bed: Maybe<Bed>;
  flooring: Maybe<Flooring>;
  furniture: Maybe<Furniture>;
  kitchen: Maybe<Kitchen>;
  lock: Maybe<Lock>;
  services: Maybe<Services>;
  size: Maybe<Scalars['Int']>;
  storage: Maybe<Storage>;
  toilet: Maybe<Toilet>;
  windows: Maybe<Windows>;
};

/** Available filters when listing rooms. */
export type RoomFilterInput = {
  /** Filters rooms by accommodation type */
  accommodationType: InputMaybe<AccommodationType>;
  /** Filters rooms by archived. */
  archived: InputMaybe<Scalars['Boolean']>;
  /** Filters rooms by availability. */
  availability: InputMaybe<AvailabilityFilterInput>;
  /** Filters rooms by completed. */
  completed: InputMaybe<Scalars['Boolean']>;
  /** Filters rooms by gender preference */
  genderPreference: InputMaybe<GenderPreferences>;
  /** Filters rooms by host ID. */
  hostId: InputMaybe<Scalars['ID']>;
  /** Filters rooms by housing assitance */
  housingAssistance: InputMaybe<Scalars['Boolean']>;
  /** Filters rooms by price (range) */
  price: InputMaybe<PriceFilterInput>;
  /** Filters rooms by published. */
  published: InputMaybe<Scalars['Boolean']>;
  /** Filters rooms by host ID. */
  text: InputMaybe<Scalars['String']>;
  /** Filters rooms by visited. */
  visited: InputMaybe<Scalars['Boolean']>;
  /** Filters rooms with professional pictures. */
  withProfessionalPictures: InputMaybe<Scalars['Boolean']>;
};

/** A room search performed by a user */
export type RoomSearch = {
  __typename?: 'RoomSearch';
  /** The room search id. */
  id: Scalars['ID'];
  /** The room search datetime. */
  insertedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The room search maximum budget. */
  maxBudget: Maybe<Scalars['Int']>;
  /** The room search mimimum budget. */
  minBudget: Maybe<Scalars['Int']>;
};

/** The available rooms for an accommodation. */
export enum RoomType {
  Basement = 'BASEMENT',
  Bathroom = 'BATHROOM',
  BikePark = 'BIKE_PARK',
  DiningRoom = 'DINING_ROOM',
  Garden = 'GARDEN',
  Gym = 'GYM',
  Kitchen = 'KITCHEN',
  LivingRoom = 'LIVING_ROOM',
  Office = 'OFFICE',
  Parking = 'PARKING',
  SwimmingPool = 'SWIMMING_POOL',
  Terrace = 'TERRACE'
}

/** The rooms available within an accommodation. */
export type Rooms = {
  __typename?: 'Rooms';
  name: Scalars['String'];
  picture: Maybe<Picture>;
};

/** Describes accommodation's rooms filter. */
export type RoomsFilterInput = {
  available: Scalars['Boolean'];
  name: RoomType;
};

export type RoomsInput = {
  basement: InputMaybe<Scalars['Boolean']>;
  bathroom: InputMaybe<Scalars['Boolean']>;
  bikePark: InputMaybe<Scalars['Boolean']>;
  diningRoom: InputMaybe<Scalars['Boolean']>;
  garden: InputMaybe<Scalars['Boolean']>;
  gym: InputMaybe<Scalars['Boolean']>;
  livingRoom: InputMaybe<Scalars['Boolean']>;
  office: InputMaybe<Scalars['Boolean']>;
  other: InputMaybe<Scalars['String']>;
  parking: InputMaybe<Scalars['Boolean']>;
  swimmingPool: InputMaybe<Scalars['Boolean']>;
  terrace: InputMaybe<Scalars['Boolean']>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Allows users to accept an activity */
  acceptActivity: Maybe<AcceptActivityPayload>;
  /** Accept a booking stage (contact-request, booking-request or booking-confirmation) */
  acceptBookingStage: Maybe<AcceptBookingStagePayload>;
  /** Accept user in community */
  acceptUserInCommunity: Maybe<AcceptUserInCommunityPayload>;
  /** Activate a user */
  activateUser: Maybe<ActivateUserPayload>;
  /** Add pictures to the accommodation */
  addAccommodationPictures: Maybe<AddAccommodationPicturesPayload>;
  /** Adds a new comment on given commentable. */
  addComment: Maybe<AddCommentPayload>;
  /** Add a user to a discussion group */
  addUserToDiscussionGroup: Maybe<AddUserToDiscussionGroupPayload>;
  /** Apply entry */
  applyEntry: Maybe<ApplyEntryPayload>;
  /** Archive an accommodation */
  archiveAccommodation: Maybe<ArchiveAccommodationPayload>;
  /** Allows users to archive (soft-delete) an activity */
  archiveActivity: Maybe<ArchiveActivityPayload>;
  /** Archive (soft-delete) a discussion group */
  archiveDiscussionGroup: Maybe<ArchiveDiscussionGroupPayload>;
  /** Archive a thread */
  archiveThread: Maybe<ArchiveThreadPayload>;
  /** Authenticates a user by email address and password. */
  authenticateAdminByEmail: Maybe<AuthenticateAdminByEmailPayload>;
  /** Ban the user */
  banUser: Maybe<BanUserPayload>;
  /** Baptize user */
  baptizeUser: Maybe<BaptizeUserPayload>;
  /** Cancel a booking */
  cancelBooking: Maybe<CancelBookingPayload>;
  /** Cancel deposit */
  cancelDeposit: Maybe<CancelDepositPayload>;
  /** Cancel a photographer visit */
  cancelPhotographer: Maybe<CancelPhotographerPayload>;
  /** Cancels a subscription */
  cancelSubscription: Maybe<CancelSubscriptionPayload>;
  /** Cancels the user deletion process */
  cancelUserDeletion: Maybe<CancelUserDeletionPayload>;
  /** Confirm activity attendance */
  confirmActivityAttendance: Maybe<ConfirmActivityAttendancePayload>;
  /** Confirm user email */
  confirmUserEmail: Maybe<ConfirmUserEmailPayload>;
  /** Confirm user phone number */
  confirmUserPhoneNumber: Maybe<ConfirmUserPhoneNumberPayload>;
  /** Copy an accommodation */
  copyAccommodation: Maybe<CopyAccommodationPayload>;
  /** Create an accommodation */
  createAccommodation: Maybe<CreateAccommodationPayload>;
  /** Create an account */
  createAccount: Maybe<CreateAccountPayload>;
  /** Create an activity */
  createActivity: Maybe<CreateActivityPayload>;
  /** Create a booking */
  createBooking: Maybe<CreateBookingPayload>;
  /** Create a booking report */
  createBookingReport: Maybe<CreateBookingReportPayload>;
  /** Create a category */
  createCategory: Maybe<CreateCategoryPayload>;
  /** Create a charter */
  createCharter: Maybe<CreateCharterPayload>;
  /** Create a customer for the given user */
  createCustomer: Maybe<CreateCustomerPayload>;
  /** Create a discussion group */
  createDiscussionGroup: Maybe<CreateDiscussionGroupPayload>;
  /** Create a thread in a discussion group */
  createDiscussionGroupThread: Maybe<CreateDiscussionGroupThreadPayload>;
  /** Creates a place. */
  createPlace: Maybe<CreatePlacePayload>;
  /** Create a rental discount */
  createRentalDiscount: Maybe<CreateRentalDiscountPayload>;
  /** Creates a Stripe connected account for the customer */
  createStripeAccount: Maybe<CreateStripeAccountPayload>;
  /** Creates a free subscription */
  createSubscription: Maybe<CreateSubscriptionPayload>;
  /** Create a guest */
  createUser: Maybe<CreateUserPayload>;
  /** Creates a review. */
  createUserReview: Maybe<CreateUserReviewPayload>;
  /** Deactivate a user */
  deactivateUser: Maybe<DeactivateUserPayload>;
  /** Delete an accommodation */
  deleteAccommodation: Maybe<DeleteAccommodationPayload>;
  /** Delete pictures from the accommodation */
  deleteAccommodationPictures: Maybe<DeleteAccommodationPicturesPayload>;
  /** Delete a category */
  deleteCategory: Maybe<DeleteCategoryPayload>;
  /** Deletes a user review. */
  deleteUserReview: Maybe<DeleteUserReviewPayload>;
  /** Disable a rental discount */
  disableRentalDiscount: Maybe<DisableRentalDiscountPayload>;
  /** Disconfirm activity attendance */
  disconfirmActivityAttendance: Maybe<DisconfirmActivityAttendancePayload>;
  /** Duplicate an activity */
  duplicateActivity: Maybe<DuplicateActivityPayload>;
  /** Create a short-lived token to log in as the user */
  impersonateUserWithMagicLink: Maybe<ImpersonateUserWithMagicLinkPayload>;
  /** Invalidate the accommodation professional pictures */
  invalidateAccommodationProfessionalPictures: Maybe<InvalidateAccommodationProfessionalPicturesPayload>;
  /** Like a message, increasing its like count and marking the message as liked by the user. */
  likeMessage: Maybe<LikeMessagePayload>;
  /** Lock a discussion group */
  lockDiscussionGroup: Maybe<LockDiscussionGroupPayload>;
  /** Lock a thread */
  lockThread: Maybe<LockThreadPayload>;
  /** Make user ambassador */
  makeUserAmbassador: Maybe<MakeUserAmbassadorPayload>;
  /** Onboard a user and the corresponding profile, compatiblity and onboarding */
  onboardUser: Maybe<OnboardUserPayload>;
  /** Publish the accommodation */
  publishAccommodation: Maybe<PublishAccommodationPayload>;
  /** Redact a message */
  redactMessage: Maybe<RedactMessagePayload>;
  /** Register a user to an activity */
  registerUserToActivity: Maybe<RegisterUserToActivityPayload>;
  /** Allows users to reject an activity */
  rejectActivity: Maybe<RejectActivityPayload>;
  /** Reject a booking stage (contact-request, booking-request or booking-confirmation) */
  rejectBookingStage: Maybe<RejectBookingStagePayload>;
  /** Reject the user */
  rejectUser: Maybe<RejectUserPayload>;
  /** Reject user from community */
  rejectUserFromCommunity: Maybe<RejectUserFromCommunityPayload>;
  /** Remove user's ambassador status */
  removeUserAmbassadorStatus: Maybe<RemoveUserAmbassadorStatusPayload>;
  /** Remove a user from a discussion group */
  removeUserFromDiscussionGroup: Maybe<RemoveUserFromDiscussionGroupPayload>;
  /** Report a message, increasing its report count and marking the message as reported by the user. */
  reportMessage: Maybe<ReportMessagePayload>;
  /** Request a photographer visit */
  requestPhotographer: Maybe<RequestPhotographerPayload>;
  /** Reschedule a booking */
  rescheduleBooking: Maybe<RescheduleBookingPayload>;
  /** Send a message to the specified thread with the given body */
  sendMessage: Maybe<SendMessagePayload>;
  /** Send a reset password token to the user in */
  sendResetPasswordToken: Maybe<SendResetPasswordTokenPayload>;
  /** Send a short-lived token to the user */
  sendShortlivedToken: Maybe<SendShortlivedTokenPayload>;
  /** Sets the user follow up status */
  setFollowUpStatus: Maybe<SetFollowUpStatusPayload>;
  /** Showcase the accommodation picture */
  showcaseAccommodationPicture: Maybe<ShowcaseAccommodationPicturePayload>;
  /** Starts the user deletion process */
  startUserDeletion: Maybe<StartUserDeletionPayload>;
  /** Terminate a booking */
  terminateBooking: Maybe<TerminateBookingPayload>;
  /** Unarchive an accommodation */
  unarchiveAccommodation: Maybe<UnarchiveAccommodationPayload>;
  /** Unarchive (soft-delete) a discussion group */
  unarchiveDiscussionGroup: Maybe<UnarchiveDiscussionGroupPayload>;
  /** Unarchive a thread */
  unarchiveThread: Maybe<UnarchiveThreadPayload>;
  /** Unban the user */
  unbanUser: Maybe<UnbanUserPayload>;
  /** Unbaptize user */
  unbaptizeUser: Maybe<UnbaptizeUserPayload>;
  /** Un-Like a message, decreasing its like count and un-marking the message as liked by the user. */
  unlikeMessage: Maybe<UnlikeMessagePayload>;
  /** Unlock a discussion group */
  unlockDiscussionGroup: Maybe<UnlockDiscussionGroupPayload>;
  /** Unlock a thread */
  unlockThread: Maybe<UnlockThreadPayload>;
  /** Unpublish the accommodation */
  unpublishAccommodation: Maybe<UnpublishAccommodationPayload>;
  /** Unredact a message */
  unredactMessage: Maybe<UnredactMessagePayload>;
  /** Unregister a user from an activity */
  unregisterUserFromActivity: Maybe<UnregisterUserFromActivityPayload>;
  /** Unreject the user */
  unrejectUser: Maybe<UnrejectUserPayload>;
  /** Unvisit accommodation */
  unvisitAccommodation: Maybe<UnvisitAccommodationPayload>;
  /** Update an accommodation */
  updateAccommodation: Maybe<UpdateAccommodationPayload>;
  /** Updates the number of max requests the room can receive */
  updateAccommodationMaxRequestCount: Maybe<UpdateAccommodationMaxRequestCountPayload>;
  /** Update an activity */
  updateActivity: Maybe<UpdateActivityPayload>;
  /** Update the activity picture */
  updateActivityPicture: Maybe<UpdateActivityPicturePayload>;
  /** Update a booking */
  updateBooking: Maybe<UpdateBookingPayload>;
  /** Update a booking NPS */
  updateBookingNps: Maybe<UpdateBookingNpsPayload>;
  /** Update a booking price */
  updateBookingPrice: Maybe<UpdateBookingPricePayload>;
  /** Update a booking report */
  updateBookingReport: Maybe<UpdateBookingReportPayload>;
  /** Update a category */
  updateCategory: Maybe<UpdateCategoryPayload>;
  /** Update a room */
  updateCharter: Maybe<UpdateCharterPayload>;
  /** Update a discussion_group */
  updateDiscussionGroup: Maybe<UpdateDiscussionGroupPayload>;
  /** Update a message */
  updateMessage: Maybe<UpdateMessagePayload>;
  /** Updates a place. */
  updatePlace: Maybe<UpdatePlacePayload>;
  /** Update a thread */
  updateThread: Maybe<UpdateThreadPayload>;
  /** Updates a user and the corresponding profile */
  updateUser: Maybe<UpdateUserPayload>;
  /** Update user avatar */
  updateUserAvatar: Maybe<UpdateUserAvatarPayload>;
  updateUserCompatibility: Maybe<UpdateUserCompatibilityPayload>;
  updateUserOnboarding: Maybe<UpdateUserOnboardingPayload>;
  /** Updates a review. */
  updateUserReview: Maybe<UpdateUserReviewPayload>;
  /** Validate the accommodation professional pictures */
  validateAccommodationProfessionalPictures: Maybe<ValidateAccommodationProfessionalPicturesPayload>;
  /** Visit accommodation */
  visitAccommodation: Maybe<VisitAccommodationPayload>;
};


export type RootMutationTypeAcceptActivityArgs = {
  input: AcceptActivityInput;
};


export type RootMutationTypeAcceptBookingStageArgs = {
  input: AcceptBookingStageInput;
};


export type RootMutationTypeAcceptUserInCommunityArgs = {
  input: AcceptUserInCommunityInput;
};


export type RootMutationTypeActivateUserArgs = {
  input: ActivateUserInput;
};


export type RootMutationTypeAddAccommodationPicturesArgs = {
  input: AddAccommodationPicturesInput;
};


export type RootMutationTypeAddCommentArgs = {
  input: AddCommentInput;
};


export type RootMutationTypeAddUserToDiscussionGroupArgs = {
  input: AddUserToDiscussionGroupInput;
};


export type RootMutationTypeApplyEntryArgs = {
  input: ApplyEntryInput;
};


export type RootMutationTypeArchiveAccommodationArgs = {
  input: ArchiveAccommodationInput;
};


export type RootMutationTypeArchiveActivityArgs = {
  input: ArchiveActivityInput;
};


export type RootMutationTypeArchiveDiscussionGroupArgs = {
  input: ArchiveDiscussionGroupInput;
};


export type RootMutationTypeArchiveThreadArgs = {
  input: ArchiveThreadInput;
};


export type RootMutationTypeAuthenticateAdminByEmailArgs = {
  input: AuthenticateAdminByEmailInput;
};


export type RootMutationTypeBanUserArgs = {
  input: BanUserInput;
};


export type RootMutationTypeBaptizeUserArgs = {
  input: BaptizeUserInput;
};


export type RootMutationTypeCancelBookingArgs = {
  input: CancelBookingInput;
};


export type RootMutationTypeCancelDepositArgs = {
  input: CancelDepositInput;
};


export type RootMutationTypeCancelPhotographerArgs = {
  input: CancelPhotographerInput;
};


export type RootMutationTypeCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type RootMutationTypeCancelUserDeletionArgs = {
  input: CancelUserDeletionInput;
};


export type RootMutationTypeConfirmActivityAttendanceArgs = {
  input: ConfirmActivityAttendanceInput;
};


export type RootMutationTypeConfirmUserEmailArgs = {
  input: ConfirmUserEmailInput;
};


export type RootMutationTypeConfirmUserPhoneNumberArgs = {
  input: ConfirmUserPhoneNumberInput;
};


export type RootMutationTypeCopyAccommodationArgs = {
  input: CopyAccommodationInput;
};


export type RootMutationTypeCreateAccommodationArgs = {
  input: CreateAccommodationInput;
};


export type RootMutationTypeCreateAccountArgs = {
  input: CreateAccountInput;
};


export type RootMutationTypeCreateActivityArgs = {
  input: CreateActivityInput;
};


export type RootMutationTypeCreateBookingArgs = {
  input: CreateBookingInput;
};


export type RootMutationTypeCreateBookingReportArgs = {
  input: CreateBookingReportInput;
};


export type RootMutationTypeCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type RootMutationTypeCreateCharterArgs = {
  input: CreateCharterInput;
};


export type RootMutationTypeCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type RootMutationTypeCreateDiscussionGroupArgs = {
  input: CreateDiscussionGroupInput;
};


export type RootMutationTypeCreateDiscussionGroupThreadArgs = {
  input: CreateDiscussionGroupThreadInput;
};


export type RootMutationTypeCreatePlaceArgs = {
  input: CreatePlaceInput;
};


export type RootMutationTypeCreateRentalDiscountArgs = {
  input: CreateRentalDiscountInput;
};


export type RootMutationTypeCreateStripeAccountArgs = {
  input: CreateStripeAccountInput;
};


export type RootMutationTypeCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type RootMutationTypeCreateUserArgs = {
  input: CreateUserInput;
};


export type RootMutationTypeCreateUserReviewArgs = {
  input: CreateUserReviewInput;
};


export type RootMutationTypeDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type RootMutationTypeDeleteAccommodationArgs = {
  input: DeleteAccommodationInput;
};


export type RootMutationTypeDeleteAccommodationPicturesArgs = {
  input: DeleteAccommodationPicturesInput;
};


export type RootMutationTypeDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type RootMutationTypeDeleteUserReviewArgs = {
  input: DeleteUserReviewInput;
};


export type RootMutationTypeDisableRentalDiscountArgs = {
  input: DisableRentalDiscountInput;
};


export type RootMutationTypeDisconfirmActivityAttendanceArgs = {
  input: DisconfirmActivityAttendanceInput;
};


export type RootMutationTypeDuplicateActivityArgs = {
  input: DuplicateActivityInput;
};


export type RootMutationTypeImpersonateUserWithMagicLinkArgs = {
  input: ImpersonateUserWithMagicLinkInput;
};


export type RootMutationTypeInvalidateAccommodationProfessionalPicturesArgs = {
  input: InvalidateAccommodationProfessionalPicturesInput;
};


export type RootMutationTypeLikeMessageArgs = {
  input: LikeMessageInput;
};


export type RootMutationTypeLockDiscussionGroupArgs = {
  input: LockDiscussionGroupInput;
};


export type RootMutationTypeLockThreadArgs = {
  input: LockThreadInput;
};


export type RootMutationTypeMakeUserAmbassadorArgs = {
  input: MakeUserAmbassadorInput;
};


export type RootMutationTypeOnboardUserArgs = {
  input: OnboardUserInput;
};


export type RootMutationTypePublishAccommodationArgs = {
  input: PublishAccommodationInput;
};


export type RootMutationTypeRedactMessageArgs = {
  input: RedactMessageInput;
};


export type RootMutationTypeRegisterUserToActivityArgs = {
  input: RegisterUserToActivityInput;
};


export type RootMutationTypeRejectActivityArgs = {
  input: RejectActivityInput;
};


export type RootMutationTypeRejectBookingStageArgs = {
  input: RejectBookingStageInput;
};


export type RootMutationTypeRejectUserArgs = {
  input: RejectUserInput;
};


export type RootMutationTypeRejectUserFromCommunityArgs = {
  input: RejectUserFromCommunityInput;
};


export type RootMutationTypeRemoveUserAmbassadorStatusArgs = {
  input: RemoveUserAmbassadorStatusInput;
};


export type RootMutationTypeRemoveUserFromDiscussionGroupArgs = {
  input: RemoveUserFromDiscussionGroupInput;
};


export type RootMutationTypeReportMessageArgs = {
  input: ReportMessageInput;
};


export type RootMutationTypeRequestPhotographerArgs = {
  input: RequestPhotographerInput;
};


export type RootMutationTypeRescheduleBookingArgs = {
  input: RescheduleBookingInput;
};


export type RootMutationTypeSendMessageArgs = {
  input: SendMessageInput;
};


export type RootMutationTypeSendResetPasswordTokenArgs = {
  input: SendResetPasswordTokenInput;
};


export type RootMutationTypeSendShortlivedTokenArgs = {
  input: SendShortlivedTokenInput;
};


export type RootMutationTypeSetFollowUpStatusArgs = {
  input: SetFollowUpStatusInput;
};


export type RootMutationTypeShowcaseAccommodationPictureArgs = {
  input: ShowcaseAccommodationPictureInput;
};


export type RootMutationTypeStartUserDeletionArgs = {
  input: StartUserDeletionInput;
};


export type RootMutationTypeTerminateBookingArgs = {
  input: TerminateBookingInput;
};


export type RootMutationTypeUnarchiveAccommodationArgs = {
  input: UnarchiveAccommodationInput;
};


export type RootMutationTypeUnarchiveDiscussionGroupArgs = {
  input: UnarchiveDiscussionGroupInput;
};


export type RootMutationTypeUnarchiveThreadArgs = {
  input: UnarchiveThreadInput;
};


export type RootMutationTypeUnbanUserArgs = {
  input: UnbanUserInput;
};


export type RootMutationTypeUnbaptizeUserArgs = {
  input: UnbaptizeUserInput;
};


export type RootMutationTypeUnlikeMessageArgs = {
  input: UnlikeMessageInput;
};


export type RootMutationTypeUnlockDiscussionGroupArgs = {
  input: UnlockDiscussionGroupInput;
};


export type RootMutationTypeUnlockThreadArgs = {
  input: UnlockThreadInput;
};


export type RootMutationTypeUnpublishAccommodationArgs = {
  input: UnpublishAccommodationInput;
};


export type RootMutationTypeUnredactMessageArgs = {
  input: UnredactMessageInput;
};


export type RootMutationTypeUnregisterUserFromActivityArgs = {
  input: UnregisterUserFromActivityInput;
};


export type RootMutationTypeUnrejectUserArgs = {
  input: UnrejectUserInput;
};


export type RootMutationTypeUnvisitAccommodationArgs = {
  input: UnvisitAccommodationInput;
};


export type RootMutationTypeUpdateAccommodationArgs = {
  input: UpdateAccommodationInput;
};


export type RootMutationTypeUpdateAccommodationMaxRequestCountArgs = {
  input: UpdateAccommodationMaxRequestCountInput;
};


export type RootMutationTypeUpdateActivityArgs = {
  input: UpdateActivityInput;
};


export type RootMutationTypeUpdateActivityPictureArgs = {
  input: UpdateActivityPictureInput;
};


export type RootMutationTypeUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type RootMutationTypeUpdateBookingNpsArgs = {
  input: UpdateBookingNpsInput;
};


export type RootMutationTypeUpdateBookingPriceArgs = {
  input: UpdateBookingPriceInput;
};


export type RootMutationTypeUpdateBookingReportArgs = {
  input: UpdateBookingReportInput;
};


export type RootMutationTypeUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type RootMutationTypeUpdateCharterArgs = {
  input: UpdateCharterInput;
};


export type RootMutationTypeUpdateDiscussionGroupArgs = {
  input: UpdateDiscussionGroupInput;
};


export type RootMutationTypeUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type RootMutationTypeUpdatePlaceArgs = {
  input: UpdatePlaceInput;
};


export type RootMutationTypeUpdateThreadArgs = {
  input: UpdateThreadInput;
};


export type RootMutationTypeUpdateUserArgs = {
  input: UpdateUserInput;
};


export type RootMutationTypeUpdateUserAvatarArgs = {
  input: UpdateUserAvatarInput;
};


export type RootMutationTypeUpdateUserCompatibilityArgs = {
  input: UpdateUserCompatibilityInput;
};


export type RootMutationTypeUpdateUserOnboardingArgs = {
  input: UpdateUserOnboardingInput;
};


export type RootMutationTypeUpdateUserReviewArgs = {
  input: UpdateUserReviewInput;
};


export type RootMutationTypeValidateAccommodationProfessionalPicturesArgs = {
  input: ValidateAccommodationProfessionalPicturesInput;
};


export type RootMutationTypeVisitAccommodationArgs = {
  input: VisitAccommodationInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Get room by ID */
  accommodation: Maybe<Accommodation>;
  /** Get paginated accommodations */
  accommodations: Maybe<AccommodationConnection>;
  /** Get a paginated list of activities. */
  activities: Maybe<ActivityConnection>;
  /** Get activity by ID */
  activity: Maybe<Activity>;
  /** Get booking by ID */
  booking: Maybe<Booking>;
  /** Get a booking payments history */
  bookingPaymentsHistory: Maybe<HostTransferConnection>;
  /** Get paginated bookings */
  bookings: Maybe<BookingConnection>;
  /** Get a paginated list of categories. */
  categories: Maybe<CategoryConnection>;
  /** Get paginated comments */
  comments: Maybe<CommentConnection>;
  /** Get the customer of the given user */
  customer: Maybe<Customer>;
  /** Get a discussion group by ID */
  discussionGroup: DiscussionGroup;
  /** Get a paginated list of discussion groups. */
  discussionGroups: DiscussionGroupConnection;
  /** Get paginated tags */
  flags: Maybe<Array<Scalars['String']>>;
  /** Get paginated gifts */
  gifts: Maybe<GiftConnection>;
  /** Get viewer */
  me: Maybe<User>;
  /** Get a paginated list of messages. */
  messages: MessageConnection;
  /** Get data for the given period */
  metrics: Maybe<Metrics>;
  /** Get payment dispute by ID */
  paymentDispute: Maybe<PaymentDispute>;
  /** Get payment intent by ID */
  paymentIntent: Maybe<PaymentIntent>;
  /** Get paginated payments */
  payments: Maybe<PaymentConnection>;
  /** Get a place by ID. */
  place: Maybe<Place>;
  /** A paginated list of places. */
  places: Maybe<PlaceConnection>;
  /** Get a paginated list of recommendations. */
  recommendations: Maybe<RecommendationConnection>;
  /** Get paginated rental discounts */
  rentalDiscounts: Maybe<RentalDiscountConnection>;
  /** Get paginated saved accommodations */
  savedAccommodations: Maybe<SavedAccommodationConnection>;
  /** Get paginated subscriptions */
  subscriptions: Maybe<ClubSubscriptionConnection>;
  /** Get paginated tags */
  tags: Maybe<TagConnection>;
  /** Get a thread by ID */
  thread: Thread;
  /** Get user by ID */
  user: User;
  /** Get user review by ID */
  userReview: Maybe<UserReview>;
  /** Get paginated user reviews */
  userReviews: Maybe<UserReviewConnection>;
  /** Get paginated users */
  users: Maybe<UserConnection>;
  /** Get birthdays */
  usersWithBirthday: Maybe<Array<Maybe<User>>>;
};


export type RootQueryTypeAccommodationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeAccommodationsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<RoomFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeActivitiesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ActivityFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ActivityOrderByInput>;
};


export type RootQueryTypeActivityArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeBookingArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeBookingPaymentsHistoryArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  bookingId: Scalars['ID'];
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeBookingsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<BookingFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<BookingsOrderByInput>;
};


export type RootQueryTypeCategoriesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CategoryFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CommentsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeCustomerArgs = {
  userId: Scalars['ID'];
};


export type RootQueryTypeDiscussionGroupArgs = {
  id: Scalars['UUID'];
};


export type RootQueryTypeDiscussionGroupsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<DiscussionGroupFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGiftsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<GiftFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeMessagesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeMetricsArgs = {
  endDate: InputMaybe<Scalars['Date']>;
  startDate: InputMaybe<Scalars['Date']>;
};


export type RootQueryTypePaymentDisputeArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePaymentIntentArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePaymentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  rentalId: InputMaybe<Scalars['String']>;
};


export type RootQueryTypePlaceArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePlacesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<PlacesFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeRecommendationsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<RecommendationsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeRentalDiscountsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<RentalDiscountFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeSavedAccommodationsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type RootQueryTypeSubscriptionsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SubscriptionFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TagsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeThreadArgs = {
  id: Scalars['UUID'];
};


export type RootQueryTypeUserArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserReviewArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserReviewsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<UserReviewFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeUsersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<UsersFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<UsersOrderByInput>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** A Subscription for receiving updates when an Activity gets created on the Admin. */
  activityCreated: Maybe<Activity>;
};


export type RootSubscriptionTypeActivityCreatedArgs = {
  type: InputMaybe<ActivityTypes>;
};

/** A saved accommodation joins a user, an accommodation, a start date and an end date */
export type SavedAccommodation = {
  __typename?: 'SavedAccommodation';
  /** The owner of the accommodation. */
  accommodation: Accommodation;
  /** The end date */
  endDate: Maybe<Scalars['Date']>;
  /** The ID */
  id: Scalars['ID'];
  /** The start date */
  startDate: Maybe<Scalars['Date']>;
};

export type SavedAccommodationConnection = {
  __typename?: 'SavedAccommodationConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<SavedAccommodationEdge>>>;
  pageInfo: PageInfo;
};

export type SavedAccommodationEdge = {
  __typename?: 'SavedAccommodationEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<SavedAccommodation>;
};

export type SendMessageInput = {
  /** The message body */
  body: Scalars['String'];
  /** The message pictures */
  pictures: InputMaybe<Array<PictureInput>>;
  /** The thread ID */
  threadId: Scalars['UUID'];
};

export type SendMessagePayload = {
  __typename?: 'SendMessagePayload';
  /** The message */
  message: Message;
};

export type SendResetPasswordTokenInput = {
  userId: Scalars['String'];
};

export type SendResetPasswordTokenPayload = {
  __typename?: 'SendResetPasswordTokenPayload';
  user: User;
};

export type SendShortlivedTokenInput = {
  userId: Scalars['String'];
};

export type SendShortlivedTokenPayload = {
  __typename?: 'SendShortlivedTokenPayload';
  user: User;
};

/** A room's services. */
export type Services = {
  __typename?: 'Services';
  cleaning: Scalars['Boolean'];
  halfBoard: Scalars['Boolean'];
};

export type SetFollowUpStatusInput = {
  status: FollowUpStatus;
  userId: Scalars['ID'];
};

export type SetFollowUpStatusPayload = {
  __typename?: 'SetFollowUpStatusPayload';
  user: User;
};

export type ShowcaseAccommodationPictureInput = {
  accommodationId: Scalars['String'];
  pictureId: Scalars['String'];
};

export type ShowcaseAccommodationPicturePayload = {
  __typename?: 'ShowcaseAccommodationPicturePayload';
  accommodation: Accommodation;
};

/** Describes guest's desired rental start_date filter. */
export type StartDateFilterInput = {
  /** Operator */
  operator: InputMaybe<StartDateOperator>;
  /** Value in days. */
  value: InputMaybe<Scalars['Date']>;
};

export enum StartDateOperator {
  After = 'AFTER',
  Before = 'BEFORE',
  Equal = 'EQUAL'
}

export type StartUserDeletionInput = {
  /** The user ID. */
  userId: Scalars['UUID'];
};

export type StartUserDeletionPayload = {
  __typename?: 'StartUserDeletionPayload';
  /** The updated user. */
  user: User;
};

/** A room's storage. */
export type Storage = {
  __typename?: 'Storage';
  hasBookshelf: Scalars['Boolean'];
  hasDresser: Scalars['Boolean'];
  hasWardrobe: Scalars['Boolean'];
};

export type StorageInput = {
  bookshelf: InputMaybe<Scalars['Boolean']>;
  dresser: InputMaybe<Scalars['Boolean']>;
  wardrobe: InputMaybe<Scalars['Boolean']>;
};

/** A customer Stripe link. */
export type StripeLink = {
  __typename?: 'StripeLink';
  /** The Stripe link name. */
  name: StripeLinkNameType;
  /** The Stripe link URL. */
  url: Scalars['String'];
};

/** The possible names for an Stripe link. */
export enum StripeLinkNameType {
  Account = 'ACCOUNT',
  Login = 'LOGIN'
}

/** Available filters when listing subscriptions. */
export type SubscriptionFilterInput = {
  /** Filters subscriptions by price. */
  price: InputMaybe<Scalars['Int']>;
  /** Filters subscriptions by a search expression (on the user). */
  search: InputMaybe<Scalars['String']>;
  /** Filters subscriptions by status. */
  status: InputMaybe<SubscriptionStatuses>;
  /** Filters subscriptions by user ID. */
  userId: InputMaybe<Scalars['ID']>;
};

/** The possible statuses for subscription. */
export enum SubscriptionStatuses {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type SubscriptionStripeData = {
  __typename?: 'SubscriptionStripeData';
  customerId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

/** A tag */
export type Tag = {
  __typename?: 'Tag';
  /** The tag's id. */
  id: Scalars['ID'];
  /** The tag's value */
  value: Scalars['String'];
};

/** A paginated list of tags. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<TagEdge>>>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename?: 'TagEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Tag>;
};

/** Describes taggable filter. */
export type TaggableFilterInput = {
  id: Scalars['ID'];
  scope: InputMaybe<TaggableScope>;
  type: TaggableType;
};

/** The possible scopes for a taggable object. */
export enum TaggableScope {
  IdealHost = 'IDEAL_HOST'
}

/** The possible types for a taggable object. */
export enum TaggableType {
  Candidate = 'CANDIDATE',
  Recommendation = 'RECOMMENDATION',
  User = 'USER'
}

/** Describes available filters when listing tags. */
export type TagsFilterInput = {
  taggable: InputMaybe<TaggableFilterInput>;
};

export type TerminateBookingInput = {
  bookingId: Scalars['ID'];
  endReason: InputMaybe<Scalars['String']>;
  privateEndReason: InputMaybe<Scalars['String']>;
  terminatedById: InputMaybe<Scalars['ID']>;
};

export type TerminateBookingPayload = {
  __typename?: 'TerminateBookingPayload';
  booking: Booking;
};

/** Describes a filter used to perform basic search against a text. */
export type TextSearchFilterInput = {
  /**
   * Searches for records which matches given expression at the end of the text
   * in a case insensitive manner.
   */
  endsWith: InputMaybe<Scalars['String']>;
  /**
   * Searches for records which matches given expression anywhere in the text
   * in a case insensitive manner.
   */
  like: InputMaybe<Scalars['String']>;
  /**
   * Searches for records which matches given expression at the beginning of the
   * text in a case insensitive manner.
   */
  startsWith: InputMaybe<Scalars['String']>;
};

/** A thread. */
export type Thread = {
  __typename?: 'Thread';
  /** The linked activity if any */
  activity: Maybe<Activity>;
  /** The time the thread was archived at */
  archivedAt: Maybe<Scalars['DateTime']>;
  /** The thread boost. */
  boost: Scalars['Int'];
  /** The linked discussion group if any */
  discussionGroup: Maybe<DiscussionGroup>;
  /** The first message of the tread */
  firstMessage: Maybe<Message>;
  /** Whether the thread contains unread messages */
  hasUnreadMessages: Scalars['Boolean'];
  /** The thread hashtags. */
  hashtags: Maybe<Array<Scalars['String']>>;
  /** The thread id. */
  id: Scalars['UUID'];
  /** The thread creation time */
  insertedAt: Scalars['DateTime'];
  /** The last message of the tread */
  lastMessage: Maybe<Message>;
  /** The time the thread was locked at */
  lockedAt: Maybe<Scalars['DateTime']>;
  /** A paginated list of messages for that thread. */
  messages: Maybe<MessageConnection>;
  /** The thread name. */
  name: Scalars['String'];
  /** A paginated list of the thread participants. */
  participants: Maybe<UserConnection>;
};


/** A thread. */
export type ThreadMessagesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


/** A thread. */
export type ThreadParticipantsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** A paginated list of threads. */
export type ThreadConnection = {
  __typename?: 'ThreadConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<ThreadEdge>>>;
  pageInfo: PageInfo;
};

export type ThreadEdge = {
  __typename?: 'ThreadEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<Thread>;
};

/** Filters for threads. */
export type ThreadsFilterInput = {
  /** Filter threads by text */
  text: InputMaybe<Scalars['String']>;
};

/** The time range input object.  Both start_date and end_date are required. */
export type TimeRangeInput = {
  /** The end date of the time range */
  endDate: Scalars['Date'];
  /** The start date of the time range */
  startDate: Scalars['Date'];
};

/** A room's toilet. */
export type Toilet = {
  __typename?: 'Toilet';
  isAvailable: Scalars['Boolean'];
};

/** Transit station located near an accommodation. */
export type TransitStation = {
  __typename?: 'TransitStation';
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  reference: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type UnarchiveAccommodationInput = {
  id: Scalars['String'];
};

export type UnarchiveAccommodationPayload = {
  __typename?: 'UnarchiveAccommodationPayload';
  accommodation: Accommodation;
};

export type UnarchiveDiscussionGroupInput = {
  /** The discussion group ID to archive */
  id: Scalars['UUID'];
};

export type UnarchiveDiscussionGroupPayload = {
  __typename?: 'UnarchiveDiscussionGroupPayload';
  /** The unarchived discussion group. */
  discussionGroup: DiscussionGroup;
};

export type UnarchiveThreadInput = {
  /** The thread ID */
  id: Scalars['UUID'];
};

export type UnarchiveThreadPayload = {
  __typename?: 'UnarchiveThreadPayload';
  thread: Thread;
};

export type UnbanUserInput = {
  id: Scalars['String'];
};

export type UnbanUserPayload = {
  __typename?: 'UnbanUserPayload';
  user: User;
};

export type UnbaptizeUserInput = {
  id: Scalars['ID'];
};

export type UnbaptizeUserPayload = {
  __typename?: 'UnbaptizeUserPayload';
  user: User;
};

export type UnlikeMessageInput = {
  /** The message ID */
  id: Scalars['UUID'];
};

export type UnlikeMessagePayload = {
  __typename?: 'UnlikeMessagePayload';
  /** The message */
  message: Message;
};

export type UnlockDiscussionGroupInput = {
  /** The discussion group ID */
  id: Scalars['UUID'];
};

export type UnlockDiscussionGroupPayload = {
  __typename?: 'UnlockDiscussionGroupPayload';
  /** The unlocked discussion group. */
  discussionGroup: DiscussionGroup;
};

export type UnlockThreadInput = {
  /** The thread ID */
  id: Scalars['UUID'];
};

export type UnlockThreadPayload = {
  __typename?: 'UnlockThreadPayload';
  thread: Thread;
};

export type UnpublishAccommodationInput = {
  id: Scalars['String'];
};

export type UnpublishAccommodationPayload = {
  __typename?: 'UnpublishAccommodationPayload';
  accommodation: Accommodation;
};

export type UnredactMessageInput = {
  /** The message ID */
  id: Scalars['UUID'];
};

export type UnredactMessagePayload = {
  __typename?: 'UnredactMessagePayload';
  message: Message;
};

export type UnregisterUserFromActivityInput = {
  activityAttendanceId: Scalars['ID'];
};

export type UnregisterUserFromActivityPayload = {
  __typename?: 'UnregisterUserFromActivityPayload';
  activityAttendance: ActivityAttendance;
};

export type UnrejectUserInput = {
  id: Scalars['String'];
};

export type UnrejectUserPayload = {
  __typename?: 'UnrejectUserPayload';
  user: User;
};

export type UnvisitAccommodationInput = {
  id: Scalars['String'];
};

export type UnvisitAccommodationPayload = {
  __typename?: 'UnvisitAccommodationPayload';
  accommodation: Accommodation;
};

export type UpdateAccommodationInput = {
  accommodationType: InputMaybe<AccommodationType>;
  addressLineOne: InputMaybe<Scalars['String']>;
  addressLineTwo: InputMaybe<Scalars['String']>;
  amenitiesAccessibleToGuest: InputMaybe<AmenitiesInput>;
  animals: InputMaybe<AnimalsInput>;
  area: InputMaybe<Areas>;
  availableFrom: InputMaybe<Scalars['String']>;
  bathroom: InputMaybe<BathroomInput>;
  bedLinen: InputMaybe<BedLinenInput>;
  city: InputMaybe<Scalars['String']>;
  cleaningIncluded: InputMaybe<Scalars['Boolean']>;
  comment: InputMaybe<Scalars['String']>;
  countryIsoCode: InputMaybe<Scalars['String']>;
  currency: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  dwellingSizeInSqm: InputMaybe<Scalars['Int']>;
  eligibleForHousingAssistance: InputMaybe<Scalars['Boolean']>;
  flooring: InputMaybe<FlooringInput>;
  formattedAddress: InputMaybe<Scalars['String']>;
  genderPreference: InputMaybe<GenderPreferences>;
  /** The default guest fixed fee for the room */
  guestFixedFee: InputMaybe<Scalars['Int']>;
  /** The default guest variable fee for the room */
  guestVariableFee: InputMaybe<Scalars['Float']>;
  halfBoardPossible: InputMaybe<Scalars['Boolean']>;
  headline: InputMaybe<Scalars['String']>;
  homeworkingFrequencyPreference: InputMaybe<HomeworkingFrequencies>;
  /** The default host fixed fee for the room */
  hostFixedFee: InputMaybe<Scalars['Int']>;
  /** The default host variable fee for the room */
  hostVariableFee: InputMaybe<Scalars['Float']>;
  housingType: InputMaybe<HousingType>;
  id: Scalars['String'];
  kitchenUsePreference: InputMaybe<KitchenUseFrequencies>;
  languagePreference: InputMaybe<LanguagePreferences>;
  latitude: InputMaybe<Scalars['Float']>;
  longitude: InputMaybe<Scalars['Float']>;
  numberOfBedrooms: InputMaybe<Scalars['Int']>;
  numberOfRoomsAccessibleToGuest: InputMaybe<Scalars['Int']>;
  numberOfWindowsInRoom: InputMaybe<Scalars['Int']>;
  postalCode: InputMaybe<Scalars['String']>;
  priceInCents: InputMaybe<Scalars['Int']>;
  privateRooms: InputMaybe<PrivateRoomsInput>;
  providedEquipment: InputMaybe<EquipmentInput>;
  rentDuration: InputMaybe<RentDurationInput>;
  roomAvailable: InputMaybe<Scalars['Boolean']>;
  roomBedding: InputMaybe<Scalars['String']>;
  roomFurniture: InputMaybe<FurnitureInput>;
  roomSizeInSqm: InputMaybe<Scalars['Int']>;
  roomStorage: InputMaybe<StorageInput>;
  roomWindowType: InputMaybe<Scalars['String']>;
  roomWithLockAndKeys: InputMaybe<Scalars['Boolean']>;
  roomsAccessibleToGuest: InputMaybe<RoomsInput>;
  sharedAreaSizeInSqm: InputMaybe<Scalars['Int']>;
  subheading: InputMaybe<Scalars['String']>;
};

export type UpdateAccommodationMaxRequestCountInput = {
  id: Scalars['ID'];
  maxRequestCount: Scalars['Int'];
};

export type UpdateAccommodationMaxRequestCountPayload = {
  __typename?: 'UpdateAccommodationMaxRequestCountPayload';
  accommodation: Accommodation;
};

export type UpdateAccommodationPayload = {
  __typename?: 'UpdateAccommodationPayload';
  accommodation: Accommodation;
};

export type UpdateActivityInput = {
  /**
   * This is the list of names of categories the activity is linked to.
   * If provided, it must be the exhaustive list of category names.
   */
  categories: InputMaybe<Array<Scalars['String']>>;
  class: InputMaybe<ActivityClasses>;
  description: Scalars['String'];
  /** Duration in minutes */
  duration: Scalars['Int'];
  headline: Scalars['String'];
  id: Scalars['ID'];
  location: InputMaybe<Scalars['String']>;
  maxAttendees: Scalars['Int'];
  mobileExclusive: Scalars['Boolean'];
  name: Scalars['String'];
  organizerId: InputMaybe<Scalars['ID']>;
  organizerName: InputMaybe<Scalars['String']>;
  picture: PictureInput;
  price: ActivityPriceInput;
  publicationTime: InputMaybe<Scalars['NaiveDateTime']>;
  scene: ActivitySceneTypes;
  startTime: Scalars['NaiveDateTime'];
  timezone: Scalars['String'];
  type: ActivityTypes;
};

export type UpdateActivityPayload = {
  __typename?: 'UpdateActivityPayload';
  activity: Activity;
};

export type UpdateActivityPictureInput = {
  id: Scalars['ID'];
  picture: InputMaybe<PictureInput>;
};

export type UpdateActivityPicturePayload = {
  __typename?: 'UpdateActivityPicturePayload';
  activity: Activity;
};

export type UpdateBookingInput = {
  addressLine1: InputMaybe<Scalars['String']>;
  addressLine2: InputMaybe<Scalars['String']>;
  bookingId: Scalars['ID'];
  city: InputMaybe<Scalars['String']>;
  countryIsoCode: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  postalCode: InputMaybe<Scalars['String']>;
};

export type UpdateBookingNpsInput = {
  guestEndNps: InputMaybe<Scalars['Int']>;
  guestStartNps: InputMaybe<Scalars['Int']>;
  hostEndNps: InputMaybe<Scalars['Int']>;
  hostStartNps: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type UpdateBookingNpsPayload = {
  __typename?: 'UpdateBookingNpsPayload';
  booking: Booking;
};

export type UpdateBookingPayload = {
  __typename?: 'UpdateBookingPayload';
  booking: Booking;
};

export type UpdateBookingPriceInput = {
  bookingId: Scalars['ID'];
  currency: Scalars['String'];
  guestFixedFee: InputMaybe<Scalars['Int']>;
  hostVariableFee: InputMaybe<Scalars['Float']>;
  nextInvoiceDate: Scalars['Date'];
  priceChangedById: InputMaybe<Scalars['ID']>;
  priceInCents: Scalars['Int'];
};

export type UpdateBookingPricePayload = {
  __typename?: 'UpdateBookingPricePayload';
  booking: Booking;
};

export type UpdateBookingReportInput = {
  bookingReportId: Scalars['ID'];
  bookingStatus: InputMaybe<BookingReportBookingStatus>;
  comment: InputMaybe<Scalars['String']>;
  couldHaveBeenPrevented: InputMaybe<Scalars['Boolean']>;
  endReason: InputMaybe<BookingEndReasons>;
  endTriggeredBy: InputMaybe<Scalars['ID']>;
  guestRehoused: InputMaybe<Scalars['Boolean']>;
  hostDesiredRetention: InputMaybe<Scalars['Boolean']>;
  hostHasNewGuest: InputMaybe<Scalars['Boolean']>;
  hostStillRenting: InputMaybe<Scalars['Boolean']>;
  issueWithHost: InputMaybe<IssuesWithHost>;
  noticeGiven: InputMaybe<Scalars['Boolean']>;
  topHost: InputMaybe<Scalars['Boolean']>;
};

export type UpdateBookingReportPayload = {
  __typename?: 'UpdateBookingReportPayload';
  bookingReport: BookingReport;
};

export type UpdateCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  category: Category;
};

export type UpdateCharterInput = {
  additionalElements: InputMaybe<Array<InputMaybe<CharterElementInput>>>;
  comment: InputMaybe<Scalars['String']>;
  deliveries: InputMaybe<Scalars['Boolean']>;
  drinkAlcohol: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  inviteFamily: InputMaybe<Scalars['Boolean']>;
  inviteFriends: InputMaybe<Scalars['Boolean']>;
  inviteFriendsForASleepover: InputMaybe<Scalars['Boolean']>;
  invitePartner: InputMaybe<Scalars['Boolean']>;
  smoke: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCharterPayload = {
  __typename?: 'UpdateCharterPayload';
  charter: Charter;
};

export type UpdateDiscussionGroupInput = {
  /**
   * This is the list of names of categories the discussion group is linked to.
   * If provided, it must be the exhaustive list of category names.
   */
  categories: InputMaybe<Array<Scalars['String']>>;
  coverPicture: InputMaybe<PictureInput>;
  description: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: InputMaybe<Scalars['String']>;
};

export type UpdateDiscussionGroupPayload = {
  __typename?: 'UpdateDiscussionGroupPayload';
  discussionGroup: DiscussionGroup;
};

export type UpdateMessageInput = {
  /** The message body */
  body: InputMaybe<Scalars['String']>;
  /** The message ID */
  id: Scalars['UUID'];
  /** The message pictures */
  pictures: InputMaybe<Array<PictureInput>>;
};

export type UpdateMessagePayload = {
  __typename?: 'UpdateMessagePayload';
  /** The updated message */
  message: Message;
};

export type UpdatePlaceInput = {
  /** The city of the place to update. */
  city: InputMaybe<Scalars['String']>;
  /** The country of the place to update. */
  country: InputMaybe<Scalars['String']>;
  /** The formatted address of the place to update. */
  formattedAddress: InputMaybe<Scalars['String']>;
  /** The ID of the place to update. */
  id: Scalars['ID'];
  /** The name of the place to update. */
  name: InputMaybe<Scalars['String']>;
  /** The postal code of the place to update. */
  postalCode: InputMaybe<Scalars['String']>;
};

export type UpdatePlacePayload = {
  __typename?: 'UpdatePlacePayload';
  /** The updated place. */
  place: Place;
};

export type UpdateThreadInput = {
  /** The thread boost */
  boost: InputMaybe<Scalars['Int']>;
  /** The thread hashtags */
  hashtags: InputMaybe<Array<Scalars['String']>>;
  /** The thread ID */
  id: Scalars['UUID'];
  /** The thread name */
  name: InputMaybe<Scalars['String']>;
};

export type UpdateThreadPayload = {
  __typename?: 'UpdateThreadPayload';
  thread: Thread;
};

export type UpdateUserAvatarInput = {
  id: Scalars['String'];
  public: InputMaybe<Scalars['Boolean']>;
  url: InputMaybe<Scalars['String']>;
};

export type UpdateUserAvatarPayload = {
  __typename?: 'UpdateUserAvatarPayload';
  user: User;
};

export type UpdateUserCompatibilityInput = {
  cleanlinessPreference: InputMaybe<CleanlinessPreferences>;
  desiredHousematePersonalityTraits: InputMaybe<DesiredHousematePersonalityTraits>;
  genderPreference: InputMaybe<GenderPreferences>;
  homeworkingFrequency: InputMaybe<HomeworkingFrequencies>;
  houseSharingExpectations: InputMaybe<HouseSharingExpectations>;
  houseSharingReasons: InputMaybe<HouseSharingReasons>;
  id: Scalars['ID'];
  kitchenUse: InputMaybe<KitchenUseFrequencies>;
  languagePreference: InputMaybe<LanguagePreferences>;
};

export type UpdateUserCompatibilityPayload = {
  __typename?: 'UpdateUserCompatibilityPayload';
  user: User;
};

export type UpdateUserInput = {
  about: InputMaybe<Scalars['String']>;
  aboutSecondPhoneNumber: InputMaybe<Scalars['String']>;
  birthdate: InputMaybe<Scalars['Date']>;
  email: InputMaybe<Scalars['String']>;
  firstName: InputMaybe<Scalars['String']>;
  gender: InputMaybe<Gender>;
  hobbies: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: InputMaybe<Scalars['String']>;
  leadSource: InputMaybe<LeadSource>;
  leadSourceDetail: InputMaybe<LeadSourceDetail>;
  linkedin: InputMaybe<Scalars['String']>;
  locale: InputMaybe<Scalars['String']>;
  maritalStatus: InputMaybe<MaritalStatuses>;
  nationality: InputMaybe<Nationalities>;
  numberOfChildren: InputMaybe<Scalars['Int']>;
  organization: InputMaybe<Scalars['String']>;
  ownerOrTenant: InputMaybe<OwnerOrTenantOptions>;
  personalityTraits: InputMaybe<PersonalityTraitsInput>;
  phoneNumber: InputMaybe<Scalars['String']>;
  placeOfResidence: InputMaybe<Scalars['String']>;
  postalAddress: InputMaybe<LocationInput>;
  secondPhoneNumber: InputMaybe<Scalars['String']>;
  spokenLanguages: InputMaybe<LanguagesInput>;
  studyAndWork: InputMaybe<Scalars['String']>;
  type: InputMaybe<Roles>;
  workSituation: InputMaybe<WorkSituations>;
};

export type UpdateUserOnboardingInput = {
  accessToCommonAreasGiven: InputMaybe<Scalars['Boolean']>;
  allChargesIncludedPolicyAccepted: InputMaybe<Scalars['Boolean']>;
  alreadyHouseShared: InputMaybe<Scalars['Boolean']>;
  alreadyRentedARoom: InputMaybe<Scalars['Boolean']>;
  availableRoomCount: InputMaybe<Scalars['Int']>;
  /** The user's budget currency. */
  budgetCurrency: InputMaybe<Scalars['String']>;
  /** The user's budget. */
  budgetInCents: InputMaybe<Scalars['Int']>;
  cleanAndTidyFlat: InputMaybe<Scalars['Boolean']>;
  coletteContractAccepted: InputMaybe<Scalars['Boolean']>;
  coletteFeesAccepted: InputMaybe<Scalars['Boolean']>;
  colettePaymentAccepted: InputMaybe<Scalars['Boolean']>;
  comment: InputMaybe<Scalars['String']>;
  concerns: InputMaybe<Scalars['String']>;
  desiredLocation: InputMaybe<DesiredLocationOptions>;
  durationInDays: InputMaybe<Scalars['Int']>;
  emergencyContact: InputMaybe<ContactInformationInput>;
  expectationsAndWishes: InputMaybe<Scalars['String']>;
  familyUnderstandsIntergenerationalHouseSharing: InputMaybe<Scalars['Boolean']>;
  goodFirstImpression: InputMaybe<Scalars['Boolean']>;
  hasDependentChildren: InputMaybe<Scalars['Boolean']>;
  hostedPeople: InputMaybe<HostedPeopleInput>;
  housingAssistanceAccepted: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idealHostDescription: InputMaybe<Scalars['String']>;
  internalAbout: InputMaybe<Scalars['String']>;
  internalHobbies: InputMaybe<Scalars['String']>;
  internalLifestyle: InputMaybe<Scalars['String']>;
  internalStudyAndWork: InputMaybe<Scalars['String']>;
  mainResidence: InputMaybe<Scalars['Boolean']>;
  oldEnough: InputMaybe<Scalars['Boolean']>;
  pastHousingExperience: InputMaybe<Scalars['String']>;
  pastRentingExperience: InputMaybe<Scalars['String']>;
  personalHistory: InputMaybe<Scalars['String']>;
  personality: InputMaybe<Scalars['String']>;
  placeId: InputMaybe<Scalars['ID']>;
  profileCategory: InputMaybe<Scalars['String']>;
  referencePerson: InputMaybe<ContactInformationInput>;
  roomInReadinessForGuest: InputMaybe<Scalars['Boolean']>;
  startDate: InputMaybe<Scalars['Date']>;
  wellBehaving: InputMaybe<Scalars['Boolean']>;
  whyColette: InputMaybe<Scalars['String']>;
};

export type UpdateUserOnboardingPayload = {
  __typename?: 'UpdateUserOnboardingPayload';
  user: User;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user: User;
};

export type UpdateUserReviewInput = {
  /** The review's comment. */
  comment: Scalars['String'];
  /** The review's ID. */
  id: Scalars['ID'];
  /** The review's rating. */
  rating: Scalars['Int'];
};

export type UpdateUserReviewPayload = {
  __typename?: 'UpdateUserReviewPayload';
  /** The updated review */
  userReview: UserReview;
};

/** A user is a person in the application. */
export type User = {
  __typename?: 'User';
  /** A paginated list of accommodations owned by the user. */
  accommodations: Maybe<AccommodationConnection>;
  /** The Colette account of the user (COL currency) */
  account: Maybe<Account>;
  /** The time the user was activated at. */
  activatedAt: Maybe<Scalars['DateTime']>;
  /** The active club subsciption of the user */
  activeClubSubscription: Maybe<ClubSubscription>;
  /** A paginated list of attendances for that user. */
  activityAttendances: Maybe<ActivityAttendanceConnection>;
  admin: Scalars['Boolean'];
  /** The user app version. */
  appVersion: Maybe<Scalars['String']>;
  attendedActivitiesThisMonth: Scalars['Boolean'];
  bannedAt: Maybe<Scalars['DateTime']>;
  baptizedAt: Maybe<Scalars['DateTime']>;
  /** The booking count of the user as a guest */
  bookingAsGuestCount: Scalars['Int'];
  /** A paginated list of bookings visible by the guest. */
  bookings: Maybe<BookingConnection>;
  communityVettingStatus: CommunityVettingStatuses;
  /** The user's compatibility profile. */
  compatibility: Maybe<UserCompatibility>;
  /** Whether the user is complete or not (i.e. has a password) */
  complete: Scalars['Boolean'];
  /** The user's customer. */
  customer: Maybe<Customer>;
  /** When the user account is planned for deletion */
  deleteAt: Maybe<Scalars['DateTime']>;
  /** When the user account has been deleted */
  deletedAt: Maybe<Scalars['DateTime']>;
  /** Whether the user is eligible or not. */
  eligible: Scalars['Boolean'];
  email: Scalars['String'];
  emailConfirmedAt: Maybe<Scalars['NaiveDateTime']>;
  firstName: Maybe<Scalars['String']>;
  /** The list of flags of the user */
  flags: Maybe<Array<Flag>>;
  /** The user follow-up status */
  followUpStatus: Maybe<FollowUpStatus>;
  /** The ID of the user. */
  id: Scalars['ID'];
  /** The user's identity. */
  identity: Maybe<Identity>;
  insertedAt: Scalars['NaiveDateTime'];
  /** The last booking created by the user as a guest */
  lastBookingAsGuest: Maybe<Booking>;
  lastName: Maybe<Scalars['String']>;
  /** The last search of the user */
  lastSearch: Maybe<RoomSearch>;
  leadSource: Maybe<LeadSource>;
  leadSourceDetail: Maybe<LeadSourceDetail>;
  /** The user locale. */
  locale: Maybe<Scalars['String']>;
  memberType: MemberTypes;
  /** Whether the user is onboarded or not. */
  onboarded: Scalars['Boolean'];
  /** The user's onboarding profile. */
  onboarding: Maybe<UserOnboarding>;
  phoneNumber: Maybe<Scalars['String']>;
  phoneNumberConfirmedAt: Maybe<Scalars['NaiveDateTime']>;
  /** The user's profile. */
  profile: Maybe<Profile>;
  registrationChannel: Maybe<Scalars['String']>;
  rejectedAt: Maybe<Scalars['DateTime']>;
  rejectionReason: Maybe<Scalars['String']>;
  /** The paginated list of the user's relationships */
  relationships: Maybe<RelationshipConnection>;
  /** The number of requested recommendations by the user */
  requestedRecommendationCount: Maybe<Scalars['Int']>;
  /** The user's role. */
  role: Maybe<Role>;
  /** The search count of the user */
  searchCount: Scalars['Int'];
  status: Scalars['String'];
  /** The user time zone. */
  timeZone: Maybe<Scalars['String']>;
  type: Maybe<Roles>;
  updatedAt: Scalars['NaiveDateTime'];
};


/** A user is a person in the application. */
export type UserAccommodationsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<AccommodationsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


/** A user is a person in the application. */
export type UserActivityAttendancesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ActivityAttendancesFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


/** A user is a person in the application. */
export type UserBookingsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


/** A user is a person in the application. */
export type UserRelationshipsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

/** The user's compatibility profile. */
export type UserCompatibility = {
  __typename?: 'UserCompatibility';
  cleanlinessPreference: Maybe<CleanlinessPreferences>;
  desiredHousematePersonalityTraits: Maybe<DesiredHousematePersonalityTraits>;
  genderPreference: Maybe<GenderPreferences>;
  homeworkingFrequency: Maybe<HomeworkingFrequencies>;
  houseSharingExpectations: Maybe<HouseSharingExpectations>;
  houseSharingReasons: Maybe<HouseSharingReasons>;
  /** The ID of the user compatibility profile (mostly used for caching purposes) */
  id: Scalars['ID'];
  kitchenUse: Maybe<KitchenUseFrequencies>;
  languagePreference: Maybe<LanguagePreferences>;
};

/** A paginated list of users. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<UserEdge>>>;
  pageInfo: PageInfo;
};

/** Date range filter for users. */
export type UserDateRange = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<User>;
};

/** The user's onboarding data. */
export type UserOnboarding = {
  __typename?: 'UserOnboarding';
  accessToCommonAreasGiven: Maybe<Scalars['Boolean']>;
  allChargesIncludedPolicyAccepted: Maybe<Scalars['Boolean']>;
  alreadyHouseShared: Maybe<Scalars['Boolean']>;
  alreadyRentedARoom: Maybe<Scalars['Boolean']>;
  availableRoomCount: Maybe<Scalars['Int']>;
  /** The user's budget. */
  budget: Maybe<Price>;
  cleanAndTidyFlat: Maybe<Scalars['Boolean']>;
  coletteContractAccepted: Maybe<Scalars['Boolean']>;
  coletteFeesAccepted: Maybe<Scalars['Boolean']>;
  colettePaymentAccepted: Maybe<Scalars['Boolean']>;
  comment: Maybe<Scalars['String']>;
  concerns: Maybe<Scalars['String']>;
  desiredLocation: Maybe<DesiredLocationOptions>;
  durationInDays: Maybe<Scalars['Int']>;
  emergencyContact: Maybe<ContactInformation>;
  expectationsAndWishes: Maybe<Scalars['String']>;
  familyUnderstandsIntergenerationalHouseSharing: Maybe<Scalars['Boolean']>;
  goodFirstImpression: Maybe<Scalars['Boolean']>;
  hasDependentChildren: Maybe<Scalars['Boolean']>;
  /** The people hosted by the user. */
  hostedPeople: Maybe<HostedPeople>;
  housingAssistanceAccepted: Maybe<Scalars['Boolean']>;
  /** The ID of the user onboarding data (mostly used for caching purposes) */
  id: Scalars['ID'];
  idealHostDescription: Maybe<Scalars['String']>;
  internalAbout: Maybe<Scalars['String']>;
  internalHobbies: Maybe<Scalars['String']>;
  internalLifestyle: Maybe<Scalars['String']>;
  internalStudyAndWork: Maybe<Scalars['String']>;
  mainResidence: Maybe<Scalars['Boolean']>;
  oldEnough: Maybe<Scalars['Boolean']>;
  partnershipCode: Maybe<Scalars['String']>;
  pastHousingExperience: Maybe<Scalars['String']>;
  pastRentingExperience: Maybe<Scalars['String']>;
  personalHistory: Maybe<Scalars['String']>;
  personality: Maybe<Scalars['String']>;
  placeId: Maybe<Scalars['ID']>;
  profileCategory: Maybe<ProfileCategories>;
  referencePerson: Maybe<ContactInformation>;
  roomInReadinessForGuest: Maybe<Scalars['Boolean']>;
  startDate: Maybe<Scalars['Date']>;
  wellBehaving: Maybe<Scalars['Boolean']>;
  whyColette: Maybe<Scalars['String']>;
};

/**
 * A user review describes a request between a guest and a host to book a
 * stay for a given accommodation and stay period.
 */
export type UserReview = {
  __typename?: 'UserReview';
  /** The booking subject to the review. */
  booking: Maybe<Booking>;
  /** The review's comment. */
  comment: Scalars['String'];
  /** The review's id. */
  id: Scalars['ID'];
  /** The review's date of creation. */
  insertedAt: Scalars['DateTime'];
  /** The review's rating. */
  rating: Scalars['Int'];
  /** The reviewee */
  reviewee: User;
  /** The reviewer. */
  reviewer: User;
  /** The room subject to the review. */
  room: Maybe<Accommodation>;
  /** The review's last update time. */
  updatedAt: Scalars['DateTime'];
};

/** A paginated list of user reviews. */
export type UserReviewConnection = {
  __typename?: 'UserReviewConnection';
  /** The total count of items in the connection. */
  count: Maybe<Scalars['Int']>;
  edges: Maybe<Array<Maybe<UserReviewEdge>>>;
  pageInfo: PageInfo;
};

export type UserReviewEdge = {
  __typename?: 'UserReviewEdge';
  cursor: Maybe<Scalars['String']>;
  node: Maybe<UserReview>;
};

/** Describes available filters when listing user reviews. */
export type UserReviewFilterInput = {
  bookingId: InputMaybe<Scalars['ID']>;
  revieweeId: InputMaybe<Scalars['ID']>;
  reviewerId: InputMaybe<Scalars['ID']>;
  roomId: InputMaybe<Scalars['ID']>;
};

export enum UserStatus {
  Banned = 'BANNED',
  NotRejected = 'NOT_REJECTED',
  Rejected = 'REJECTED'
}

/** Describes available filters when listing users. */
export type UsersFilterInput = {
  /** Filters users by whether they are active or not */
  active: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether or not they're admins. */
  admin: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they're ambassador or not */
  ambassador: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they have an avatar or not */
  avatar: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they're baptized or not */
  baptized: InputMaybe<Scalars['Boolean']>;
  /** Filters users by budget (range) */
  budget: InputMaybe<BudgetFilterInput>;
  /** Filters users by whether or not they're accepted by the community. */
  communityAccepted: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether or not they're rejected by the community. */
  communityRejected: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they are complete or not (i.e. they have a password) */
  complete: InputMaybe<Scalars['Boolean']>;
  /** Filters users by completion score */
  completionScore: InputMaybe<CompletionScoreFilterInput>;
  /** Filters users by planned deletion time */
  deleteAt: InputMaybe<UserDateRange>;
  /** Filters users by whether or not they've been deleted. */
  deleted: InputMaybe<Scalars['Boolean']>;
  /** Filters users by deletion time */
  deletedAt: InputMaybe<UserDateRange>;
  /** Filters users by whether or not they're planned for deletion. */
  deletionPlanned: InputMaybe<Scalars['Boolean']>;
  /** Filters users by their desired location */
  desiredLocation: InputMaybe<DesiredLocationOptions>;
  /** Filters users by desired rental duration */
  duration: InputMaybe<DurationFilterInput>;
  /** Filters users by whether they are eligible or not */
  eligible: InputMaybe<Scalars['Boolean']>;
  /** Filters users by follow-up status */
  followUpStatus: InputMaybe<FollowUpStatus>;
  /** Filters users by gender */
  gender: InputMaybe<Gender>;
  /** Filters users by partnership code */
  hasPartnershipCode: InputMaybe<Scalars['Boolean']>;
  /** Filters users by wishlist */
  hasWishlist: InputMaybe<Scalars['Boolean']>;
  /** Filters users by their house share status */
  houseShare: InputMaybe<HouseShareStatus>;
  /** Filters users by whether they are house sharing now or not */
  houseSharingNow: InputMaybe<Scalars['Boolean']>;
  /** Filters users whether their identity is verified or not. */
  identityVerified: InputMaybe<Scalars['Boolean']>;
  /** Filters users by ids. */
  ids: InputMaybe<Array<Scalars['UUID']>>;
  /** Filters users by lead source */
  leadSource: InputMaybe<LeadSource>;
  /** Filters users by member type. */
  memberType: InputMaybe<MemberTypes>;
  /** Filters users by whether they are onboarded or not */
  onboarded: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they performed searched or not */
  performedSearches: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they requested recommendations or not */
  requestedRecommendations: InputMaybe<Scalars['Boolean']>;
  /** Filters users by role. */
  role: InputMaybe<Roles>;
  /** Filters users by roles (potentially multiple ones). */
  roles: InputMaybe<Array<RolesInput>>;
  /** Filters users by given search expression. */
  search: InputMaybe<Scalars['String']>;
  /** Filters users by desired rental start_date */
  startDate: InputMaybe<StartDateFilterInput>;
  /** Filters users by given status. */
  status: InputMaybe<UserStatus>;
  /** Filters users by whether they submitted contact requests or not */
  submittedContactRequests: InputMaybe<Scalars['Boolean']>;
  /** Filters users by whether they have a video or not */
  video: InputMaybe<Scalars['Boolean']>;
  /** Filters users by work_situation */
  workSituation: InputMaybe<WorkSituations>;
};

/** Describes available order by expressions when listing users. */
export type UsersOrderByInput = {
  /** Desired rental duration for a guest. */
  duration: InputMaybe<OrderByDirection>;
  /** Time at which the user was inserted. */
  insertedAt: InputMaybe<OrderByDirection>;
  /** Desired rental start_date for a guest. */
  startDate: InputMaybe<OrderByDirection>;
};

export type ValidateAccommodationProfessionalPicturesInput = {
  id: Scalars['String'];
};

export type ValidateAccommodationProfessionalPicturesPayload = {
  __typename?: 'ValidateAccommodationProfessionalPicturesPayload';
  accommodation: Accommodation;
};

/** A video accessible through a URL. */
export type Video = {
  __typename?: 'Video';
  basename: Maybe<Scalars['String']>;
  ext: Maybe<Scalars['String']>;
  md5hash: Maybe<Scalars['String']>;
  mime: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  public: Maybe<Scalars['Boolean']>;
  size: Maybe<Scalars['Int']>;
  thumbnailUrl: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

export type VisitAccommodationInput = {
  id: Scalars['String'];
};

export type VisitAccommodationPayload = {
  __typename?: 'VisitAccommodationPayload';
  accommodation: Accommodation;
};

/** A room's windows. */
export type Windows = {
  __typename?: 'Windows';
  count: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
};

/** The possible occupations. */
export enum WorkSituations {
  Other = 'OTHER',
  Retired = 'RETIRED',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED',
  Volunteer = 'VOLUNTEER',
  Working = 'WORKING'
}

export type AcceptBookingStageMutationVariables = Exact<{
  input: AcceptBookingStageInput;
}>;


export type AcceptBookingStageMutation = { __typename?: 'RootMutationType', acceptBookingStage: { __typename?: 'AcceptBookingStagePayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type AccommodationFieldsFragment = { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } };

export type AccountFieldsFragment = { __typename?: 'Account', id: string, balance: number, reserved: number, currency: AccountCurrencies, upperLimit: number, lowerLimit: number };

export type ActivateUserMutationVariables = Exact<{
  input: ActivateUserInput;
}>;


export type ActivateUserMutation = { __typename?: 'RootMutationType', activateUser: { __typename?: 'ActivateUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type ActivityFieldsFragment = { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } };

export type AddAccommodationPicturesMutationVariables = Exact<{
  input: AddAccommodationPicturesInput;
}>;


export type AddAccommodationPicturesMutation = { __typename?: 'RootMutationType', addAccommodationPictures: { __typename?: 'AddAccommodationPicturesPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type AddCommentMutationVariables = Exact<{
  input: AddCommentInput;
}>;


export type AddCommentMutation = { __typename?: 'RootMutationType', addComment: { __typename?: 'AddCommentPayload', comment: { __typename?: 'Comment', id: string, body: string, insertedAt: string, updatedAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string, profile: { __typename?: 'Profile', avatar: { __typename?: 'Avatar', url: string } } } } } };

export type ApplyEntryMutationVariables = Exact<{
  input: ApplyEntryInput;
}>;


export type ApplyEntryMutation = { __typename?: 'RootMutationType', applyEntry: { __typename?: 'ApplyEntryPayload', account: { __typename?: 'Account', id: string, balance: number, reserved: number, currency: AccountCurrencies, upperLimit: number, lowerLimit: number } } };

export type ArchiveAccommodationMutationVariables = Exact<{
  input: ArchiveAccommodationInput;
}>;


export type ArchiveAccommodationMutation = { __typename?: 'RootMutationType', archiveAccommodation: { __typename?: 'ArchiveAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type AuthenticateAdminByEmailMutationVariables = Exact<{
  input: AuthenticateAdminByEmailInput;
}>;


export type AuthenticateAdminByEmailMutation = { __typename?: 'RootMutationType', authenticateAdminByEmail: { __typename?: 'AuthenticateAdminByEmailPayload', token: string, user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type BanUserMutationVariables = Exact<{
  input: BanUserInput;
}>;


export type BanUserMutation = { __typename?: 'RootMutationType', banUser: { __typename?: 'BanUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type BaptizeUserMutationVariables = Exact<{
  input: BaptizeUserInput;
}>;


export type BaptizeUserMutation = { __typename?: 'RootMutationType', baptizeUser: { __typename?: 'BaptizeUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } };

export type BookingPhaseFieldsFragment = { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } };

export type BookingReportFieldsFragment = { __typename?: 'BookingReport', id: string, bookingId: string, bookingStatus: BookingReportBookingStatus, endTriggeredBy: string, noticeGiven: boolean, guestRehoused: boolean, hostHasNewGuest: boolean, hostStillRenting: boolean, endReason: BookingEndReasons, couldHaveBeenPrevented: boolean, comment: string, hostDesiredRetention: boolean, topHost: boolean, issueWithHost: IssuesWithHost };

export type CancelBookingMutationVariables = Exact<{
  input: CancelBookingInput;
}>;


export type CancelBookingMutation = { __typename?: 'RootMutationType', cancelBooking: { __typename?: 'CancelBookingPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type CancelDepositMutationVariables = Exact<{
  input: CancelDepositInput;
}>;


export type CancelDepositMutation = { __typename?: 'RootMutationType', cancelDeposit: { __typename?: 'CancelDepositPayload', rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string } } };

export type CancelPhotographerMutationVariables = Exact<{
  input: CancelPhotographerInput;
}>;


export type CancelPhotographerMutation = { __typename?: 'RootMutationType', cancelPhotographer: { __typename?: 'CancelPhotographerPayload', host: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number } } };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'RootMutationType', cancelSubscription: { __typename?: 'CancelSubscriptionPayload', subscription: { __typename?: 'ClubSubscription', id: string, createdAt: string, cancelledAt: string, cancelAt: string, status: SubscriptionStatuses, scope: string, userId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, stripeData: { __typename?: 'SubscriptionStripeData', customerId: string, subscriptionId: string } } } };

export type CategoriesQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<CategoryFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type CategoriesQuery = { __typename?: 'RootQueryType', categories: { __typename?: 'CategoryConnection', count: number, edges: Array<{ __typename?: 'CategoryEdge', node: { __typename?: 'Category', id: string, name: string, insertedAt: string } }> } };

export type CharterFieldsFragment = { __typename?: 'Charter', canInviteFriends: boolean, canInviteFriendsForASleepover: boolean, canInvitePartner: boolean, canInviteFamily: boolean, canSmoke: boolean, canDrinkAlcohol: boolean, canReceiveDeliveries: boolean, comment: string, id: string, insertedAt: string, updatedAt: string, accommodationId: string, hostId: string, additionalElements: Array<{ __typename?: 'CharterElement', title: string, authorized: boolean }> };

export type ClubSubscriptionFieldsFragment = { __typename?: 'ClubSubscription', id: string, createdAt: string, cancelledAt: string, cancelAt: string, status: SubscriptionStatuses, scope: string, userId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, stripeData: { __typename?: 'SubscriptionStripeData', customerId: string, subscriptionId: string } };

export type CommentFieldsFragment = { __typename?: 'Comment', id: string, body: string, insertedAt: string, updatedAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string, profile: { __typename?: 'Profile', avatar: { __typename?: 'Avatar', url: string } } } };

export type ConfirmActivityAttendanceMutationVariables = Exact<{
  input: ConfirmActivityAttendanceInput;
}>;


export type ConfirmActivityAttendanceMutation = { __typename?: 'RootMutationType', confirmActivityAttendance: { __typename?: 'ConfirmActivityAttendancePayload', activityAttendance: { __typename?: 'ActivityAttendance', id: string } } };

export type ConfirmUserEmailMutationVariables = Exact<{
  input: ConfirmUserEmailInput;
}>;


export type ConfirmUserEmailMutation = { __typename?: 'RootMutationType', confirmUserEmail: { __typename?: 'ConfirmUserEmailPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type ConfirmUserPhoneNumberMutationVariables = Exact<{
  input: ConfirmUserPhoneNumberInput;
}>;


export type ConfirmUserPhoneNumberMutation = { __typename?: 'RootMutationType', confirmUserPhoneNumber: { __typename?: 'ConfirmUserPhoneNumberPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type CopyAccommodationMutationVariables = Exact<{
  input: CopyAccommodationInput;
}>;


export type CopyAccommodationMutation = { __typename?: 'RootMutationType', copyAccommodation: { __typename?: 'CopyAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type CreateAccommodationMutationVariables = Exact<{
  input: CreateAccommodationInput;
}>;


export type CreateAccommodationMutation = { __typename?: 'RootMutationType', createAccommodation: { __typename?: 'CreateAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'RootMutationType', createAccount: { __typename?: 'CreateAccountPayload', account: { __typename?: 'Account', id: string, balance: number, reserved: number, currency: AccountCurrencies, upperLimit: number, lowerLimit: number } } };

export type CreateActivityMutationVariables = Exact<{
  input: CreateActivityInput;
}>;


export type CreateActivityMutation = { __typename?: 'RootMutationType', createActivity: { __typename?: 'CreateActivityPayload', activity: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'RootMutationType', createBooking: { __typename?: 'CreateBookingPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type CreateBookingReportMutationVariables = Exact<{
  input: CreateBookingReportInput;
}>;


export type CreateBookingReportMutation = { __typename?: 'RootMutationType', createBookingReport: { __typename?: 'CreateBookingReportPayload', bookingReport: { __typename?: 'BookingReport', id: string, bookingId: string, bookingStatus: BookingReportBookingStatus, endTriggeredBy: string, noticeGiven: boolean, guestRehoused: boolean, hostHasNewGuest: boolean, hostStillRenting: boolean, endReason: BookingEndReasons, couldHaveBeenPrevented: boolean, comment: string, hostDesiredRetention: boolean, topHost: boolean, issueWithHost: IssuesWithHost } } };

export type CreateCharterMutationVariables = Exact<{
  input: CreateCharterInput;
}>;


export type CreateCharterMutation = { __typename?: 'RootMutationType', createCharter: { __typename?: 'CreateCharterPayload', charter: { __typename?: 'Charter', canInviteFriends: boolean, canInviteFriendsForASleepover: boolean, canInvitePartner: boolean, canInviteFamily: boolean, canSmoke: boolean, canDrinkAlcohol: boolean, canReceiveDeliveries: boolean, comment: string, id: string, insertedAt: string, updatedAt: string, accommodationId: string, hostId: string, additionalElements: Array<{ __typename?: 'CharterElement', title: string, authorized: boolean }> } } };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'RootMutationType', createCustomer: { __typename?: 'CreateCustomerPayload', customer: { __typename?: 'Customer', id: string, insertedAt: string, updatedAt: string, hasStripeAccount: boolean, stripeLinks: Array<{ __typename?: 'StripeLink', name: StripeLinkNameType, url: string }> } } };

export type CreatePlaceMutationVariables = Exact<{
  input: CreatePlaceInput;
}>;


export type CreatePlaceMutation = { __typename?: 'RootMutationType', createPlace: { __typename?: 'CreatePlacePayload', place: { __typename?: 'Place', id: string, city: string, country: string, formattedAddress: string, latitude: number, longitude: number, name: string, postalCode: string, types: Array<string>, insertedAt: string, updatedAt: string } } };

export type CreateRentalDiscountMutationVariables = Exact<{
  input: CreateRentalDiscountInput;
}>;


export type CreateRentalDiscountMutation = { __typename?: 'RootMutationType', createRentalDiscount: { __typename?: 'CreateRentalDiscountPayload', rentalDiscount: { __typename?: 'RentalDiscount', amountOff: number, currency: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: any, maxApplications: number, percentOff: number, rentalId: any, timesApplied: number, insertedAt: string, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type CreateStripeAccountMutationVariables = Exact<{
  input: CreateStripeAccountInput;
}>;


export type CreateStripeAccountMutation = { __typename?: 'RootMutationType', createStripeAccount: { __typename?: 'CreateStripeAccountPayload', customer: { __typename?: 'Customer', id: string, insertedAt: string, updatedAt: string, hasStripeAccount: boolean, stripeLinks: Array<{ __typename?: 'StripeLink', name: StripeLinkNameType, url: string }> } } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'RootMutationType', createSubscription: { __typename?: 'CreateSubscriptionPayload', subscription: { __typename?: 'ClubSubscription', id: string, createdAt: string, cancelledAt: string, cancelAt: string, status: SubscriptionStatuses, scope: string, userId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, stripeData: { __typename?: 'SubscriptionStripeData', customerId: string, subscriptionId: string } } } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'RootMutationType', createUser: { __typename?: 'CreateUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type CreateUserReviewMutationVariables = Exact<{
  input: CreateUserReviewInput;
}>;


export type CreateUserReviewMutation = { __typename?: 'RootMutationType', createUserReview: { __typename?: 'CreateUserReviewPayload', userReview: { __typename?: 'UserReview', id: string, comment: string, rating: number, insertedAt: string, updatedAt: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName: string }, reviewee: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type CustomerFieldsFragment = { __typename?: 'Customer', id: string, insertedAt: string, updatedAt: string, hasStripeAccount: boolean, stripeLinks: Array<{ __typename?: 'StripeLink', name: StripeLinkNameType, url: string }> };

export type DeactivateUserMutationVariables = Exact<{
  input: DeactivateUserInput;
}>;


export type DeactivateUserMutation = { __typename?: 'RootMutationType', deactivateUser: { __typename?: 'DeactivateUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type DeleteAccommodationMutationVariables = Exact<{
  input: DeleteAccommodationInput;
}>;


export type DeleteAccommodationMutation = { __typename?: 'RootMutationType', deleteAccommodation: { __typename?: 'DeleteAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type DeleteAccommodationPicturesMutationVariables = Exact<{
  input: DeleteAccommodationPicturesInput;
}>;


export type DeleteAccommodationPicturesMutation = { __typename?: 'RootMutationType', deleteAccommodationPictures: { __typename?: 'DeleteAccommodationPicturesPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type DeleteCategoryMutationVariables = Exact<{
  input: DeleteCategoryInput;
}>;


export type DeleteCategoryMutation = { __typename?: 'RootMutationType', deleteCategory: { __typename?: 'DeleteCategoryPayload', category: { __typename?: 'Category', name: string, insertedAt: string, id: string } } };

export type DeleteUserReviewMutationVariables = Exact<{
  input: DeleteUserReviewInput;
}>;


export type DeleteUserReviewMutation = { __typename?: 'RootMutationType', deleteUserReview: { __typename?: 'DeleteUserReviewPayload', userReview: { __typename?: 'UserReview', id: string, comment: string, rating: number, insertedAt: string, updatedAt: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName: string }, reviewee: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type DisableRentalDiscountMutationVariables = Exact<{
  input: DisableRentalDiscountInput;
}>;


export type DisableRentalDiscountMutation = { __typename?: 'RootMutationType', disableRentalDiscount: { __typename?: 'DisableRentalDiscountPayload', rentalDiscount: { __typename?: 'RentalDiscount', amountOff: number, currency: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: any, maxApplications: number, percentOff: number, rentalId: any, timesApplied: number, insertedAt: string, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type DisconfirmActivityAttendanceMutationVariables = Exact<{
  input: DisconfirmActivityAttendanceInput;
}>;


export type DisconfirmActivityAttendanceMutation = { __typename?: 'RootMutationType', disconfirmActivityAttendance: { __typename?: 'DisconfirmActivityAttendancePayload', activityAttendance: { __typename?: 'ActivityAttendance', id: string } } };

export type DuplicateActivityMutationVariables = Exact<{
  input: DuplicateActivityInput;
}>;


export type DuplicateActivityMutation = { __typename?: 'RootMutationType', duplicateActivity: { __typename?: 'DuplicateActivityPayload', activity: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } };

export type EntryFieldsFragment = { __typename?: 'Entry', id: string, type: EntryTypes, amount: number, event: EntryEvents, communication: string, resourceId: string, resourceType: string, resourceDescription: string, hold: boolean, sequenceNumber: number, linkedEntryId: string, insertedAt: string };

export type AccommodationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccommodationQuery = { __typename?: 'RootQueryType', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, owner: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } }, charter: { __typename?: 'Charter', canInviteFriends: boolean, canInviteFriendsForASleepover: boolean, canInvitePartner: boolean, canInviteFamily: boolean, canSmoke: boolean, canDrinkAlcohol: boolean, canReceiveDeliveries: boolean, comment: string, id: string, insertedAt: string, updatedAt: string, accommodationId: string, hostId: string, additionalElements: Array<{ __typename?: 'CharterElement', title: string, authorized: boolean }> }, bookings: { __typename?: 'BookingConnection', count: number, edges: Array<{ __typename?: 'BookingEdge', node: { __typename?: 'Booking', id: string } }> }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } };

export type ActivityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivityQuery = { __typename?: 'RootQueryType', activity: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, attendances: { __typename?: 'ActivityAttendanceConnection', count: number, edges: Array<{ __typename?: 'ActivityAttendanceEdge', node: { __typename?: 'ActivityAttendance', id: string, attendanceConfirmation: ActivityAttendanceConfirmationStates, selfRegistered: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phoneNumber: string, memberType: MemberTypes, attendedActivitiesThisMonth: boolean, account: { __typename?: 'Account', currency: AccountCurrencies, balance: number, reserved: number }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } }> }, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } };

export type BookingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookingQuery = { __typename?: 'RootQueryType', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, bookingReport: { __typename?: 'BookingReport', id: string, bookingId: string, bookingStatus: BookingReportBookingStatus, endTriggeredBy: string, noticeGiven: boolean, guestRehoused: boolean, hostHasNewGuest: boolean, hostStillRenting: boolean, endReason: BookingEndReasons, couldHaveBeenPrevented: boolean, comment: string, hostDesiredRetention: boolean, topHost: boolean, issueWithHost: IssuesWithHost }, host: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } }, guest: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } }, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, room: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } };

export type CustomerQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type CustomerQuery = { __typename?: 'RootQueryType', customer: { __typename?: 'Customer', id: string, insertedAt: string, updatedAt: string, hasStripeAccount: boolean, stripeLinks: Array<{ __typename?: 'StripeLink', name: StripeLinkNameType, url: string }> } };

export type GetPaymentDisputeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentDisputeQuery = { __typename?: 'RootQueryType', paymentDispute: { __typename?: 'PaymentDispute', id: string, status: PaymentDisputeStatusType, reason: PaymentDisputeReasonType, insertedAt: string, stripePaymentIntentId: string, payment: { __typename?: 'Payment', id: string, description: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } };

export type GetPaymentIntentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentIntentQuery = { __typename?: 'RootQueryType', paymentIntent: { __typename?: 'PaymentIntent', id: string, description: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } };

export type GetPlaceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPlaceQuery = { __typename?: 'RootQueryType', place: { __typename?: 'Place', id: string, city: string, country: string, formattedAddress: string, latitude: number, longitude: number, name: string, postalCode: string, types: Array<string>, insertedAt: string, updatedAt: string } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, userId: string, price: { __typename?: 'Price', currency: CurrencyType, amount: number }, stripeData: { __typename?: 'SubscriptionStripeData', customerId: string, subscriptionId: string } }, compatibility: { __typename?: 'UserCompatibility', id: string, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, kitchenUse: KitchenUseFrequencies }, bookings: { __typename?: 'BookingConnection', count: number, edges: Array<{ __typename?: 'BookingEdge', node: { __typename?: 'Booking', id: string } }> }, role: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number }, accommodations: { __typename?: 'AccommodationConnection', count: number, edges: Array<{ __typename?: 'AccommodationEdge', node: { __typename?: 'Accommodation', id: string } }> }, activityAttendances: { __typename?: 'ActivityAttendanceConnection', edges: Array<{ __typename?: 'ActivityAttendanceEdge', node: { __typename?: 'ActivityAttendance', id: string, attendanceConfirmation: ActivityAttendanceConfirmationStates, activity: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } }> }, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } } } };

export type GiftFieldsFragment = { __typename?: 'Gift', id: string, name: string, duration: GiftDuration, durationInMonths: number, buyerName: string, buyerEmail: string, recipientName: string, recipientEmail: string, message: string, deliverAt: string, deliveredAt: string, deletedAt: string, redeemBy: string, redeemedAt: string, code: string, percentOff: number, amountOff: { __typename?: 'Price', amount: number, currency: CurrencyType } };

export type GiftsQueryVariables = Exact<{
  filter: InputMaybe<GiftFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type GiftsQuery = { __typename?: 'RootQueryType', gifts: { __typename?: 'GiftConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'GiftEdge', node: { __typename?: 'Gift', id: string, name: string, duration: GiftDuration, durationInMonths: number, buyerName: string, buyerEmail: string, recipientName: string, recipientEmail: string, message: string, deliverAt: string, deliveredAt: string, deletedAt: string, redeemBy: string, redeemedAt: string, code: string, percentOff: number, redeemedBy: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } }, product: { __typename?: 'Product', id: string, name: string, description: string, active: boolean, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, amountOff: { __typename?: 'Price', amount: number, currency: CurrencyType } } }> } };

export type HostFieldsFragment = { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number };

export type ImpersonateUserWithMagicLinkMutationVariables = Exact<{
  input: ImpersonateUserWithMagicLinkInput;
}>;


export type ImpersonateUserWithMagicLinkMutation = { __typename?: 'RootMutationType', impersonateUserWithMagicLink: { __typename?: 'ImpersonateUserWithMagicLinkPayload', user: { __typename?: 'User', id: string } } };

export type InvalidateAccommodationProfessionalPicturesMutationVariables = Exact<{
  input: InvalidateAccommodationProfessionalPicturesInput;
}>;


export type InvalidateAccommodationProfessionalPicturesMutation = { __typename?: 'RootMutationType', invalidateAccommodationProfessionalPictures: { __typename?: 'InvalidateAccommodationProfessionalPicturesPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type ListAccommodationsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
  filter: InputMaybe<RoomFilterInput>;
}>;


export type ListAccommodationsQuery = { __typename?: 'RootQueryType', accommodations: { __typename?: 'AccommodationConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'AccommodationEdge', node: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, owner: { __typename?: 'User', id: string, firstName: string, lastName: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } }> } };

export type ListActivitiesQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<ActivityFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<ActivityOrderByInput>;
}>;


export type ListActivitiesQuery = { __typename?: 'RootQueryType', activities: { __typename?: 'ActivityConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'ActivityEdge', node: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } }> } };

export type ListBookingsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
  filter: InputMaybe<BookingFilterInput>;
  orderBy: InputMaybe<BookingsOrderByInput>;
}>;


export type ListBookingsQuery = { __typename?: 'RootQueryType', bookings: { __typename?: 'BookingConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'BookingEdge', node: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, bookingReport: { __typename?: 'BookingReport', id: string }, host: { __typename?: 'User', id: string, firstName: string, lastName: string }, guest: { __typename?: 'User', id: string, firstName: string, lastName: string }, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, room: { __typename?: 'Accommodation', id: string, headline: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } }> } };

export type ListClubSubscriptionsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  filter: InputMaybe<SubscriptionFilterInput>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
}>;


export type ListClubSubscriptionsQuery = { __typename?: 'RootQueryType', subscriptions: { __typename?: 'ClubSubscriptionConnection', count: number, edges: Array<{ __typename?: 'ClubSubscriptionEdge', cursor: string, node: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, status: SubscriptionStatuses, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, user: { __typename?: 'User', firstName: string, id: string, lastName: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string } } };

export type CommentsQueryVariables = Exact<{
  filter: InputMaybe<CommentsFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type CommentsQuery = { __typename?: 'RootQueryType', comments: { __typename?: 'CommentConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, body: string, insertedAt: string, updatedAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string, profile: { __typename?: 'Profile', avatar: { __typename?: 'Avatar', url: string } } } } }> } };

export type ListGuestUsersQueryVariables = Exact<{
  filter: InputMaybe<UsersFilterInput>;
  orderBy: InputMaybe<UsersOrderByInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListGuestUsersQuery = { __typename?: 'RootQueryType', users: { __typename?: 'UserConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', searchCount: number, bookingAsGuestCount: number, id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, lastBookingAsGuest: { __typename?: 'Booking', insertedAt: string, id: string }, role: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number }, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } }> } };

export type ListPaymentsQueryVariables = Exact<{
  rentalId: InputMaybe<Scalars['String']>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListPaymentsQuery = { __typename?: 'RootQueryType', payments: { __typename?: 'PaymentConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'PaymentEdge', node: { __typename?: 'Payment', id: string, rentalId: string, insertedAt: string, updatedAt: string, stripeCreated: string, status: string, description: string, amountInCents: number, currency: string, applicationFeeAmount: number, stripeCustomerId: string, paymentDispute: { __typename?: 'PaymentDispute', id: string, status: PaymentDisputeStatusType, reason: PaymentDisputeReasonType, insertedAt: string, stripePaymentIntentId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string, guestCustomer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, userId: string }, hostCustomer: { __typename?: 'Customer', id: string, firstName: string, lastName: string, userId: string } } } }> } };

export type ListPlacesQueryVariables = Exact<{
  filter: InputMaybe<PlacesFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListPlacesQuery = { __typename?: 'RootQueryType', places: { __typename?: 'PlaceConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'PlaceEdge', node: { __typename?: 'Place', id: string, city: string, country: string, formattedAddress: string, latitude: number, longitude: number, name: string, postalCode: string, types: Array<string>, insertedAt: string, updatedAt: string } }> } };

export type ListRecommendationsQueryVariables = Exact<{
  filter: InputMaybe<RecommendationsFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListRecommendationsQuery = { __typename?: 'RootQueryType', recommendations: { __typename?: 'RecommendationConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'RecommendationEdge', node: { __typename?: 'Recommendation', id: string, about: string, acceptedAt: string, insertedAt: string, published: boolean, publishedAt: string, recommenderEmail: string, recommenderFirstName: string, recommenderLastName: string, rejectedAt: string, rejectionReason: string, relationship: RecommendationRelationshipType, status: RecommendationStatusType, recommendee: { __typename?: 'User', id: string, type: Roles, email: string, firstName: string, lastName: string }, recommender: { __typename?: 'User', id: string, type: Roles, email: string, firstName: string, lastName: string } } }> } };

export type ListTagsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<TagsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListTagsQuery = { __typename?: 'RootQueryType', tags: { __typename?: 'TagConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'TagEdge', node: { __typename?: 'Tag', id: string, value: string } }> } };

export type ListUserReviewsQueryVariables = Exact<{
  filter: InputMaybe<UserReviewFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListUserReviewsQuery = { __typename?: 'RootQueryType', userReviews: { __typename?: 'UserReviewConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'UserReviewEdge', node: { __typename?: 'UserReview', id: string, comment: string, rating: number, insertedAt: string, updatedAt: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName: string }, reviewee: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } };

export type ListUsersQueryVariables = Exact<{
  filter: InputMaybe<UsersFilterInput>;
  orderBy: InputMaybe<UsersOrderByInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type ListUsersQuery = { __typename?: 'RootQueryType', users: { __typename?: 'UserConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, role: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number }, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } }> } };

export type UsersWithBirthdayQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersWithBirthdayQuery = { __typename?: 'RootQueryType', usersWithBirthday: Array<{ __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } }> };

export type MakeUserAmbassadorMutationVariables = Exact<{
  input: MakeUserAmbassadorInput;
}>;


export type MakeUserAmbassadorMutation = { __typename?: 'RootMutationType', makeUserAmbassador: { __typename?: 'MakeUserAmbassadorPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, profile: { __typename?: 'Profile', id: string, avatar: { __typename?: 'Avatar', url: string } } } };

export type OnboardUserMutationVariables = Exact<{
  input: OnboardUserInput;
}>;


export type OnboardUserMutation = { __typename?: 'RootMutationType', onboardUser: { __typename?: 'OnboardUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type PaymentDisputeFieldsFragment = { __typename?: 'PaymentDispute', id: string, status: PaymentDisputeStatusType, reason: PaymentDisputeReasonType, insertedAt: string, stripePaymentIntentId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, rentalId: string, insertedAt: string, updatedAt: string, stripeCreated: string, status: string, description: string, amountInCents: number, currency: string, applicationFeeAmount: number, stripeCustomerId: string };

export type PlaceFieldsFragment = { __typename?: 'Place', id: string, city: string, country: string, formattedAddress: string, latitude: number, longitude: number, name: string, postalCode: string, types: Array<string>, insertedAt: string, updatedAt: string };

export type PublishAccommodationMutationVariables = Exact<{
  input: PublishAccommodationInput;
}>;


export type PublishAccommodationMutation = { __typename?: 'RootMutationType', publishAccommodation: { __typename?: 'PublishAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type RecommendationFieldsFragment = { __typename?: 'Recommendation', id: string, about: string, acceptedAt: string, insertedAt: string, published: boolean, publishedAt: string, recommenderEmail: string, recommenderFirstName: string, recommenderLastName: string, rejectedAt: string, rejectionReason: string, relationship: RecommendationRelationshipType, status: RecommendationStatusType };

export type RegisterUserToActivityMutationVariables = Exact<{
  input: RegisterUserToActivityInput;
}>;


export type RegisterUserToActivityMutation = { __typename?: 'RootMutationType', registerUserToActivity: { __typename?: 'RegisterUserToActivityPayload', activityAttendance: { __typename?: 'ActivityAttendance', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } } };

export type RejectBookingStageMutationVariables = Exact<{
  input: RejectBookingStageInput;
}>;


export type RejectBookingStageMutation = { __typename?: 'RootMutationType', rejectBookingStage: { __typename?: 'RejectBookingStagePayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type RejectUserMutationVariables = Exact<{
  input: RejectUserInput;
}>;


export type RejectUserMutation = { __typename?: 'RootMutationType', rejectUser: { __typename?: 'RejectUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type RemoveUserAmbassadorStatusMutationVariables = Exact<{
  input: RemoveUserAmbassadorStatusInput;
}>;


export type RemoveUserAmbassadorStatusMutation = { __typename?: 'RootMutationType', removeUserAmbassadorStatus: { __typename?: 'RemoveUserAmbassadorStatusPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type RentalDiscountFragment = { __typename?: 'RentalDiscount', amountOff: number, currency: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: any, maxApplications: number, percentOff: number, rentalId: any, timesApplied: number, insertedAt: string, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type RentalDiscountsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filter: InputMaybe<RentalDiscountFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type RentalDiscountsQuery = { __typename?: 'RootQueryType', rentalDiscounts: { __typename?: 'RentalDiscountConnection', count: number, pageInfo: { __typename?: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string }, edges: Array<{ __typename?: 'RentalDiscountEdge', cursor: string, node: { __typename?: 'RentalDiscount', amountOff: number, currency: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: any, maxApplications: number, percentOff: number, rentalId: any, timesApplied: number, insertedAt: string, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } };

export type RentalFieldsFragment = { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string };

export type RequestPhotographerMutationVariables = Exact<{
  input: RequestPhotographerInput;
}>;


export type RequestPhotographerMutation = { __typename?: 'RootMutationType', requestPhotographer: { __typename?: 'RequestPhotographerPayload', host: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number } } };

export type RescheduleBookingMutationVariables = Exact<{
  input: RescheduleBookingInput;
}>;


export type RescheduleBookingMutation = { __typename?: 'RootMutationType', rescheduleBooking: { __typename?: 'RescheduleBookingPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type SavedAccommodationsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
}>;


export type SavedAccommodationsQuery = { __typename?: 'RootQueryType', savedAccommodations: { __typename?: 'SavedAccommodationConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'SavedAccommodationEdge', node: { __typename?: 'SavedAccommodation', id: string, startDate: string, endDate: string, accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, owner: { __typename?: 'User', id: string, firstName: string, lastName: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } }> } };

export type SendResetPasswordTokenMutationVariables = Exact<{
  input: SendResetPasswordTokenInput;
}>;


export type SendResetPasswordTokenMutation = { __typename?: 'RootMutationType', sendResetPasswordToken: { __typename?: 'SendResetPasswordTokenPayload', user: { __typename?: 'User', id: string } } };

export type SendShortlivedTokenMutationVariables = Exact<{
  input: SendShortlivedTokenInput;
}>;


export type SendShortlivedTokenMutation = { __typename?: 'RootMutationType', sendShortlivedToken: { __typename?: 'SendShortlivedTokenPayload', user: { __typename?: 'User', id: string } } };

export type SetFollowUpStatusMutationVariables = Exact<{
  input: SetFollowUpStatusInput;
}>;


export type SetFollowUpStatusMutation = { __typename?: 'RootMutationType', setFollowUpStatus: { __typename?: 'SetFollowUpStatusPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type ShowcaseAccommodationPictureMutationVariables = Exact<{
  input: ShowcaseAccommodationPictureInput;
}>;


export type ShowcaseAccommodationPictureMutation = { __typename?: 'RootMutationType', showcaseAccommodationPicture: { __typename?: 'ShowcaseAccommodationPicturePayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type SubscriptionsQueryVariables = Exact<{
  filter: InputMaybe<SubscriptionFilterInput>;
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['Int']>;
}>;


export type SubscriptionsQuery = { __typename?: 'RootQueryType', subscriptions: { __typename?: 'ClubSubscriptionConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor: string, startCursor: string }, edges: Array<{ __typename?: 'ClubSubscriptionEdge', node: { __typename?: 'ClubSubscription', id: string, createdAt: string, cancelledAt: string, cancelAt: string, status: SubscriptionStatuses, scope: string, userId: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, stripeData: { __typename?: 'SubscriptionStripeData', customerId: string, subscriptionId: string } } }> } };

export type TerminateBookingMutationVariables = Exact<{
  input: TerminateBookingInput;
}>;


export type TerminateBookingMutation = { __typename?: 'RootMutationType', terminateBooking: { __typename?: 'TerminateBookingPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type UnarchiveAccommodationMutationVariables = Exact<{
  input: UnarchiveAccommodationInput;
}>;


export type UnarchiveAccommodationMutation = { __typename?: 'RootMutationType', unarchiveAccommodation: { __typename?: 'UnarchiveAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type UnbaptizeUserMutationVariables = Exact<{
  input: UnbaptizeUserInput;
}>;


export type UnbaptizeUserMutation = { __typename?: 'RootMutationType', unbaptizeUser: { __typename?: 'UnbaptizeUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UnpublishAccommodationMutationVariables = Exact<{
  input: UnpublishAccommodationInput;
}>;


export type UnpublishAccommodationMutation = { __typename?: 'RootMutationType', unpublishAccommodation: { __typename?: 'UnpublishAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type UnregisterUserFromActivityMutationVariables = Exact<{
  input: UnregisterUserFromActivityInput;
}>;


export type UnregisterUserFromActivityMutation = { __typename?: 'RootMutationType', unregisterUserFromActivity: { __typename?: 'UnregisterUserFromActivityPayload', activityAttendance: { __typename?: 'ActivityAttendance', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } } };

export type UnrejectUserMutationVariables = Exact<{
  input: UnrejectUserInput;
}>;


export type UnrejectUserMutation = { __typename?: 'RootMutationType', unrejectUser: { __typename?: 'UnrejectUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UnvisitAccommodationMutationVariables = Exact<{
  input: UnvisitAccommodationInput;
}>;


export type UnvisitAccommodationMutation = { __typename?: 'RootMutationType', unvisitAccommodation: { __typename?: 'UnvisitAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type UpdateAccommodationMutationVariables = Exact<{
  input: UpdateAccommodationInput;
}>;


export type UpdateAccommodationMutation = { __typename?: 'RootMutationType', updateAccommodation: { __typename?: 'UpdateAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type UpdateAccommodationMaxRequestCountMutationVariables = Exact<{
  input: UpdateAccommodationMaxRequestCountInput;
}>;


export type UpdateAccommodationMaxRequestCountMutation = { __typename?: 'RootMutationType', updateAccommodationMaxRequestCount: { __typename?: 'UpdateAccommodationMaxRequestCountPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type UpdateActivityMutationVariables = Exact<{
  input: UpdateActivityInput;
}>;


export type UpdateActivityMutation = { __typename?: 'RootMutationType', updateActivity: { __typename?: 'UpdateActivityPayload', activity: { __typename?: 'Activity', id: string, description: string, mobileExclusive: boolean, headline: string, duration: number, location: string, scene: ActivitySceneTypes, class: ActivityClasses, maxAttendees: number, attendeeCount: number, organizerName: string, name: string, startTime: string, publicationTime: string, timezone: string, insertedAt: string, type: ActivityTypes, categories: Array<{ __typename?: 'Category', id: string, name: string }>, picture: { __typename?: 'Picture', id: string, url: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } };

export type UpdateActivityPictureMutationVariables = Exact<{
  input: UpdateActivityPictureInput;
}>;


export type UpdateActivityPictureMutation = { __typename?: 'RootMutationType', updateActivityPicture: { __typename?: 'UpdateActivityPicturePayload', activity: { __typename?: 'Activity', id: string, picture: { __typename?: 'Picture', id: string, url: string } } } };

export type UpdateBookingMutationVariables = Exact<{
  input: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'RootMutationType', updateBooking: { __typename?: 'UpdateBookingPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type UpdateBookingNpsMutationVariables = Exact<{
  input: UpdateBookingNpsInput;
}>;


export type UpdateBookingNpsMutation = { __typename?: 'RootMutationType', updateBookingNps: { __typename?: 'UpdateBookingNpsPayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type UpdateBookingPriceMutationVariables = Exact<{
  input: UpdateBookingPriceInput;
}>;


export type UpdateBookingPriceMutation = { __typename?: 'RootMutationType', updateBookingPrice: { __typename?: 'UpdateBookingPricePayload', booking: { __typename?: 'Booking', id: string, roomId: string, guestStartNps: number, guestEndNps: number, hostStartNps: number, hostEndNps: number, currentStage: BookingStages, status: BookingStatuses, startDate: string, endDate: string, depositPaidAt: string, terminatedAt: string, cancelledAt: string, insertedAt: string, cancelledById: string, terminatedById: string, endReason: string, privateEndReason: string, rental: { __typename?: 'Rental', id: string, startDate: string, endDate: string, hostFixedFee: number, hostVariableFee: number, guestFixedFee: number, guestVariableFee: number, priceInCents: number, currency: string, bookingId: string, addressLineOne: string, addressLineTwo: string, postalCode: string, city: string, countryIsoCode: string, description: string, cancelledAt: string, terminatedAt: string, stripePaymentIntentId: string }, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, currentPhase: { __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, phases: Array<{ __typename?: 'BookingPhase', endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, endedAt: string, guestFixedFee: number, guestVariableFee: number, hostFixedFee: number, hostVariableFee: number, id: string, insertedAt: string, priceChangedAt: string, priceChangedById: string, rescheduledAt: string, rescheduledById: string, startDate: string, terminatedAt: string, terminatedById: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }>, bookingConfirmation: { __typename?: 'BookingConfirmation', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, bookingRequest: { __typename?: 'BookingRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } }, contactRequest: { __typename?: 'ContactRequest', acceptedAt: string, acceptedById: string, endReason: string, privateEndReason: string, cancelledAt: string, cancelledById: string, endDate: string, id: string, insertedAt: string, rejectedAt: string, rejectedById: string, startDate: string, price: { __typename?: 'Price', amount: number, currency: CurrencyType } } } } };

export type UpdateBookingReportMutationVariables = Exact<{
  input: UpdateBookingReportInput;
}>;


export type UpdateBookingReportMutation = { __typename?: 'RootMutationType', updateBookingReport: { __typename?: 'UpdateBookingReportPayload', bookingReport: { __typename?: 'BookingReport', id: string, bookingId: string, bookingStatus: BookingReportBookingStatus, endTriggeredBy: string, noticeGiven: boolean, guestRehoused: boolean, hostHasNewGuest: boolean, hostStillRenting: boolean, endReason: BookingEndReasons, couldHaveBeenPrevented: boolean, comment: string, hostDesiredRetention: boolean, topHost: boolean, issueWithHost: IssuesWithHost } } };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'RootMutationType', updateCategory: { __typename?: 'UpdateCategoryPayload', category: { __typename?: 'Category', id: string, insertedAt: string, name: string } } };

export type UpdateCharterMutationVariables = Exact<{
  input: UpdateCharterInput;
}>;


export type UpdateCharterMutation = { __typename?: 'RootMutationType', updateCharter: { __typename?: 'UpdateCharterPayload', charter: { __typename?: 'Charter', canInviteFriends: boolean, canInviteFriendsForASleepover: boolean, canInvitePartner: boolean, canInviteFamily: boolean, canSmoke: boolean, canDrinkAlcohol: boolean, canReceiveDeliveries: boolean, comment: string, id: string, insertedAt: string, updatedAt: string, accommodationId: string, hostId: string, additionalElements: Array<{ __typename?: 'CharterElement', title: string, authorized: boolean }> } } };

export type UpdatePlaceMutationVariables = Exact<{
  input: UpdatePlaceInput;
}>;


export type UpdatePlaceMutation = { __typename?: 'RootMutationType', updatePlace: { __typename?: 'UpdatePlacePayload', place: { __typename?: 'Place', id: string, city: string, country: string, formattedAddress: string, latitude: number, longitude: number, name: string, postalCode: string, types: Array<string>, insertedAt: string, updatedAt: string } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, role: { __typename?: 'Host', id: string, photographerRequestSentAt: string, photographerRequestedAt: string, photographerRequestDispatchDelayInSeconds: number }, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UpdateUserAvatarMutationVariables = Exact<{
  input: UpdateUserAvatarInput;
}>;


export type UpdateUserAvatarMutation = { __typename?: 'RootMutationType', updateUserAvatar: { __typename?: 'UpdateUserAvatarPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UpdateUserCompatibilityMutationVariables = Exact<{
  input: UpdateUserCompatibilityInput;
}>;


export type UpdateUserCompatibilityMutation = { __typename?: 'RootMutationType', updateUserCompatibility: { __typename?: 'UpdateUserCompatibilityPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UpdateUserOnboardingMutationVariables = Exact<{
  input: UpdateUserOnboardingInput;
}>;


export type UpdateUserOnboardingMutation = { __typename?: 'RootMutationType', updateUserOnboarding: { __typename?: 'UpdateUserOnboardingPayload', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } } };

export type UpdateUserReviewMutationVariables = Exact<{
  input: UpdateUserReviewInput;
}>;


export type UpdateUserReviewMutation = { __typename?: 'RootMutationType', updateUserReview: { __typename?: 'UpdateUserReviewPayload', userReview: { __typename?: 'UserReview', id: string, comment: string, rating: number, insertedAt: string, updatedAt: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName: string }, reviewee: { __typename?: 'User', id: string, firstName: string, lastName: string } } } };

export type UserAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserAccountQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, account: { __typename?: 'Account', id: string, balance: number, reserved: number, currency: AccountCurrencies, upperLimit: number, lowerLimit: number, entries: { __typename?: 'EntryConnection', count: number, edges: Array<{ __typename?: 'EntryEdge', node: { __typename?: 'Entry', id: string, type: EntryTypes, amount: number, event: EntryEvents, communication: string, resourceId: string, resourceType: string, resourceDescription: string, hold: boolean, sequenceNumber: number, linkedEntryId: string, insertedAt: string } }> } }, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } } };

export type UserFieldsFragment = { __typename?: 'User', id: string, activatedAt: string, onboarded: boolean, eligible: boolean, complete: boolean, bannedAt: string, baptizedAt: string, email: string, emailConfirmedAt: string, firstName: string, lastName: string, leadSource: LeadSource, leadSourceDetail: LeadSourceDetail, registrationChannel: string, locale: string, insertedAt: string, updatedAt: string, phoneNumber: string, phoneNumberConfirmedAt: string, rejectedAt: string, rejectionReason: string, status: string, type: Roles, memberType: MemberTypes, followUpStatus: FollowUpStatus, identity: { __typename?: 'Identity', id: string, verified: boolean, verifiedAt: string, verificationRequestedAt: string }, compatibility: { __typename?: 'UserCompatibility', cleanlinessPreference: CleanlinessPreferences, desiredHousematePersonalityTraits: DesiredHousematePersonalityTraits, genderPreference: GenderPreferences, homeworkingFrequency: HomeworkingFrequencies, houseSharingExpectations: HouseSharingExpectations, houseSharingReasons: HouseSharingReasons, id: string, kitchenUse: KitchenUseFrequencies, languagePreference: LanguagePreferences }, onboarding: { __typename?: 'UserOnboarding', partnershipCode: string, familyUnderstandsIntergenerationalHouseSharing: boolean, hasDependentChildren: boolean, expectationsAndWishes: string, personalHistory: string, alreadyRentedARoom: boolean, alreadyHouseShared: boolean, pastRentingExperience: string, pastHousingExperience: string, housingAssistanceAccepted: boolean, internalAbout: string, internalHobbies: string, internalLifestyle: string, internalStudyAndWork: string, concerns: string, desiredLocation: DesiredLocationOptions, oldEnough: boolean, availableRoomCount: number, coletteContractAccepted: boolean, colettePaymentAccepted: boolean, accessToCommonAreasGiven: boolean, coletteFeesAccepted: boolean, allChargesIncludedPolicyAccepted: boolean, comment: string, startDate: string, durationInDays: number, goodFirstImpression: boolean, wellBehaving: boolean, profileCategory: ProfileCategories, cleanAndTidyFlat: boolean, roomInReadinessForGuest: boolean, mainResidence: boolean, budget: { __typename?: 'Price', amount: number, currency: CurrencyType }, hostedPeople: { __typename?: 'HostedPeople', family: boolean, parent: boolean, friend: boolean, cohabitant: boolean, other: string }, referencePerson: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string }, emergencyContact: { __typename?: 'ContactInformation', firstName: string, lastName: string, email: string, phoneNumber: string } }, profile: { __typename?: 'Profile', id: string, hobbies: string, gender: Gender, birthdate: string, becameAmbassadorAt: string, completionScore: number, about: string, linkedin: string, maritalStatus: MaritalStatuses, nationality: Nationalities, numberOfChildren: number, organization: string, ownerOrTenant: OwnerOrTenantOptions, placeOfResidence: string, secondPhoneNumber: string, studyAndWork: string, workSituation: WorkSituations, aboutSecondPhoneNumber: string, idCardOrPassportUrl: string, workOrSchoolCertificateUrl: string, visaUrl: string, postalAddress: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, formattedAddress: string, city: string, postalCode: string, latitude: number, longitude: number, countryIsoCode: string }, avatar: { __typename?: 'Avatar', public: boolean, name: string, url: string }, personalityTraits: { __typename?: 'PersonalityTraits', demanding: boolean, direct: boolean, impulsive: boolean, independent: boolean, patient: boolean, quiet: boolean, reserved: boolean, sociable: boolean, thoughtful: boolean }, spokenLanguages: { __typename?: 'Languages', english: boolean, french: boolean, german: boolean, italian: boolean, other: string, portuguese: boolean, spanish: boolean }, video: { __typename?: 'Video', url: string, name: string } }, activeClubSubscription: { __typename?: 'ClubSubscription', cancelAt: string, cancelledAt: string, createdAt: string, id: string, scope: string, status: SubscriptionStatuses, price: { __typename?: 'Price', currency: CurrencyType, amount: number } } };

export type UserReviewFieldsFragment = { __typename?: 'UserReview', id: string, comment: string, rating: number, insertedAt: string, updatedAt: string, reviewer: { __typename?: 'User', id: string, firstName: string, lastName: string }, reviewee: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type ValidateAccommodationProfessionalPicturesMutationVariables = Exact<{
  input: ValidateAccommodationProfessionalPicturesInput;
}>;


export type ValidateAccommodationProfessionalPicturesMutation = { __typename?: 'RootMutationType', validateAccommodationProfessionalPictures: { __typename?: 'ValidateAccommodationProfessionalPicturesPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export type VisitAccommodationMutationVariables = Exact<{
  input: VisitAccommodationInput;
}>;


export type VisitAccommodationMutation = { __typename?: 'RootMutationType', visitAccommodation: { __typename?: 'VisitAccommodationPayload', accommodation: { __typename?: 'Accommodation', id: string, isEligibleForHousingAssistance: boolean, maxRequestCount: number, area: Areas, guestFixedFee: number, hostVariableFee: number, visitedAt: string, archivedAt: string, completedAt: string, professionalPicturesValidatedAt: string, published: boolean, headline: string, subheading: string, description: string, housingType: HousingType, accommodationType: AccommodationType, availableFrom: string, comment: string, size: number, sharedSize: number, generalState: string, meetsSafetyStandards: boolean, t3OrBigger: boolean, privateRoomForGuest: boolean, atLeastNineSqmRoom: boolean, numberOfRoomsAccessibleToGuest: number, roomAvailable: boolean, schoolYear: boolean, numberOfBedrooms: number, insertedAt: string, updatedAt: string, equipment: Array<EquipmentType>, genderPreference: GenderPreferences, languagePreference: LanguagePreferences, homeworkingFrequencyPreference: HomeworkingFrequencies, kitchenUsePreference: KitchenUseFrequencies, price: { __typename?: 'Price', amount: number, currency: CurrencyType }, featuredPicture: { __typename?: 'Picture', id: string, url: string }, pictures: Array<{ __typename?: 'Picture', id: string, isFeatured: boolean, url: string }>, location: { __typename?: 'Location', addressLineOne: string, addressLineTwo: string, addressSupplement: string, city: string, countryIsoCode: string, formattedAddress: string, latitude: number, id: string, longitude: number, postalCode: string }, privateRooms: Array<{ __typename?: 'Rooms', name: string, picture: { __typename?: 'Picture', id: string, url: string } }>, room: { __typename?: 'Room', size: number, lock: { __typename?: 'Lock', isAvailable: boolean }, balcony: { __typename?: 'Balcony', isAvailable: boolean }, bathroom: { __typename?: 'Bathroom', isAvailable: boolean, hasBathtub: boolean, hasShower: boolean }, bed: { __typename?: 'Bed', bedding: string, hasDuvet: boolean, hasBlanket: boolean }, flooring: { __typename?: 'Flooring', hasParquet: boolean, hasCarpet: boolean, hasTiles: boolean, other: string }, furniture: { __typename?: 'Furniture', hasDesk: boolean, hasBedsideTable: boolean, hasChair: boolean, hasLight: boolean }, kitchen: { __typename?: 'Kitchen', isAvailable: boolean }, services: { __typename?: 'Services', cleaning: boolean, halfBoard: boolean }, storage: { __typename?: 'Storage', hasWardrobe: boolean, hasDresser: boolean, hasBookshelf: boolean }, toilet: { __typename?: 'Toilet', isAvailable: boolean }, windows: { __typename?: 'Windows', type: string, count: number } }, animals: { __typename?: 'Animals', cat: boolean, dog: boolean, other: string }, sharedRooms: Array<{ __typename?: 'Rooms', name: string }>, rentDuration: { __typename?: 'RentDuration', lessThanThreeMonths: boolean, betweenThreeAndSixMonths: boolean, moreThanSixMonths: boolean } } } };

export const AccommodationFieldsFragmentDoc = gql`
    fragment AccommodationFields on Accommodation {
  id
  isEligibleForHousingAssistance
  price {
    amount
    currency
  }
  maxRequestCount
  area
  guestFixedFee
  hostVariableFee
  visitedAt
  archivedAt
  completedAt
  professionalPicturesValidatedAt
  published
  headline
  subheading
  description
  housingType
  accommodationType
  availableFrom
  comment
  size
  sharedSize
  generalState
  meetsSafetyStandards
  t3OrBigger
  privateRoomForGuest
  atLeastNineSqmRoom
  numberOfRoomsAccessibleToGuest
  roomAvailable
  schoolYear
  numberOfBedrooms
  insertedAt
  updatedAt
  featuredPicture {
    id
    url
  }
  pictures {
    id
    isFeatured
    url
  }
  location {
    addressLineOne
    addressLineTwo
    addressSupplement
    city
    countryIsoCode
    formattedAddress
    latitude
    id
    longitude
    postalCode
  }
  privateRooms {
    name
    picture {
      id
      url
    }
  }
  room {
    size
    lock {
      isAvailable
    }
    balcony {
      isAvailable
    }
    bathroom {
      isAvailable
      hasBathtub
      hasShower
    }
    bed {
      bedding
      hasDuvet
      hasBlanket
    }
    flooring {
      hasParquet
      hasCarpet
      hasTiles
      other
    }
    furniture {
      hasDesk
      hasBedsideTable
      hasChair
      hasLight
    }
    kitchen {
      isAvailable
    }
    services {
      cleaning
      halfBoard
    }
    storage {
      hasWardrobe
      hasDresser
      hasBookshelf
    }
    toilet {
      isAvailable
    }
    windows {
      type
      count
    }
  }
  equipment
  animals {
    cat
    dog
    other
  }
  sharedRooms {
    name
  }
  genderPreference
  languagePreference
  homeworkingFrequencyPreference
  kitchenUsePreference
  rentDuration {
    lessThanThreeMonths
    betweenThreeAndSixMonths
    moreThanSixMonths
  }
}
    `;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  id
  balance
  reserved
  currency
  upperLimit
  lowerLimit
}
    `;
export const ActivityFieldsFragmentDoc = gql`
    fragment ActivityFields on Activity {
  id
  description
  mobileExclusive
  headline
  duration
  location
  scene
  categories {
    id
    name
  }
  class
  maxAttendees
  attendeeCount
  organizerName
  name
  picture {
    id
    url
  }
  price {
    amount
    currency
  }
  startTime
  publicationTime
  timezone
  insertedAt
  type
}
    `;
export const BookingPhaseFieldsFragmentDoc = gql`
    fragment BookingPhaseFields on BookingPhase {
  endReason
  privateEndReason
  cancelledAt
  cancelledById
  endDate
  endedAt
  guestFixedFee
  guestVariableFee
  hostFixedFee
  hostVariableFee
  id
  insertedAt
  price {
    amount
    currency
  }
  priceChangedAt
  priceChangedById
  rescheduledAt
  rescheduledById
  startDate
  terminatedAt
  terminatedById
}
    `;
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  roomId
  price {
    amount
    currency
  }
  guestStartNps
  guestEndNps
  hostStartNps
  hostEndNps
  currentStage
  status
  startDate
  endDate
  depositPaidAt
  terminatedAt
  cancelledAt
  insertedAt
  cancelledById
  terminatedById
  endReason
  privateEndReason
  currentPhase {
    ...BookingPhaseFields
  }
  phases {
    ...BookingPhaseFields
  }
  bookingConfirmation {
    acceptedAt
    acceptedById
    endReason
    privateEndReason
    cancelledAt
    cancelledById
    endDate
    id
    insertedAt
    price {
      amount
      currency
    }
    rejectedAt
    rejectedById
    startDate
  }
  bookingRequest {
    acceptedAt
    acceptedById
    endReason
    privateEndReason
    cancelledAt
    cancelledById
    endDate
    id
    insertedAt
    price {
      amount
      currency
    }
    rejectedAt
    rejectedById
    startDate
  }
  contactRequest {
    acceptedAt
    acceptedById
    endReason
    privateEndReason
    cancelledAt
    cancelledById
    endDate
    id
    insertedAt
    price {
      amount
      currency
    }
    rejectedAt
    rejectedById
    startDate
  }
}
    ${BookingPhaseFieldsFragmentDoc}`;
export const BookingReportFieldsFragmentDoc = gql`
    fragment BookingReportFields on BookingReport {
  id
  bookingId
  bookingStatus
  endTriggeredBy
  noticeGiven
  guestRehoused
  hostHasNewGuest
  hostStillRenting
  endReason
  couldHaveBeenPrevented
  comment
  hostDesiredRetention
  topHost
  issueWithHost
}
    `;
export const CharterFieldsFragmentDoc = gql`
    fragment CharterFields on Charter {
  canInviteFriends
  canInviteFriendsForASleepover
  canInvitePartner
  canInviteFamily
  canSmoke
  canDrinkAlcohol
  canReceiveDeliveries
  comment
  additionalElements {
    title
    authorized
  }
  id
  insertedAt
  updatedAt
  accommodationId
  hostId
}
    `;
export const ClubSubscriptionFieldsFragmentDoc = gql`
    fragment ClubSubscriptionFields on ClubSubscription {
  id
  createdAt
  cancelledAt
  cancelAt
  status
  scope
  userId
  price {
    amount
    currency
  }
  stripeData {
    customerId
    subscriptionId
  }
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  id
  body
  insertedAt
  updatedAt
  author {
    id
    firstName
    lastName
    profile {
      avatar {
        url
      }
    }
  }
}
    `;
export const CustomerFieldsFragmentDoc = gql`
    fragment CustomerFields on Customer {
  id
  insertedAt
  updatedAt
  hasStripeAccount
  stripeLinks {
    name
    url
  }
}
    `;
export const EntryFieldsFragmentDoc = gql`
    fragment EntryFields on Entry {
  id
  type
  amount
  event
  communication
  resourceId
  resourceType
  resourceDescription
  hold
  sequenceNumber
  linkedEntryId
  insertedAt
}
    `;
export const GiftFieldsFragmentDoc = gql`
    fragment GiftFields on Gift {
  id
  name
  duration
  durationInMonths
  buyerName
  buyerEmail
  recipientName
  recipientEmail
  message
  deliverAt
  deliveredAt
  deletedAt
  redeemBy
  redeemedAt
  code
  amountOff {
    amount
    currency
  }
  percentOff
}
    `;
export const HostFieldsFragmentDoc = gql`
    fragment HostFields on Host {
  id
  photographerRequestSentAt
  photographerRequestedAt
  photographerRequestDispatchDelayInSeconds
}
    `;
export const PaymentDisputeFieldsFragmentDoc = gql`
    fragment PaymentDisputeFields on PaymentDispute {
  id
  status
  reason
  insertedAt
  stripePaymentIntentId
  price {
    amount
    currency
  }
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  rentalId
  insertedAt
  updatedAt
  stripeCreated
  status
  description
  amountInCents
  currency
  applicationFeeAmount
  stripeCustomerId
}
    `;
export const PlaceFieldsFragmentDoc = gql`
    fragment PlaceFields on Place {
  id
  city
  country
  formattedAddress
  latitude
  longitude
  name
  postalCode
  types
  insertedAt
  updatedAt
}
    `;
export const RecommendationFieldsFragmentDoc = gql`
    fragment RecommendationFields on Recommendation {
  id
  about
  acceptedAt
  insertedAt
  published
  publishedAt
  recommenderEmail
  recommenderFirstName
  recommenderLastName
  rejectedAt
  rejectionReason
  relationship
  status
}
    `;
export const RentalDiscountFragmentDoc = gql`
    fragment RentalDiscount on RentalDiscount {
  amountOff
  currency
  guestFixedFee
  guestVariableFee
  hostFixedFee
  hostVariableFee
  id
  maxApplications
  percentOff
  rentalId
  timesApplied
  insertedAt
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const RentalFieldsFragmentDoc = gql`
    fragment RentalFields on Rental {
  id
  startDate
  endDate
  hostFixedFee
  hostVariableFee
  guestFixedFee
  guestVariableFee
  priceInCents
  currency
  bookingId
  addressLineOne
  addressLineTwo
  postalCode
  city
  countryIsoCode
  description
  cancelledAt
  terminatedAt
  stripePaymentIntentId
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  activatedAt
  onboarded
  eligible
  complete
  bannedAt
  baptizedAt
  email
  emailConfirmedAt
  firstName
  lastName
  leadSource
  leadSourceDetail
  registrationChannel
  locale
  insertedAt
  updatedAt
  phoneNumber
  phoneNumberConfirmedAt
  rejectedAt
  rejectionReason
  status
  type
  memberType
  followUpStatus
  identity {
    id
    verified
    verifiedAt
    verificationRequestedAt
  }
  compatibility {
    cleanlinessPreference
    desiredHousematePersonalityTraits
    genderPreference
    homeworkingFrequency
    houseSharingExpectations
    houseSharingReasons
    id
    kitchenUse
    languagePreference
  }
  onboarding {
    partnershipCode
    familyUnderstandsIntergenerationalHouseSharing
    hasDependentChildren
    expectationsAndWishes
    personalHistory
    alreadyRentedARoom
    alreadyHouseShared
    pastRentingExperience
    pastHousingExperience
    housingAssistanceAccepted
    internalAbout
    internalHobbies
    internalLifestyle
    internalStudyAndWork
    concerns
    desiredLocation
    oldEnough
    availableRoomCount
    coletteContractAccepted
    colettePaymentAccepted
    accessToCommonAreasGiven
    coletteFeesAccepted
    allChargesIncludedPolicyAccepted
    comment
    budget {
      amount
      currency
    }
    startDate
    durationInDays
    hostedPeople {
      family
      parent
      friend
      cohabitant
      other
    }
    referencePerson {
      firstName
      lastName
      email
      phoneNumber
    }
    emergencyContact {
      firstName
      lastName
      email
      phoneNumber
    }
    goodFirstImpression
    wellBehaving
    profileCategory
    cleanAndTidyFlat
    roomInReadinessForGuest
    mainResidence
  }
  profile {
    id
    hobbies
    gender
    birthdate
    becameAmbassadorAt
    completionScore
    postalAddress {
      addressLineOne
      addressLineTwo
      addressSupplement
      formattedAddress
      city
      postalCode
      latitude
      longitude
      countryIsoCode
    }
    avatar {
      public
      name
      url
    }
    about
    linkedin
    maritalStatus
    nationality
    numberOfChildren
    organization
    ownerOrTenant
    personalityTraits {
      demanding
      direct
      impulsive
      independent
      patient
      quiet
      reserved
      sociable
      thoughtful
    }
    placeOfResidence
    secondPhoneNumber
    spokenLanguages {
      english
      french
      german
      italian
      other
      portuguese
      spanish
    }
    studyAndWork
    video {
      url
      name
    }
    workSituation
    aboutSecondPhoneNumber
    idCardOrPassportUrl
    workOrSchoolCertificateUrl
    visaUrl
  }
  activeClubSubscription {
    cancelAt
    cancelledAt
    createdAt
    id
    price {
      currency
      amount
    }
    scope
    status
  }
}
    `;
export const UserReviewFieldsFragmentDoc = gql`
    fragment UserReviewFields on UserReview {
  id
  comment
  rating
  insertedAt
  updatedAt
  reviewer {
    id
    firstName
    lastName
  }
  reviewee {
    id
    firstName
    lastName
  }
}
    `;
export const AcceptBookingStageDocument = gql`
    mutation AcceptBookingStage($input: AcceptBookingStageInput!) {
  acceptBookingStage(input: $input) {
    booking {
      ...BookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}`;
export type AcceptBookingStageMutationFn = Apollo.MutationFunction<AcceptBookingStageMutation, AcceptBookingStageMutationVariables>;

/**
 * __useAcceptBookingStageMutation__
 *
 * To run a mutation, you first call `useAcceptBookingStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptBookingStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptBookingStageMutation, { data, loading, error }] = useAcceptBookingStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptBookingStageMutation(baseOptions?: Apollo.MutationHookOptions<AcceptBookingStageMutation, AcceptBookingStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptBookingStageMutation, AcceptBookingStageMutationVariables>(AcceptBookingStageDocument, options);
      }
export type AcceptBookingStageMutationHookResult = ReturnType<typeof useAcceptBookingStageMutation>;
export type AcceptBookingStageMutationResult = Apollo.MutationResult<AcceptBookingStageMutation>;
export type AcceptBookingStageMutationOptions = Apollo.BaseMutationOptions<AcceptBookingStageMutation, AcceptBookingStageMutationVariables>;
export const ActivateUserDocument = gql`
    mutation ActivateUser($input: ActivateUserInput!) {
  activateUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const AddAccommodationPicturesDocument = gql`
    mutation AddAccommodationPictures($input: AddAccommodationPicturesInput!) {
  addAccommodationPictures(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type AddAccommodationPicturesMutationFn = Apollo.MutationFunction<AddAccommodationPicturesMutation, AddAccommodationPicturesMutationVariables>;

/**
 * __useAddAccommodationPicturesMutation__
 *
 * To run a mutation, you first call `useAddAccommodationPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccommodationPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccommodationPicturesMutation, { data, loading, error }] = useAddAccommodationPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccommodationPicturesMutation(baseOptions?: Apollo.MutationHookOptions<AddAccommodationPicturesMutation, AddAccommodationPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccommodationPicturesMutation, AddAccommodationPicturesMutationVariables>(AddAccommodationPicturesDocument, options);
      }
export type AddAccommodationPicturesMutationHookResult = ReturnType<typeof useAddAccommodationPicturesMutation>;
export type AddAccommodationPicturesMutationResult = Apollo.MutationResult<AddAccommodationPicturesMutation>;
export type AddAccommodationPicturesMutationOptions = Apollo.BaseMutationOptions<AddAccommodationPicturesMutation, AddAccommodationPicturesMutationVariables>;
export const AddCommentDocument = gql`
    mutation AddComment($input: AddCommentInput!) {
  addComment(input: $input) {
    comment {
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const ApplyEntryDocument = gql`
    mutation ApplyEntry($input: ApplyEntryInput!) {
  applyEntry(input: $input) {
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type ApplyEntryMutationFn = Apollo.MutationFunction<ApplyEntryMutation, ApplyEntryMutationVariables>;

/**
 * __useApplyEntryMutation__
 *
 * To run a mutation, you first call `useApplyEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyEntryMutation, { data, loading, error }] = useApplyEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyEntryMutation(baseOptions?: Apollo.MutationHookOptions<ApplyEntryMutation, ApplyEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyEntryMutation, ApplyEntryMutationVariables>(ApplyEntryDocument, options);
      }
export type ApplyEntryMutationHookResult = ReturnType<typeof useApplyEntryMutation>;
export type ApplyEntryMutationResult = Apollo.MutationResult<ApplyEntryMutation>;
export type ApplyEntryMutationOptions = Apollo.BaseMutationOptions<ApplyEntryMutation, ApplyEntryMutationVariables>;
export const ArchiveAccommodationDocument = gql`
    mutation ArchiveAccommodation($input: ArchiveAccommodationInput!) {
  archiveAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type ArchiveAccommodationMutationFn = Apollo.MutationFunction<ArchiveAccommodationMutation, ArchiveAccommodationMutationVariables>;

/**
 * __useArchiveAccommodationMutation__
 *
 * To run a mutation, you first call `useArchiveAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAccommodationMutation, { data, loading, error }] = useArchiveAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAccommodationMutation, ArchiveAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAccommodationMutation, ArchiveAccommodationMutationVariables>(ArchiveAccommodationDocument, options);
      }
export type ArchiveAccommodationMutationHookResult = ReturnType<typeof useArchiveAccommodationMutation>;
export type ArchiveAccommodationMutationResult = Apollo.MutationResult<ArchiveAccommodationMutation>;
export type ArchiveAccommodationMutationOptions = Apollo.BaseMutationOptions<ArchiveAccommodationMutation, ArchiveAccommodationMutationVariables>;
export const AuthenticateAdminByEmailDocument = gql`
    mutation AuthenticateAdminByEmail($input: AuthenticateAdminByEmailInput!) {
  authenticateAdminByEmail(input: $input) {
    token
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type AuthenticateAdminByEmailMutationFn = Apollo.MutationFunction<AuthenticateAdminByEmailMutation, AuthenticateAdminByEmailMutationVariables>;

/**
 * __useAuthenticateAdminByEmailMutation__
 *
 * To run a mutation, you first call `useAuthenticateAdminByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateAdminByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateAdminByEmailMutation, { data, loading, error }] = useAuthenticateAdminByEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateAdminByEmailMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateAdminByEmailMutation, AuthenticateAdminByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateAdminByEmailMutation, AuthenticateAdminByEmailMutationVariables>(AuthenticateAdminByEmailDocument, options);
      }
export type AuthenticateAdminByEmailMutationHookResult = ReturnType<typeof useAuthenticateAdminByEmailMutation>;
export type AuthenticateAdminByEmailMutationResult = Apollo.MutationResult<AuthenticateAdminByEmailMutation>;
export type AuthenticateAdminByEmailMutationOptions = Apollo.BaseMutationOptions<AuthenticateAdminByEmailMutation, AuthenticateAdminByEmailMutationVariables>;
export const BanUserDocument = gql`
    mutation BanUser($input: BanUserInput!) {
  banUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type BanUserMutationFn = Apollo.MutationFunction<BanUserMutation, BanUserMutationVariables>;

/**
 * __useBanUserMutation__
 *
 * To run a mutation, you first call `useBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserMutation, { data, loading, error }] = useBanUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBanUserMutation(baseOptions?: Apollo.MutationHookOptions<BanUserMutation, BanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanUserMutation, BanUserMutationVariables>(BanUserDocument, options);
      }
export type BanUserMutationHookResult = ReturnType<typeof useBanUserMutation>;
export type BanUserMutationResult = Apollo.MutationResult<BanUserMutation>;
export type BanUserMutationOptions = Apollo.BaseMutationOptions<BanUserMutation, BanUserMutationVariables>;
export const BaptizeUserDocument = gql`
    mutation BaptizeUser($input: BaptizeUserInput!) {
  baptizeUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type BaptizeUserMutationFn = Apollo.MutationFunction<BaptizeUserMutation, BaptizeUserMutationVariables>;

/**
 * __useBaptizeUserMutation__
 *
 * To run a mutation, you first call `useBaptizeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBaptizeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [baptizeUserMutation, { data, loading, error }] = useBaptizeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBaptizeUserMutation(baseOptions?: Apollo.MutationHookOptions<BaptizeUserMutation, BaptizeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BaptizeUserMutation, BaptizeUserMutationVariables>(BaptizeUserDocument, options);
      }
export type BaptizeUserMutationHookResult = ReturnType<typeof useBaptizeUserMutation>;
export type BaptizeUserMutationResult = Apollo.MutationResult<BaptizeUserMutation>;
export type BaptizeUserMutationOptions = Apollo.BaseMutationOptions<BaptizeUserMutation, BaptizeUserMutationVariables>;
export const CancelBookingDocument = gql`
    mutation CancelBooking($input: CancelBookingInput!) {
  cancelBooking(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type CancelBookingMutationFn = Apollo.MutationFunction<CancelBookingMutation, CancelBookingMutationVariables>;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelBookingMutation(baseOptions?: Apollo.MutationHookOptions<CancelBookingMutation, CancelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, options);
      }
export type CancelBookingMutationHookResult = ReturnType<typeof useCancelBookingMutation>;
export type CancelBookingMutationResult = Apollo.MutationResult<CancelBookingMutation>;
export type CancelBookingMutationOptions = Apollo.BaseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>;
export const CancelDepositDocument = gql`
    mutation CancelDeposit($input: CancelDepositInput!) {
  cancelDeposit(input: $input) {
    rental {
      ...RentalFields
    }
  }
}
    ${RentalFieldsFragmentDoc}`;
export type CancelDepositMutationFn = Apollo.MutationFunction<CancelDepositMutation, CancelDepositMutationVariables>;

/**
 * __useCancelDepositMutation__
 *
 * To run a mutation, you first call `useCancelDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDepositMutation, { data, loading, error }] = useCancelDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDepositMutation(baseOptions?: Apollo.MutationHookOptions<CancelDepositMutation, CancelDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDepositMutation, CancelDepositMutationVariables>(CancelDepositDocument, options);
      }
export type CancelDepositMutationHookResult = ReturnType<typeof useCancelDepositMutation>;
export type CancelDepositMutationResult = Apollo.MutationResult<CancelDepositMutation>;
export type CancelDepositMutationOptions = Apollo.BaseMutationOptions<CancelDepositMutation, CancelDepositMutationVariables>;
export const CancelPhotographerDocument = gql`
    mutation CancelPhotographer($input: CancelPhotographerInput!) {
  cancelPhotographer(input: $input) {
    host {
      ...HostFields
    }
  }
}
    ${HostFieldsFragmentDoc}`;
export type CancelPhotographerMutationFn = Apollo.MutationFunction<CancelPhotographerMutation, CancelPhotographerMutationVariables>;

/**
 * __useCancelPhotographerMutation__
 *
 * To run a mutation, you first call `useCancelPhotographerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPhotographerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPhotographerMutation, { data, loading, error }] = useCancelPhotographerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPhotographerMutation(baseOptions?: Apollo.MutationHookOptions<CancelPhotographerMutation, CancelPhotographerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPhotographerMutation, CancelPhotographerMutationVariables>(CancelPhotographerDocument, options);
      }
export type CancelPhotographerMutationHookResult = ReturnType<typeof useCancelPhotographerMutation>;
export type CancelPhotographerMutationResult = Apollo.MutationResult<CancelPhotographerMutation>;
export type CancelPhotographerMutationOptions = Apollo.BaseMutationOptions<CancelPhotographerMutation, CancelPhotographerMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    subscription {
      ...ClubSubscriptionFields
    }
  }
}
    ${ClubSubscriptionFieldsFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CategoriesDocument = gql`
    query Categories($after: String, $before: String, $filter: CategoryFilterInput, $first: Int, $last: Int) {
  categories(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    count
    edges {
      node {
        id
        name
        insertedAt
      }
    }
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const ConfirmActivityAttendanceDocument = gql`
    mutation ConfirmActivityAttendance($input: ConfirmActivityAttendanceInput!) {
  confirmActivityAttendance(input: $input) {
    activityAttendance {
      id
    }
  }
}
    `;
export type ConfirmActivityAttendanceMutationFn = Apollo.MutationFunction<ConfirmActivityAttendanceMutation, ConfirmActivityAttendanceMutationVariables>;

/**
 * __useConfirmActivityAttendanceMutation__
 *
 * To run a mutation, you first call `useConfirmActivityAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmActivityAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmActivityAttendanceMutation, { data, loading, error }] = useConfirmActivityAttendanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmActivityAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmActivityAttendanceMutation, ConfirmActivityAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmActivityAttendanceMutation, ConfirmActivityAttendanceMutationVariables>(ConfirmActivityAttendanceDocument, options);
      }
export type ConfirmActivityAttendanceMutationHookResult = ReturnType<typeof useConfirmActivityAttendanceMutation>;
export type ConfirmActivityAttendanceMutationResult = Apollo.MutationResult<ConfirmActivityAttendanceMutation>;
export type ConfirmActivityAttendanceMutationOptions = Apollo.BaseMutationOptions<ConfirmActivityAttendanceMutation, ConfirmActivityAttendanceMutationVariables>;
export const ConfirmUserEmailDocument = gql`
    mutation ConfirmUserEmail($input: ConfirmUserEmailInput!) {
  confirmUserEmail(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type ConfirmUserEmailMutationFn = Apollo.MutationFunction<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>;

/**
 * __useConfirmUserEmailMutation__
 *
 * To run a mutation, you first call `useConfirmUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserEmailMutation, { data, loading, error }] = useConfirmUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>(ConfirmUserEmailDocument, options);
      }
export type ConfirmUserEmailMutationHookResult = ReturnType<typeof useConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationResult = Apollo.MutationResult<ConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>;
export const ConfirmUserPhoneNumberDocument = gql`
    mutation ConfirmUserPhoneNumber($input: ConfirmUserPhoneNumberInput!) {
  confirmUserPhoneNumber(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type ConfirmUserPhoneNumberMutationFn = Apollo.MutationFunction<ConfirmUserPhoneNumberMutation, ConfirmUserPhoneNumberMutationVariables>;

/**
 * __useConfirmUserPhoneNumberMutation__
 *
 * To run a mutation, you first call `useConfirmUserPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserPhoneNumberMutation, { data, loading, error }] = useConfirmUserPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmUserPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUserPhoneNumberMutation, ConfirmUserPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUserPhoneNumberMutation, ConfirmUserPhoneNumberMutationVariables>(ConfirmUserPhoneNumberDocument, options);
      }
export type ConfirmUserPhoneNumberMutationHookResult = ReturnType<typeof useConfirmUserPhoneNumberMutation>;
export type ConfirmUserPhoneNumberMutationResult = Apollo.MutationResult<ConfirmUserPhoneNumberMutation>;
export type ConfirmUserPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ConfirmUserPhoneNumberMutation, ConfirmUserPhoneNumberMutationVariables>;
export const CopyAccommodationDocument = gql`
    mutation CopyAccommodation($input: CopyAccommodationInput!) {
  copyAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type CopyAccommodationMutationFn = Apollo.MutationFunction<CopyAccommodationMutation, CopyAccommodationMutationVariables>;

/**
 * __useCopyAccommodationMutation__
 *
 * To run a mutation, you first call `useCopyAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAccommodationMutation, { data, loading, error }] = useCopyAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<CopyAccommodationMutation, CopyAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAccommodationMutation, CopyAccommodationMutationVariables>(CopyAccommodationDocument, options);
      }
export type CopyAccommodationMutationHookResult = ReturnType<typeof useCopyAccommodationMutation>;
export type CopyAccommodationMutationResult = Apollo.MutationResult<CopyAccommodationMutation>;
export type CopyAccommodationMutationOptions = Apollo.BaseMutationOptions<CopyAccommodationMutation, CopyAccommodationMutationVariables>;
export const CreateAccommodationDocument = gql`
    mutation CreateAccommodation($input: CreateAccommodationInput!) {
  createAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type CreateAccommodationMutationFn = Apollo.MutationFunction<CreateAccommodationMutation, CreateAccommodationMutationVariables>;

/**
 * __useCreateAccommodationMutation__
 *
 * To run a mutation, you first call `useCreateAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccommodationMutation, { data, loading, error }] = useCreateAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccommodationMutation, CreateAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccommodationMutation, CreateAccommodationMutationVariables>(CreateAccommodationDocument, options);
      }
export type CreateAccommodationMutationHookResult = ReturnType<typeof useCreateAccommodationMutation>;
export type CreateAccommodationMutationResult = Apollo.MutationResult<CreateAccommodationMutation>;
export type CreateAccommodationMutationOptions = Apollo.BaseMutationOptions<CreateAccommodationMutation, CreateAccommodationMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    account {
      ...AccountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateActivityDocument = gql`
    mutation CreateActivity($input: CreateActivityInput!) {
  createActivity(input: $input) {
    activity {
      ...ActivityFields
    }
  }
}
    ${ActivityFieldsFragmentDoc}`;
export type CreateActivityMutationFn = Apollo.MutationFunction<CreateActivityMutation, CreateActivityMutationVariables>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityMutation, CreateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, options);
      }
export type CreateActivityMutationHookResult = ReturnType<typeof useCreateActivityMutation>;
export type CreateActivityMutationResult = Apollo.MutationResult<CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: CreateBookingInput!) {
  createBooking(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateBookingReportDocument = gql`
    mutation CreateBookingReport($input: CreateBookingReportInput!) {
  createBookingReport(input: $input) {
    bookingReport {
      ...BookingReportFields
    }
  }
}
    ${BookingReportFieldsFragmentDoc}`;
export type CreateBookingReportMutationFn = Apollo.MutationFunction<CreateBookingReportMutation, CreateBookingReportMutationVariables>;

/**
 * __useCreateBookingReportMutation__
 *
 * To run a mutation, you first call `useCreateBookingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingReportMutation, { data, loading, error }] = useCreateBookingReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingReportMutation, CreateBookingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingReportMutation, CreateBookingReportMutationVariables>(CreateBookingReportDocument, options);
      }
export type CreateBookingReportMutationHookResult = ReturnType<typeof useCreateBookingReportMutation>;
export type CreateBookingReportMutationResult = Apollo.MutationResult<CreateBookingReportMutation>;
export type CreateBookingReportMutationOptions = Apollo.BaseMutationOptions<CreateBookingReportMutation, CreateBookingReportMutationVariables>;
export const CreateCharterDocument = gql`
    mutation CreateCharter($input: CreateCharterInput!) {
  createCharter(input: $input) {
    charter {
      ...CharterFields
    }
  }
}
    ${CharterFieldsFragmentDoc}`;
export type CreateCharterMutationFn = Apollo.MutationFunction<CreateCharterMutation, CreateCharterMutationVariables>;

/**
 * __useCreateCharterMutation__
 *
 * To run a mutation, you first call `useCreateCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCharterMutation, { data, loading, error }] = useCreateCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCharterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCharterMutation, CreateCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCharterMutation, CreateCharterMutationVariables>(CreateCharterDocument, options);
      }
export type CreateCharterMutationHookResult = ReturnType<typeof useCreateCharterMutation>;
export type CreateCharterMutationResult = Apollo.MutationResult<CreateCharterMutation>;
export type CreateCharterMutationOptions = Apollo.BaseMutationOptions<CreateCharterMutation, CreateCharterMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    customer {
      ...CustomerFields
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreatePlaceDocument = gql`
    mutation CreatePlace($input: CreatePlaceInput!) {
  createPlace(input: $input) {
    place {
      ...PlaceFields
    }
  }
}
    ${PlaceFieldsFragmentDoc}`;
export type CreatePlaceMutationFn = Apollo.MutationFunction<CreatePlaceMutation, CreatePlaceMutationVariables>;

/**
 * __useCreatePlaceMutation__
 *
 * To run a mutation, you first call `useCreatePlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaceMutation, { data, loading, error }] = useCreatePlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaceMutation, CreatePlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaceMutation, CreatePlaceMutationVariables>(CreatePlaceDocument, options);
      }
export type CreatePlaceMutationHookResult = ReturnType<typeof useCreatePlaceMutation>;
export type CreatePlaceMutationResult = Apollo.MutationResult<CreatePlaceMutation>;
export type CreatePlaceMutationOptions = Apollo.BaseMutationOptions<CreatePlaceMutation, CreatePlaceMutationVariables>;
export const CreateRentalDiscountDocument = gql`
    mutation CreateRentalDiscount($input: CreateRentalDiscountInput!) {
  createRentalDiscount(input: $input) {
    rentalDiscount {
      ...RentalDiscount
    }
  }
}
    ${RentalDiscountFragmentDoc}`;
export type CreateRentalDiscountMutationFn = Apollo.MutationFunction<CreateRentalDiscountMutation, CreateRentalDiscountMutationVariables>;

/**
 * __useCreateRentalDiscountMutation__
 *
 * To run a mutation, you first call `useCreateRentalDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentalDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentalDiscountMutation, { data, loading, error }] = useCreateRentalDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRentalDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateRentalDiscountMutation, CreateRentalDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRentalDiscountMutation, CreateRentalDiscountMutationVariables>(CreateRentalDiscountDocument, options);
      }
export type CreateRentalDiscountMutationHookResult = ReturnType<typeof useCreateRentalDiscountMutation>;
export type CreateRentalDiscountMutationResult = Apollo.MutationResult<CreateRentalDiscountMutation>;
export type CreateRentalDiscountMutationOptions = Apollo.BaseMutationOptions<CreateRentalDiscountMutation, CreateRentalDiscountMutationVariables>;
export const CreateStripeAccountDocument = gql`
    mutation CreateStripeAccount($input: CreateStripeAccountInput!) {
  createStripeAccount(input: $input) {
    customer {
      ...CustomerFields
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export type CreateStripeAccountMutationFn = Apollo.MutationFunction<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;

/**
 * __useCreateStripeAccountMutation__
 *
 * To run a mutation, you first call `useCreateStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeAccountMutation, { data, loading, error }] = useCreateStripeAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>(CreateStripeAccountDocument, options);
      }
export type CreateStripeAccountMutationHookResult = ReturnType<typeof useCreateStripeAccountMutation>;
export type CreateStripeAccountMutationResult = Apollo.MutationResult<CreateStripeAccountMutation>;
export type CreateStripeAccountMutationOptions = Apollo.BaseMutationOptions<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    subscription {
      ...ClubSubscriptionFields
    }
  }
}
    ${ClubSubscriptionFieldsFragmentDoc}`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateUserReviewDocument = gql`
    mutation CreateUserReview($input: CreateUserReviewInput!) {
  createUserReview(input: $input) {
    userReview {
      ...UserReviewFields
    }
  }
}
    ${UserReviewFieldsFragmentDoc}`;
export type CreateUserReviewMutationFn = Apollo.MutationFunction<CreateUserReviewMutation, CreateUserReviewMutationVariables>;

/**
 * __useCreateUserReviewMutation__
 *
 * To run a mutation, you first call `useCreateUserReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserReviewMutation, { data, loading, error }] = useCreateUserReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserReviewMutation, CreateUserReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserReviewMutation, CreateUserReviewMutationVariables>(CreateUserReviewDocument, options);
      }
export type CreateUserReviewMutationHookResult = ReturnType<typeof useCreateUserReviewMutation>;
export type CreateUserReviewMutationResult = Apollo.MutationResult<CreateUserReviewMutation>;
export type CreateUserReviewMutationOptions = Apollo.BaseMutationOptions<CreateUserReviewMutation, CreateUserReviewMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($input: DeactivateUserInput!) {
  deactivateUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const DeleteAccommodationDocument = gql`
    mutation DeleteAccommodation($input: DeleteAccommodationInput!) {
  deleteAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type DeleteAccommodationMutationFn = Apollo.MutationFunction<DeleteAccommodationMutation, DeleteAccommodationMutationVariables>;

/**
 * __useDeleteAccommodationMutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationMutation, { data, loading, error }] = useDeleteAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccommodationMutation, DeleteAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccommodationMutation, DeleteAccommodationMutationVariables>(DeleteAccommodationDocument, options);
      }
export type DeleteAccommodationMutationHookResult = ReturnType<typeof useDeleteAccommodationMutation>;
export type DeleteAccommodationMutationResult = Apollo.MutationResult<DeleteAccommodationMutation>;
export type DeleteAccommodationMutationOptions = Apollo.BaseMutationOptions<DeleteAccommodationMutation, DeleteAccommodationMutationVariables>;
export const DeleteAccommodationPicturesDocument = gql`
    mutation DeleteAccommodationPictures($input: DeleteAccommodationPicturesInput!) {
  deleteAccommodationPictures(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type DeleteAccommodationPicturesMutationFn = Apollo.MutationFunction<DeleteAccommodationPicturesMutation, DeleteAccommodationPicturesMutationVariables>;

/**
 * __useDeleteAccommodationPicturesMutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationPicturesMutation, { data, loading, error }] = useDeleteAccommodationPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccommodationPicturesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccommodationPicturesMutation, DeleteAccommodationPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccommodationPicturesMutation, DeleteAccommodationPicturesMutationVariables>(DeleteAccommodationPicturesDocument, options);
      }
export type DeleteAccommodationPicturesMutationHookResult = ReturnType<typeof useDeleteAccommodationPicturesMutation>;
export type DeleteAccommodationPicturesMutationResult = Apollo.MutationResult<DeleteAccommodationPicturesMutation>;
export type DeleteAccommodationPicturesMutationOptions = Apollo.BaseMutationOptions<DeleteAccommodationPicturesMutation, DeleteAccommodationPicturesMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($input: DeleteCategoryInput!) {
  deleteCategory(input: $input) {
    category {
      name
      insertedAt
      id
    }
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const DeleteUserReviewDocument = gql`
    mutation DeleteUserReview($input: DeleteUserReviewInput!) {
  deleteUserReview(input: $input) {
    userReview {
      ...UserReviewFields
    }
  }
}
    ${UserReviewFieldsFragmentDoc}`;
export type DeleteUserReviewMutationFn = Apollo.MutationFunction<DeleteUserReviewMutation, DeleteUserReviewMutationVariables>;

/**
 * __useDeleteUserReviewMutation__
 *
 * To run a mutation, you first call `useDeleteUserReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserReviewMutation, { data, loading, error }] = useDeleteUserReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserReviewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserReviewMutation, DeleteUserReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserReviewMutation, DeleteUserReviewMutationVariables>(DeleteUserReviewDocument, options);
      }
export type DeleteUserReviewMutationHookResult = ReturnType<typeof useDeleteUserReviewMutation>;
export type DeleteUserReviewMutationResult = Apollo.MutationResult<DeleteUserReviewMutation>;
export type DeleteUserReviewMutationOptions = Apollo.BaseMutationOptions<DeleteUserReviewMutation, DeleteUserReviewMutationVariables>;
export const DisableRentalDiscountDocument = gql`
    mutation DisableRentalDiscount($input: DisableRentalDiscountInput!) {
  disableRentalDiscount(input: $input) {
    rentalDiscount {
      ...RentalDiscount
    }
  }
}
    ${RentalDiscountFragmentDoc}`;
export type DisableRentalDiscountMutationFn = Apollo.MutationFunction<DisableRentalDiscountMutation, DisableRentalDiscountMutationVariables>;

/**
 * __useDisableRentalDiscountMutation__
 *
 * To run a mutation, you first call `useDisableRentalDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableRentalDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableRentalDiscountMutation, { data, loading, error }] = useDisableRentalDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableRentalDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DisableRentalDiscountMutation, DisableRentalDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableRentalDiscountMutation, DisableRentalDiscountMutationVariables>(DisableRentalDiscountDocument, options);
      }
export type DisableRentalDiscountMutationHookResult = ReturnType<typeof useDisableRentalDiscountMutation>;
export type DisableRentalDiscountMutationResult = Apollo.MutationResult<DisableRentalDiscountMutation>;
export type DisableRentalDiscountMutationOptions = Apollo.BaseMutationOptions<DisableRentalDiscountMutation, DisableRentalDiscountMutationVariables>;
export const DisconfirmActivityAttendanceDocument = gql`
    mutation DisconfirmActivityAttendance($input: DisconfirmActivityAttendanceInput!) {
  disconfirmActivityAttendance(input: $input) {
    activityAttendance {
      id
    }
  }
}
    `;
export type DisconfirmActivityAttendanceMutationFn = Apollo.MutationFunction<DisconfirmActivityAttendanceMutation, DisconfirmActivityAttendanceMutationVariables>;

/**
 * __useDisconfirmActivityAttendanceMutation__
 *
 * To run a mutation, you first call `useDisconfirmActivityAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconfirmActivityAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconfirmActivityAttendanceMutation, { data, loading, error }] = useDisconfirmActivityAttendanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconfirmActivityAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<DisconfirmActivityAttendanceMutation, DisconfirmActivityAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconfirmActivityAttendanceMutation, DisconfirmActivityAttendanceMutationVariables>(DisconfirmActivityAttendanceDocument, options);
      }
export type DisconfirmActivityAttendanceMutationHookResult = ReturnType<typeof useDisconfirmActivityAttendanceMutation>;
export type DisconfirmActivityAttendanceMutationResult = Apollo.MutationResult<DisconfirmActivityAttendanceMutation>;
export type DisconfirmActivityAttendanceMutationOptions = Apollo.BaseMutationOptions<DisconfirmActivityAttendanceMutation, DisconfirmActivityAttendanceMutationVariables>;
export const DuplicateActivityDocument = gql`
    mutation DuplicateActivity($input: DuplicateActivityInput!) {
  duplicateActivity(input: $input) {
    activity {
      ...ActivityFields
    }
  }
}
    ${ActivityFieldsFragmentDoc}`;
export type DuplicateActivityMutationFn = Apollo.MutationFunction<DuplicateActivityMutation, DuplicateActivityMutationVariables>;

/**
 * __useDuplicateActivityMutation__
 *
 * To run a mutation, you first call `useDuplicateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateActivityMutation, { data, loading, error }] = useDuplicateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateActivityMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateActivityMutation, DuplicateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateActivityMutation, DuplicateActivityMutationVariables>(DuplicateActivityDocument, options);
      }
export type DuplicateActivityMutationHookResult = ReturnType<typeof useDuplicateActivityMutation>;
export type DuplicateActivityMutationResult = Apollo.MutationResult<DuplicateActivityMutation>;
export type DuplicateActivityMutationOptions = Apollo.BaseMutationOptions<DuplicateActivityMutation, DuplicateActivityMutationVariables>;
export const AccommodationDocument = gql`
    query Accommodation($id: ID!) {
  accommodation(id: $id) {
    ...AccommodationFields
    owner {
      ...UserFields
    }
    charter {
      ...CharterFields
    }
    bookings(first: 1) {
      count
      edges {
        node {
          id
        }
      }
    }
  }
}
    ${AccommodationFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${CharterFieldsFragmentDoc}`;

/**
 * __useAccommodationQuery__
 *
 * To run a query within a React component, call `useAccommodationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccommodationQuery(baseOptions: Apollo.QueryHookOptions<AccommodationQuery, AccommodationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccommodationQuery, AccommodationQueryVariables>(AccommodationDocument, options);
      }
export function useAccommodationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccommodationQuery, AccommodationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccommodationQuery, AccommodationQueryVariables>(AccommodationDocument, options);
        }
export type AccommodationQueryHookResult = ReturnType<typeof useAccommodationQuery>;
export type AccommodationLazyQueryHookResult = ReturnType<typeof useAccommodationLazyQuery>;
export type AccommodationQueryResult = Apollo.QueryResult<AccommodationQuery, AccommodationQueryVariables>;
export const ActivityDocument = gql`
    query Activity($id: ID!) {
  activity(id: $id) {
    ...ActivityFields
    attendances(first: 500) {
      count
      edges {
        node {
          id
          attendanceConfirmation
          selfRegistered
          user {
            id
            firstName
            lastName
            email
            phoneNumber
            memberType
            account {
              currency
              balance
              reserved
            }
            attendedActivitiesThisMonth
            activeClubSubscription {
              cancelAt
              cancelledAt
              createdAt
              id
              price {
                currency
                amount
              }
              scope
              status
            }
          }
        }
      }
    }
  }
}
    ${ActivityFieldsFragmentDoc}`;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityQuery(baseOptions: Apollo.QueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
      }
export function useActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
        }
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityLazyQueryHookResult = ReturnType<typeof useActivityLazyQuery>;
export type ActivityQueryResult = Apollo.QueryResult<ActivityQuery, ActivityQueryVariables>;
export const BookingDocument = gql`
    query Booking($id: ID!) {
  booking(id: $id) {
    ...BookingFields
    bookingReport {
      ...BookingReportFields
    }
    host {
      ...UserFields
    }
    guest {
      ...UserFields
    }
    rental {
      ...RentalFields
    }
    room {
      ...AccommodationFields
    }
  }
}
    ${BookingFieldsFragmentDoc}
${BookingReportFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${RentalFieldsFragmentDoc}
${AccommodationFieldsFragmentDoc}`;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const CustomerDocument = gql`
    query Customer($userId: ID!) {
  customer(userId: $userId) {
    ...CustomerFields
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const GetPaymentDisputeDocument = gql`
    query GetPaymentDispute($id: ID!) {
  paymentDispute(id: $id) {
    ...PaymentDisputeFields
    payment {
      id
      description
    }
  }
}
    ${PaymentDisputeFieldsFragmentDoc}`;

/**
 * __useGetPaymentDisputeQuery__
 *
 * To run a query within a React component, call `useGetPaymentDisputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDisputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDisputeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentDisputeQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentDisputeQuery, GetPaymentDisputeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentDisputeQuery, GetPaymentDisputeQueryVariables>(GetPaymentDisputeDocument, options);
      }
export function useGetPaymentDisputeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentDisputeQuery, GetPaymentDisputeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentDisputeQuery, GetPaymentDisputeQueryVariables>(GetPaymentDisputeDocument, options);
        }
export type GetPaymentDisputeQueryHookResult = ReturnType<typeof useGetPaymentDisputeQuery>;
export type GetPaymentDisputeLazyQueryHookResult = ReturnType<typeof useGetPaymentDisputeLazyQuery>;
export type GetPaymentDisputeQueryResult = Apollo.QueryResult<GetPaymentDisputeQuery, GetPaymentDisputeQueryVariables>;
export const GetPaymentIntentDocument = gql`
    query GetPaymentIntent($id: ID!) {
  paymentIntent(id: $id) {
    id
    description
    price {
      amount
      currency
    }
  }
}
    `;

/**
 * __useGetPaymentIntentQuery__
 *
 * To run a query within a React component, call `useGetPaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentIntentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentIntentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentIntentQuery, GetPaymentIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentIntentQuery, GetPaymentIntentQueryVariables>(GetPaymentIntentDocument, options);
      }
export function useGetPaymentIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentIntentQuery, GetPaymentIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentIntentQuery, GetPaymentIntentQueryVariables>(GetPaymentIntentDocument, options);
        }
export type GetPaymentIntentQueryHookResult = ReturnType<typeof useGetPaymentIntentQuery>;
export type GetPaymentIntentLazyQueryHookResult = ReturnType<typeof useGetPaymentIntentLazyQuery>;
export type GetPaymentIntentQueryResult = Apollo.QueryResult<GetPaymentIntentQuery, GetPaymentIntentQueryVariables>;
export const GetPlaceDocument = gql`
    query GetPlace($id: ID!) {
  place(id: $id) {
    ...PlaceFields
  }
}
    ${PlaceFieldsFragmentDoc}`;

/**
 * __useGetPlaceQuery__
 *
 * To run a query within a React component, call `useGetPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlaceQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceQuery, GetPlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceQuery, GetPlaceQueryVariables>(GetPlaceDocument, options);
      }
export function useGetPlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceQuery, GetPlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceQuery, GetPlaceQueryVariables>(GetPlaceDocument, options);
        }
export type GetPlaceQueryHookResult = ReturnType<typeof useGetPlaceQuery>;
export type GetPlaceLazyQueryHookResult = ReturnType<typeof useGetPlaceLazyQuery>;
export type GetPlaceQueryResult = Apollo.QueryResult<GetPlaceQuery, GetPlaceQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    ...UserFields
    activeClubSubscription {
      ...ClubSubscriptionFields
    }
    compatibility {
      id
      genderPreference
      languagePreference
    }
    bookings(first: 1) {
      count
      edges {
        node {
          id
        }
      }
    }
    role {
      ...HostFields
    }
    accommodations(first: 1) {
      count
      edges {
        node {
          id
        }
      }
    }
    activityAttendances(first: 50) {
      edges {
        node {
          id
          attendanceConfirmation
          activity {
            ...ActivityFields
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${ClubSubscriptionFieldsFragmentDoc}
${HostFieldsFragmentDoc}
${ActivityFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const GiftsDocument = gql`
    query Gifts($filter: GiftFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  gifts(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...GiftFields
        redeemedBy {
          ...UserFields
        }
        product {
          id
          name
          description
          price {
            amount
            currency
          }
          active
        }
      }
    }
  }
}
    ${GiftFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;

/**
 * __useGiftsQuery__
 *
 * To run a query within a React component, call `useGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGiftsQuery(baseOptions?: Apollo.QueryHookOptions<GiftsQuery, GiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftsQuery, GiftsQueryVariables>(GiftsDocument, options);
      }
export function useGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftsQuery, GiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftsQuery, GiftsQueryVariables>(GiftsDocument, options);
        }
export type GiftsQueryHookResult = ReturnType<typeof useGiftsQuery>;
export type GiftsLazyQueryHookResult = ReturnType<typeof useGiftsLazyQuery>;
export type GiftsQueryResult = Apollo.QueryResult<GiftsQuery, GiftsQueryVariables>;
export const ImpersonateUserWithMagicLinkDocument = gql`
    mutation ImpersonateUserWithMagicLink($input: ImpersonateUserWithMagicLinkInput!) {
  impersonateUserWithMagicLink(input: $input) {
    user {
      id
    }
  }
}
    `;
export type ImpersonateUserWithMagicLinkMutationFn = Apollo.MutationFunction<ImpersonateUserWithMagicLinkMutation, ImpersonateUserWithMagicLinkMutationVariables>;

/**
 * __useImpersonateUserWithMagicLinkMutation__
 *
 * To run a mutation, you first call `useImpersonateUserWithMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserWithMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserWithMagicLinkMutation, { data, loading, error }] = useImpersonateUserWithMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateUserWithMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateUserWithMagicLinkMutation, ImpersonateUserWithMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateUserWithMagicLinkMutation, ImpersonateUserWithMagicLinkMutationVariables>(ImpersonateUserWithMagicLinkDocument, options);
      }
export type ImpersonateUserWithMagicLinkMutationHookResult = ReturnType<typeof useImpersonateUserWithMagicLinkMutation>;
export type ImpersonateUserWithMagicLinkMutationResult = Apollo.MutationResult<ImpersonateUserWithMagicLinkMutation>;
export type ImpersonateUserWithMagicLinkMutationOptions = Apollo.BaseMutationOptions<ImpersonateUserWithMagicLinkMutation, ImpersonateUserWithMagicLinkMutationVariables>;
export const InvalidateAccommodationProfessionalPicturesDocument = gql`
    mutation InvalidateAccommodationProfessionalPictures($input: InvalidateAccommodationProfessionalPicturesInput!) {
  invalidateAccommodationProfessionalPictures(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type InvalidateAccommodationProfessionalPicturesMutationFn = Apollo.MutationFunction<InvalidateAccommodationProfessionalPicturesMutation, InvalidateAccommodationProfessionalPicturesMutationVariables>;

/**
 * __useInvalidateAccommodationProfessionalPicturesMutation__
 *
 * To run a mutation, you first call `useInvalidateAccommodationProfessionalPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidateAccommodationProfessionalPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidateAccommodationProfessionalPicturesMutation, { data, loading, error }] = useInvalidateAccommodationProfessionalPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvalidateAccommodationProfessionalPicturesMutation(baseOptions?: Apollo.MutationHookOptions<InvalidateAccommodationProfessionalPicturesMutation, InvalidateAccommodationProfessionalPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvalidateAccommodationProfessionalPicturesMutation, InvalidateAccommodationProfessionalPicturesMutationVariables>(InvalidateAccommodationProfessionalPicturesDocument, options);
      }
export type InvalidateAccommodationProfessionalPicturesMutationHookResult = ReturnType<typeof useInvalidateAccommodationProfessionalPicturesMutation>;
export type InvalidateAccommodationProfessionalPicturesMutationResult = Apollo.MutationResult<InvalidateAccommodationProfessionalPicturesMutation>;
export type InvalidateAccommodationProfessionalPicturesMutationOptions = Apollo.BaseMutationOptions<InvalidateAccommodationProfessionalPicturesMutation, InvalidateAccommodationProfessionalPicturesMutationVariables>;
export const ListAccommodationsDocument = gql`
    query ListAccommodations($after: String, $first: Int, $before: String, $last: Int, $filter: RoomFilterInput) {
  accommodations(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...AccommodationFields
        owner {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;

/**
 * __useListAccommodationsQuery__
 *
 * To run a query within a React component, call `useListAccommodationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccommodationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccommodationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListAccommodationsQuery(baseOptions?: Apollo.QueryHookOptions<ListAccommodationsQuery, ListAccommodationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccommodationsQuery, ListAccommodationsQueryVariables>(ListAccommodationsDocument, options);
      }
export function useListAccommodationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccommodationsQuery, ListAccommodationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccommodationsQuery, ListAccommodationsQueryVariables>(ListAccommodationsDocument, options);
        }
export type ListAccommodationsQueryHookResult = ReturnType<typeof useListAccommodationsQuery>;
export type ListAccommodationsLazyQueryHookResult = ReturnType<typeof useListAccommodationsLazyQuery>;
export type ListAccommodationsQueryResult = Apollo.QueryResult<ListAccommodationsQuery, ListAccommodationsQueryVariables>;
export const ListActivitiesDocument = gql`
    query ListActivities($after: String, $before: String, $filter: ActivityFilterInput, $first: Int, $last: Int, $orderBy: ActivityOrderByInput) {
  activities(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
    orderBy: $orderBy
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...ActivityFields
      }
    }
  }
}
    ${ActivityFieldsFragmentDoc}`;

/**
 * __useListActivitiesQuery__
 *
 * To run a query within a React component, call `useListActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ListActivitiesQuery, ListActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(ListActivitiesDocument, options);
      }
export function useListActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivitiesQuery, ListActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivitiesQuery, ListActivitiesQueryVariables>(ListActivitiesDocument, options);
        }
export type ListActivitiesQueryHookResult = ReturnType<typeof useListActivitiesQuery>;
export type ListActivitiesLazyQueryHookResult = ReturnType<typeof useListActivitiesLazyQuery>;
export type ListActivitiesQueryResult = Apollo.QueryResult<ListActivitiesQuery, ListActivitiesQueryVariables>;
export const ListBookingsDocument = gql`
    query ListBookings($after: String, $first: Int, $before: String, $last: Int, $filter: BookingFilterInput, $orderBy: BookingsOrderByInput) {
  bookings(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
    orderBy: $orderBy
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...BookingFields
        bookingReport {
          id
        }
        host {
          id
          firstName
          lastName
        }
        guest {
          id
          firstName
          lastName
        }
        rental {
          ...RentalFields
        }
        room {
          id
          headline
        }
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;

/**
 * __useListBookingsQuery__
 *
 * To run a query within a React component, call `useListBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBookingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListBookingsQuery(baseOptions?: Apollo.QueryHookOptions<ListBookingsQuery, ListBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBookingsQuery, ListBookingsQueryVariables>(ListBookingsDocument, options);
      }
export function useListBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBookingsQuery, ListBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBookingsQuery, ListBookingsQueryVariables>(ListBookingsDocument, options);
        }
export type ListBookingsQueryHookResult = ReturnType<typeof useListBookingsQuery>;
export type ListBookingsLazyQueryHookResult = ReturnType<typeof useListBookingsLazyQuery>;
export type ListBookingsQueryResult = Apollo.QueryResult<ListBookingsQuery, ListBookingsQueryVariables>;
export const ListClubSubscriptionsDocument = gql`
    query ListClubSubscriptions($after: String, $filter: SubscriptionFilterInput, $before: String, $last: Int, $first: Int) {
  subscriptions(
    after: $after
    filter: $filter
    before: $before
    last: $last
    first: $first
  ) {
    count
    edges {
      cursor
      node {
        cancelAt
        cancelledAt
        createdAt
        id
        price {
          amount
          currency
        }
        status
        user {
          firstName
          id
          lastName
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useListClubSubscriptionsQuery__
 *
 * To run a query within a React component, call `useListClubSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClubSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClubSubscriptionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListClubSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<ListClubSubscriptionsQuery, ListClubSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClubSubscriptionsQuery, ListClubSubscriptionsQueryVariables>(ListClubSubscriptionsDocument, options);
      }
export function useListClubSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClubSubscriptionsQuery, ListClubSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClubSubscriptionsQuery, ListClubSubscriptionsQueryVariables>(ListClubSubscriptionsDocument, options);
        }
export type ListClubSubscriptionsQueryHookResult = ReturnType<typeof useListClubSubscriptionsQuery>;
export type ListClubSubscriptionsLazyQueryHookResult = ReturnType<typeof useListClubSubscriptionsLazyQuery>;
export type ListClubSubscriptionsQueryResult = Apollo.QueryResult<ListClubSubscriptionsQuery, ListClubSubscriptionsQueryVariables>;
export const CommentsDocument = gql`
    query Comments($filter: CommentsFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  comments(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...CommentFields
      }
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions?: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const ListGuestUsersDocument = gql`
    query ListGuestUsers($filter: UsersFilterInput, $orderBy: UsersOrderByInput, $after: String, $first: Int, $before: String, $last: Int) {
  users(
    filter: $filter
    orderBy: $orderBy
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...UserFields
        searchCount
        bookingAsGuestCount
        lastBookingAsGuest {
          insertedAt
          id
        }
        role {
          id
          ...HostFields
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${HostFieldsFragmentDoc}`;

/**
 * __useListGuestUsersQuery__
 *
 * To run a query within a React component, call `useListGuestUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGuestUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGuestUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListGuestUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListGuestUsersQuery, ListGuestUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGuestUsersQuery, ListGuestUsersQueryVariables>(ListGuestUsersDocument, options);
      }
export function useListGuestUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGuestUsersQuery, ListGuestUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGuestUsersQuery, ListGuestUsersQueryVariables>(ListGuestUsersDocument, options);
        }
export type ListGuestUsersQueryHookResult = ReturnType<typeof useListGuestUsersQuery>;
export type ListGuestUsersLazyQueryHookResult = ReturnType<typeof useListGuestUsersLazyQuery>;
export type ListGuestUsersQueryResult = Apollo.QueryResult<ListGuestUsersQuery, ListGuestUsersQueryVariables>;
export const ListPaymentsDocument = gql`
    query ListPayments($rentalId: String, $after: String, $first: Int, $before: String, $last: Int) {
  payments(
    after: $after
    before: $before
    first: $first
    last: $last
    rentalId: $rentalId
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...PaymentFields
        paymentDispute {
          ...PaymentDisputeFields
        }
        rental {
          ...RentalFields
          guestCustomer {
            id
            firstName
            lastName
            userId
          }
          hostCustomer {
            id
            firstName
            lastName
            userId
          }
        }
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}
${PaymentDisputeFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;

/**
 * __useListPaymentsQuery__
 *
 * To run a query within a React component, call `useListPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentsQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
      }
export function useListPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
        }
export type ListPaymentsQueryHookResult = ReturnType<typeof useListPaymentsQuery>;
export type ListPaymentsLazyQueryHookResult = ReturnType<typeof useListPaymentsLazyQuery>;
export type ListPaymentsQueryResult = Apollo.QueryResult<ListPaymentsQuery, ListPaymentsQueryVariables>;
export const ListPlacesDocument = gql`
    query ListPlaces($filter: PlacesFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  places(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...PlaceFields
      }
    }
  }
}
    ${PlaceFieldsFragmentDoc}`;

/**
 * __useListPlacesQuery__
 *
 * To run a query within a React component, call `useListPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPlacesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListPlacesQuery(baseOptions?: Apollo.QueryHookOptions<ListPlacesQuery, ListPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPlacesQuery, ListPlacesQueryVariables>(ListPlacesDocument, options);
      }
export function useListPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPlacesQuery, ListPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPlacesQuery, ListPlacesQueryVariables>(ListPlacesDocument, options);
        }
export type ListPlacesQueryHookResult = ReturnType<typeof useListPlacesQuery>;
export type ListPlacesLazyQueryHookResult = ReturnType<typeof useListPlacesLazyQuery>;
export type ListPlacesQueryResult = Apollo.QueryResult<ListPlacesQuery, ListPlacesQueryVariables>;
export const ListRecommendationsDocument = gql`
    query ListRecommendations($filter: RecommendationsFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  recommendations(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...RecommendationFields
        recommendee {
          id
          type
          email
          firstName
          lastName
        }
        recommender {
          id
          type
          email
          firstName
          lastName
        }
      }
    }
  }
}
    ${RecommendationFieldsFragmentDoc}`;

/**
 * __useListRecommendationsQuery__
 *
 * To run a query within a React component, call `useListRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecommendationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<ListRecommendationsQuery, ListRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRecommendationsQuery, ListRecommendationsQueryVariables>(ListRecommendationsDocument, options);
      }
export function useListRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRecommendationsQuery, ListRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRecommendationsQuery, ListRecommendationsQueryVariables>(ListRecommendationsDocument, options);
        }
export type ListRecommendationsQueryHookResult = ReturnType<typeof useListRecommendationsQuery>;
export type ListRecommendationsLazyQueryHookResult = ReturnType<typeof useListRecommendationsLazyQuery>;
export type ListRecommendationsQueryResult = Apollo.QueryResult<ListRecommendationsQuery, ListRecommendationsQueryVariables>;
export const ListTagsDocument = gql`
    query ListTags($after: String, $before: String, $filter: TagsFilterInput, $first: Int, $last: Int) {
  tags(
    after: $after
    filter: $filter
    first: $first
    last: $last
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        id
        value
      }
    }
  }
}
    `;

/**
 * __useListTagsQuery__
 *
 * To run a query within a React component, call `useListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
      }
export function useListTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
        }
export type ListTagsQueryHookResult = ReturnType<typeof useListTagsQuery>;
export type ListTagsLazyQueryHookResult = ReturnType<typeof useListTagsLazyQuery>;
export type ListTagsQueryResult = Apollo.QueryResult<ListTagsQuery, ListTagsQueryVariables>;
export const ListUserReviewsDocument = gql`
    query ListUserReviews($filter: UserReviewFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  userReviews(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...UserReviewFields
      }
    }
  }
}
    ${UserReviewFieldsFragmentDoc}`;

/**
 * __useListUserReviewsQuery__
 *
 * To run a query within a React component, call `useListUserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserReviewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListUserReviewsQuery(baseOptions?: Apollo.QueryHookOptions<ListUserReviewsQuery, ListUserReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserReviewsQuery, ListUserReviewsQueryVariables>(ListUserReviewsDocument, options);
      }
export function useListUserReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserReviewsQuery, ListUserReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserReviewsQuery, ListUserReviewsQueryVariables>(ListUserReviewsDocument, options);
        }
export type ListUserReviewsQueryHookResult = ReturnType<typeof useListUserReviewsQuery>;
export type ListUserReviewsLazyQueryHookResult = ReturnType<typeof useListUserReviewsLazyQuery>;
export type ListUserReviewsQueryResult = Apollo.QueryResult<ListUserReviewsQuery, ListUserReviewsQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($filter: UsersFilterInput, $orderBy: UsersOrderByInput, $after: String, $first: Int, $before: String, $last: Int) {
  users(
    filter: $filter
    orderBy: $orderBy
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...UserFields
        role {
          id
          ...HostFields
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${HostFieldsFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const UsersWithBirthdayDocument = gql`
    query UsersWithBirthday {
  usersWithBirthday {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersWithBirthdayQuery__
 *
 * To run a query within a React component, call `useUsersWithBirthdayQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithBirthdayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithBirthdayQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersWithBirthdayQuery(baseOptions?: Apollo.QueryHookOptions<UsersWithBirthdayQuery, UsersWithBirthdayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersWithBirthdayQuery, UsersWithBirthdayQueryVariables>(UsersWithBirthdayDocument, options);
      }
export function useUsersWithBirthdayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersWithBirthdayQuery, UsersWithBirthdayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersWithBirthdayQuery, UsersWithBirthdayQueryVariables>(UsersWithBirthdayDocument, options);
        }
export type UsersWithBirthdayQueryHookResult = ReturnType<typeof useUsersWithBirthdayQuery>;
export type UsersWithBirthdayLazyQueryHookResult = ReturnType<typeof useUsersWithBirthdayLazyQuery>;
export type UsersWithBirthdayQueryResult = Apollo.QueryResult<UsersWithBirthdayQuery, UsersWithBirthdayQueryVariables>;
export const MakeUserAmbassadorDocument = gql`
    mutation MakeUserAmbassador($input: MakeUserAmbassadorInput!) {
  makeUserAmbassador(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type MakeUserAmbassadorMutationFn = Apollo.MutationFunction<MakeUserAmbassadorMutation, MakeUserAmbassadorMutationVariables>;

/**
 * __useMakeUserAmbassadorMutation__
 *
 * To run a mutation, you first call `useMakeUserAmbassadorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeUserAmbassadorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeUserAmbassadorMutation, { data, loading, error }] = useMakeUserAmbassadorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeUserAmbassadorMutation(baseOptions?: Apollo.MutationHookOptions<MakeUserAmbassadorMutation, MakeUserAmbassadorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeUserAmbassadorMutation, MakeUserAmbassadorMutationVariables>(MakeUserAmbassadorDocument, options);
      }
export type MakeUserAmbassadorMutationHookResult = ReturnType<typeof useMakeUserAmbassadorMutation>;
export type MakeUserAmbassadorMutationResult = Apollo.MutationResult<MakeUserAmbassadorMutation>;
export type MakeUserAmbassadorMutationOptions = Apollo.BaseMutationOptions<MakeUserAmbassadorMutation, MakeUserAmbassadorMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    firstName
    lastName
    profile {
      id
      avatar {
        url
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const OnboardUserDocument = gql`
    mutation OnboardUser($input: OnboardUserInput!) {
  onboardUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type OnboardUserMutationFn = Apollo.MutationFunction<OnboardUserMutation, OnboardUserMutationVariables>;

/**
 * __useOnboardUserMutation__
 *
 * To run a mutation, you first call `useOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUserMutation, { data, loading, error }] = useOnboardUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardUserMutation, OnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardUserMutation, OnboardUserMutationVariables>(OnboardUserDocument, options);
      }
export type OnboardUserMutationHookResult = ReturnType<typeof useOnboardUserMutation>;
export type OnboardUserMutationResult = Apollo.MutationResult<OnboardUserMutation>;
export type OnboardUserMutationOptions = Apollo.BaseMutationOptions<OnboardUserMutation, OnboardUserMutationVariables>;
export const PublishAccommodationDocument = gql`
    mutation PublishAccommodation($input: PublishAccommodationInput!) {
  publishAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type PublishAccommodationMutationFn = Apollo.MutationFunction<PublishAccommodationMutation, PublishAccommodationMutationVariables>;

/**
 * __usePublishAccommodationMutation__
 *
 * To run a mutation, you first call `usePublishAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAccommodationMutation, { data, loading, error }] = usePublishAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<PublishAccommodationMutation, PublishAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAccommodationMutation, PublishAccommodationMutationVariables>(PublishAccommodationDocument, options);
      }
export type PublishAccommodationMutationHookResult = ReturnType<typeof usePublishAccommodationMutation>;
export type PublishAccommodationMutationResult = Apollo.MutationResult<PublishAccommodationMutation>;
export type PublishAccommodationMutationOptions = Apollo.BaseMutationOptions<PublishAccommodationMutation, PublishAccommodationMutationVariables>;
export const RegisterUserToActivityDocument = gql`
    mutation RegisterUserToActivity($input: RegisterUserToActivityInput!) {
  registerUserToActivity(input: $input) {
    activityAttendance {
      user {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type RegisterUserToActivityMutationFn = Apollo.MutationFunction<RegisterUserToActivityMutation, RegisterUserToActivityMutationVariables>;

/**
 * __useRegisterUserToActivityMutation__
 *
 * To run a mutation, you first call `useRegisterUserToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserToActivityMutation, { data, loading, error }] = useRegisterUserToActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserToActivityMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserToActivityMutation, RegisterUserToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserToActivityMutation, RegisterUserToActivityMutationVariables>(RegisterUserToActivityDocument, options);
      }
export type RegisterUserToActivityMutationHookResult = ReturnType<typeof useRegisterUserToActivityMutation>;
export type RegisterUserToActivityMutationResult = Apollo.MutationResult<RegisterUserToActivityMutation>;
export type RegisterUserToActivityMutationOptions = Apollo.BaseMutationOptions<RegisterUserToActivityMutation, RegisterUserToActivityMutationVariables>;
export const RejectBookingStageDocument = gql`
    mutation RejectBookingStage($input: RejectBookingStageInput!) {
  rejectBookingStage(input: $input) {
    booking {
      ...BookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}`;
export type RejectBookingStageMutationFn = Apollo.MutationFunction<RejectBookingStageMutation, RejectBookingStageMutationVariables>;

/**
 * __useRejectBookingStageMutation__
 *
 * To run a mutation, you first call `useRejectBookingStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectBookingStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectBookingStageMutation, { data, loading, error }] = useRejectBookingStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectBookingStageMutation(baseOptions?: Apollo.MutationHookOptions<RejectBookingStageMutation, RejectBookingStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectBookingStageMutation, RejectBookingStageMutationVariables>(RejectBookingStageDocument, options);
      }
export type RejectBookingStageMutationHookResult = ReturnType<typeof useRejectBookingStageMutation>;
export type RejectBookingStageMutationResult = Apollo.MutationResult<RejectBookingStageMutation>;
export type RejectBookingStageMutationOptions = Apollo.BaseMutationOptions<RejectBookingStageMutation, RejectBookingStageMutationVariables>;
export const RejectUserDocument = gql`
    mutation RejectUser($input: RejectUserInput!) {
  rejectUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type RejectUserMutationFn = Apollo.MutationFunction<RejectUserMutation, RejectUserMutationVariables>;

/**
 * __useRejectUserMutation__
 *
 * To run a mutation, you first call `useRejectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectUserMutation, { data, loading, error }] = useRejectUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectUserMutation(baseOptions?: Apollo.MutationHookOptions<RejectUserMutation, RejectUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectUserMutation, RejectUserMutationVariables>(RejectUserDocument, options);
      }
export type RejectUserMutationHookResult = ReturnType<typeof useRejectUserMutation>;
export type RejectUserMutationResult = Apollo.MutationResult<RejectUserMutation>;
export type RejectUserMutationOptions = Apollo.BaseMutationOptions<RejectUserMutation, RejectUserMutationVariables>;
export const RemoveUserAmbassadorStatusDocument = gql`
    mutation RemoveUserAmbassadorStatus($input: RemoveUserAmbassadorStatusInput!) {
  removeUserAmbassadorStatus(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type RemoveUserAmbassadorStatusMutationFn = Apollo.MutationFunction<RemoveUserAmbassadorStatusMutation, RemoveUserAmbassadorStatusMutationVariables>;

/**
 * __useRemoveUserAmbassadorStatusMutation__
 *
 * To run a mutation, you first call `useRemoveUserAmbassadorStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserAmbassadorStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserAmbassadorStatusMutation, { data, loading, error }] = useRemoveUserAmbassadorStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserAmbassadorStatusMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserAmbassadorStatusMutation, RemoveUserAmbassadorStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserAmbassadorStatusMutation, RemoveUserAmbassadorStatusMutationVariables>(RemoveUserAmbassadorStatusDocument, options);
      }
export type RemoveUserAmbassadorStatusMutationHookResult = ReturnType<typeof useRemoveUserAmbassadorStatusMutation>;
export type RemoveUserAmbassadorStatusMutationResult = Apollo.MutationResult<RemoveUserAmbassadorStatusMutation>;
export type RemoveUserAmbassadorStatusMutationOptions = Apollo.BaseMutationOptions<RemoveUserAmbassadorStatusMutation, RemoveUserAmbassadorStatusMutationVariables>;
export const RentalDiscountsDocument = gql`
    query RentalDiscounts($after: String, $before: String, $filter: RentalDiscountFilterInput, $first: Int, $last: Int) {
  rentalDiscounts(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
    edges {
      cursor
      node {
        ...RentalDiscount
      }
    }
  }
}
    ${RentalDiscountFragmentDoc}`;

/**
 * __useRentalDiscountsQuery__
 *
 * To run a query within a React component, call `useRentalDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalDiscountsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRentalDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<RentalDiscountsQuery, RentalDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentalDiscountsQuery, RentalDiscountsQueryVariables>(RentalDiscountsDocument, options);
      }
export function useRentalDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentalDiscountsQuery, RentalDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentalDiscountsQuery, RentalDiscountsQueryVariables>(RentalDiscountsDocument, options);
        }
export type RentalDiscountsQueryHookResult = ReturnType<typeof useRentalDiscountsQuery>;
export type RentalDiscountsLazyQueryHookResult = ReturnType<typeof useRentalDiscountsLazyQuery>;
export type RentalDiscountsQueryResult = Apollo.QueryResult<RentalDiscountsQuery, RentalDiscountsQueryVariables>;
export const RequestPhotographerDocument = gql`
    mutation RequestPhotographer($input: RequestPhotographerInput!) {
  requestPhotographer(input: $input) {
    host {
      ...HostFields
    }
  }
}
    ${HostFieldsFragmentDoc}`;
export type RequestPhotographerMutationFn = Apollo.MutationFunction<RequestPhotographerMutation, RequestPhotographerMutationVariables>;

/**
 * __useRequestPhotographerMutation__
 *
 * To run a mutation, you first call `useRequestPhotographerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPhotographerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPhotographerMutation, { data, loading, error }] = useRequestPhotographerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPhotographerMutation(baseOptions?: Apollo.MutationHookOptions<RequestPhotographerMutation, RequestPhotographerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPhotographerMutation, RequestPhotographerMutationVariables>(RequestPhotographerDocument, options);
      }
export type RequestPhotographerMutationHookResult = ReturnType<typeof useRequestPhotographerMutation>;
export type RequestPhotographerMutationResult = Apollo.MutationResult<RequestPhotographerMutation>;
export type RequestPhotographerMutationOptions = Apollo.BaseMutationOptions<RequestPhotographerMutation, RequestPhotographerMutationVariables>;
export const RescheduleBookingDocument = gql`
    mutation RescheduleBooking($input: RescheduleBookingInput!) {
  rescheduleBooking(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type RescheduleBookingMutationFn = Apollo.MutationFunction<RescheduleBookingMutation, RescheduleBookingMutationVariables>;

/**
 * __useRescheduleBookingMutation__
 *
 * To run a mutation, you first call `useRescheduleBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleBookingMutation, { data, loading, error }] = useRescheduleBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleBookingMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleBookingMutation, RescheduleBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleBookingMutation, RescheduleBookingMutationVariables>(RescheduleBookingDocument, options);
      }
export type RescheduleBookingMutationHookResult = ReturnType<typeof useRescheduleBookingMutation>;
export type RescheduleBookingMutationResult = Apollo.MutationResult<RescheduleBookingMutation>;
export type RescheduleBookingMutationOptions = Apollo.BaseMutationOptions<RescheduleBookingMutation, RescheduleBookingMutationVariables>;
export const SavedAccommodationsDocument = gql`
    query SavedAccommodations($after: String, $first: Int, $before: String, $last: Int, $userId: ID!) {
  savedAccommodations(
    after: $after
    before: $before
    first: $first
    last: $last
    userId: $userId
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        id
        accommodation {
          ...AccommodationFields
          owner {
            id
            firstName
            lastName
          }
        }
        startDate
        endDate
      }
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;

/**
 * __useSavedAccommodationsQuery__
 *
 * To run a query within a React component, call `useSavedAccommodationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedAccommodationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedAccommodationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSavedAccommodationsQuery(baseOptions: Apollo.QueryHookOptions<SavedAccommodationsQuery, SavedAccommodationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedAccommodationsQuery, SavedAccommodationsQueryVariables>(SavedAccommodationsDocument, options);
      }
export function useSavedAccommodationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedAccommodationsQuery, SavedAccommodationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedAccommodationsQuery, SavedAccommodationsQueryVariables>(SavedAccommodationsDocument, options);
        }
export type SavedAccommodationsQueryHookResult = ReturnType<typeof useSavedAccommodationsQuery>;
export type SavedAccommodationsLazyQueryHookResult = ReturnType<typeof useSavedAccommodationsLazyQuery>;
export type SavedAccommodationsQueryResult = Apollo.QueryResult<SavedAccommodationsQuery, SavedAccommodationsQueryVariables>;
export const SendResetPasswordTokenDocument = gql`
    mutation SendResetPasswordToken($input: SendResetPasswordTokenInput!) {
  sendResetPasswordToken(input: $input) {
    user {
      id
    }
  }
}
    `;
export type SendResetPasswordTokenMutationFn = Apollo.MutationFunction<SendResetPasswordTokenMutation, SendResetPasswordTokenMutationVariables>;

/**
 * __useSendResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordTokenMutation, { data, loading, error }] = useSendResetPasswordTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendResetPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordTokenMutation, SendResetPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordTokenMutation, SendResetPasswordTokenMutationVariables>(SendResetPasswordTokenDocument, options);
      }
export type SendResetPasswordTokenMutationHookResult = ReturnType<typeof useSendResetPasswordTokenMutation>;
export type SendResetPasswordTokenMutationResult = Apollo.MutationResult<SendResetPasswordTokenMutation>;
export type SendResetPasswordTokenMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordTokenMutation, SendResetPasswordTokenMutationVariables>;
export const SendShortlivedTokenDocument = gql`
    mutation SendShortlivedToken($input: SendShortlivedTokenInput!) {
  sendShortlivedToken(input: $input) {
    user {
      id
    }
  }
}
    `;
export type SendShortlivedTokenMutationFn = Apollo.MutationFunction<SendShortlivedTokenMutation, SendShortlivedTokenMutationVariables>;

/**
 * __useSendShortlivedTokenMutation__
 *
 * To run a mutation, you first call `useSendShortlivedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendShortlivedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendShortlivedTokenMutation, { data, loading, error }] = useSendShortlivedTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendShortlivedTokenMutation(baseOptions?: Apollo.MutationHookOptions<SendShortlivedTokenMutation, SendShortlivedTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendShortlivedTokenMutation, SendShortlivedTokenMutationVariables>(SendShortlivedTokenDocument, options);
      }
export type SendShortlivedTokenMutationHookResult = ReturnType<typeof useSendShortlivedTokenMutation>;
export type SendShortlivedTokenMutationResult = Apollo.MutationResult<SendShortlivedTokenMutation>;
export type SendShortlivedTokenMutationOptions = Apollo.BaseMutationOptions<SendShortlivedTokenMutation, SendShortlivedTokenMutationVariables>;
export const SetFollowUpStatusDocument = gql`
    mutation SetFollowUpStatus($input: SetFollowUpStatusInput!) {
  setFollowUpStatus(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type SetFollowUpStatusMutationFn = Apollo.MutationFunction<SetFollowUpStatusMutation, SetFollowUpStatusMutationVariables>;

/**
 * __useSetFollowUpStatusMutation__
 *
 * To run a mutation, you first call `useSetFollowUpStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFollowUpStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFollowUpStatusMutation, { data, loading, error }] = useSetFollowUpStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFollowUpStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetFollowUpStatusMutation, SetFollowUpStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFollowUpStatusMutation, SetFollowUpStatusMutationVariables>(SetFollowUpStatusDocument, options);
      }
export type SetFollowUpStatusMutationHookResult = ReturnType<typeof useSetFollowUpStatusMutation>;
export type SetFollowUpStatusMutationResult = Apollo.MutationResult<SetFollowUpStatusMutation>;
export type SetFollowUpStatusMutationOptions = Apollo.BaseMutationOptions<SetFollowUpStatusMutation, SetFollowUpStatusMutationVariables>;
export const ShowcaseAccommodationPictureDocument = gql`
    mutation ShowcaseAccommodationPicture($input: ShowcaseAccommodationPictureInput!) {
  showcaseAccommodationPicture(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type ShowcaseAccommodationPictureMutationFn = Apollo.MutationFunction<ShowcaseAccommodationPictureMutation, ShowcaseAccommodationPictureMutationVariables>;

/**
 * __useShowcaseAccommodationPictureMutation__
 *
 * To run a mutation, you first call `useShowcaseAccommodationPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShowcaseAccommodationPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [showcaseAccommodationPictureMutation, { data, loading, error }] = useShowcaseAccommodationPictureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShowcaseAccommodationPictureMutation(baseOptions?: Apollo.MutationHookOptions<ShowcaseAccommodationPictureMutation, ShowcaseAccommodationPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShowcaseAccommodationPictureMutation, ShowcaseAccommodationPictureMutationVariables>(ShowcaseAccommodationPictureDocument, options);
      }
export type ShowcaseAccommodationPictureMutationHookResult = ReturnType<typeof useShowcaseAccommodationPictureMutation>;
export type ShowcaseAccommodationPictureMutationResult = Apollo.MutationResult<ShowcaseAccommodationPictureMutation>;
export type ShowcaseAccommodationPictureMutationOptions = Apollo.BaseMutationOptions<ShowcaseAccommodationPictureMutation, ShowcaseAccommodationPictureMutationVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions($filter: SubscriptionFilterInput, $after: String, $first: Int, $before: String, $last: Int) {
  subscriptions(
    filter: $filter
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        ...ClubSubscriptionFields
      }
    }
  }
}
    ${ClubSubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const TerminateBookingDocument = gql`
    mutation TerminateBooking($input: TerminateBookingInput!) {
  terminateBooking(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type TerminateBookingMutationFn = Apollo.MutationFunction<TerminateBookingMutation, TerminateBookingMutationVariables>;

/**
 * __useTerminateBookingMutation__
 *
 * To run a mutation, you first call `useTerminateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateBookingMutation, { data, loading, error }] = useTerminateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTerminateBookingMutation(baseOptions?: Apollo.MutationHookOptions<TerminateBookingMutation, TerminateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateBookingMutation, TerminateBookingMutationVariables>(TerminateBookingDocument, options);
      }
export type TerminateBookingMutationHookResult = ReturnType<typeof useTerminateBookingMutation>;
export type TerminateBookingMutationResult = Apollo.MutationResult<TerminateBookingMutation>;
export type TerminateBookingMutationOptions = Apollo.BaseMutationOptions<TerminateBookingMutation, TerminateBookingMutationVariables>;
export const UnarchiveAccommodationDocument = gql`
    mutation UnarchiveAccommodation($input: UnarchiveAccommodationInput!) {
  unarchiveAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type UnarchiveAccommodationMutationFn = Apollo.MutationFunction<UnarchiveAccommodationMutation, UnarchiveAccommodationMutationVariables>;

/**
 * __useUnarchiveAccommodationMutation__
 *
 * To run a mutation, you first call `useUnarchiveAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveAccommodationMutation, { data, loading, error }] = useUnarchiveAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveAccommodationMutation, UnarchiveAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveAccommodationMutation, UnarchiveAccommodationMutationVariables>(UnarchiveAccommodationDocument, options);
      }
export type UnarchiveAccommodationMutationHookResult = ReturnType<typeof useUnarchiveAccommodationMutation>;
export type UnarchiveAccommodationMutationResult = Apollo.MutationResult<UnarchiveAccommodationMutation>;
export type UnarchiveAccommodationMutationOptions = Apollo.BaseMutationOptions<UnarchiveAccommodationMutation, UnarchiveAccommodationMutationVariables>;
export const UnbaptizeUserDocument = gql`
    mutation UnbaptizeUser($input: UnbaptizeUserInput!) {
  unbaptizeUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UnbaptizeUserMutationFn = Apollo.MutationFunction<UnbaptizeUserMutation, UnbaptizeUserMutationVariables>;

/**
 * __useUnbaptizeUserMutation__
 *
 * To run a mutation, you first call `useUnbaptizeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbaptizeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbaptizeUserMutation, { data, loading, error }] = useUnbaptizeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnbaptizeUserMutation(baseOptions?: Apollo.MutationHookOptions<UnbaptizeUserMutation, UnbaptizeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnbaptizeUserMutation, UnbaptizeUserMutationVariables>(UnbaptizeUserDocument, options);
      }
export type UnbaptizeUserMutationHookResult = ReturnType<typeof useUnbaptizeUserMutation>;
export type UnbaptizeUserMutationResult = Apollo.MutationResult<UnbaptizeUserMutation>;
export type UnbaptizeUserMutationOptions = Apollo.BaseMutationOptions<UnbaptizeUserMutation, UnbaptizeUserMutationVariables>;
export const UnpublishAccommodationDocument = gql`
    mutation UnpublishAccommodation($input: UnpublishAccommodationInput!) {
  unpublishAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type UnpublishAccommodationMutationFn = Apollo.MutationFunction<UnpublishAccommodationMutation, UnpublishAccommodationMutationVariables>;

/**
 * __useUnpublishAccommodationMutation__
 *
 * To run a mutation, you first call `useUnpublishAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishAccommodationMutation, { data, loading, error }] = useUnpublishAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpublishAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishAccommodationMutation, UnpublishAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishAccommodationMutation, UnpublishAccommodationMutationVariables>(UnpublishAccommodationDocument, options);
      }
export type UnpublishAccommodationMutationHookResult = ReturnType<typeof useUnpublishAccommodationMutation>;
export type UnpublishAccommodationMutationResult = Apollo.MutationResult<UnpublishAccommodationMutation>;
export type UnpublishAccommodationMutationOptions = Apollo.BaseMutationOptions<UnpublishAccommodationMutation, UnpublishAccommodationMutationVariables>;
export const UnregisterUserFromActivityDocument = gql`
    mutation UnregisterUserFromActivity($input: UnregisterUserFromActivityInput!) {
  unregisterUserFromActivity(input: $input) {
    activityAttendance {
      user {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UnregisterUserFromActivityMutationFn = Apollo.MutationFunction<UnregisterUserFromActivityMutation, UnregisterUserFromActivityMutationVariables>;

/**
 * __useUnregisterUserFromActivityMutation__
 *
 * To run a mutation, you first call `useUnregisterUserFromActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterUserFromActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterUserFromActivityMutation, { data, loading, error }] = useUnregisterUserFromActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnregisterUserFromActivityMutation(baseOptions?: Apollo.MutationHookOptions<UnregisterUserFromActivityMutation, UnregisterUserFromActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnregisterUserFromActivityMutation, UnregisterUserFromActivityMutationVariables>(UnregisterUserFromActivityDocument, options);
      }
export type UnregisterUserFromActivityMutationHookResult = ReturnType<typeof useUnregisterUserFromActivityMutation>;
export type UnregisterUserFromActivityMutationResult = Apollo.MutationResult<UnregisterUserFromActivityMutation>;
export type UnregisterUserFromActivityMutationOptions = Apollo.BaseMutationOptions<UnregisterUserFromActivityMutation, UnregisterUserFromActivityMutationVariables>;
export const UnrejectUserDocument = gql`
    mutation UnrejectUser($input: UnrejectUserInput!) {
  unrejectUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UnrejectUserMutationFn = Apollo.MutationFunction<UnrejectUserMutation, UnrejectUserMutationVariables>;

/**
 * __useUnrejectUserMutation__
 *
 * To run a mutation, you first call `useUnrejectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnrejectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unrejectUserMutation, { data, loading, error }] = useUnrejectUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnrejectUserMutation(baseOptions?: Apollo.MutationHookOptions<UnrejectUserMutation, UnrejectUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnrejectUserMutation, UnrejectUserMutationVariables>(UnrejectUserDocument, options);
      }
export type UnrejectUserMutationHookResult = ReturnType<typeof useUnrejectUserMutation>;
export type UnrejectUserMutationResult = Apollo.MutationResult<UnrejectUserMutation>;
export type UnrejectUserMutationOptions = Apollo.BaseMutationOptions<UnrejectUserMutation, UnrejectUserMutationVariables>;
export const UnvisitAccommodationDocument = gql`
    mutation UnvisitAccommodation($input: UnvisitAccommodationInput!) {
  unvisitAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type UnvisitAccommodationMutationFn = Apollo.MutationFunction<UnvisitAccommodationMutation, UnvisitAccommodationMutationVariables>;

/**
 * __useUnvisitAccommodationMutation__
 *
 * To run a mutation, you first call `useUnvisitAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnvisitAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unvisitAccommodationMutation, { data, loading, error }] = useUnvisitAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnvisitAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<UnvisitAccommodationMutation, UnvisitAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnvisitAccommodationMutation, UnvisitAccommodationMutationVariables>(UnvisitAccommodationDocument, options);
      }
export type UnvisitAccommodationMutationHookResult = ReturnType<typeof useUnvisitAccommodationMutation>;
export type UnvisitAccommodationMutationResult = Apollo.MutationResult<UnvisitAccommodationMutation>;
export type UnvisitAccommodationMutationOptions = Apollo.BaseMutationOptions<UnvisitAccommodationMutation, UnvisitAccommodationMutationVariables>;
export const UpdateAccommodationDocument = gql`
    mutation UpdateAccommodation($input: UpdateAccommodationInput!) {
  updateAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type UpdateAccommodationMutationFn = Apollo.MutationFunction<UpdateAccommodationMutation, UpdateAccommodationMutationVariables>;

/**
 * __useUpdateAccommodationMutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationMutation, { data, loading, error }] = useUpdateAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccommodationMutation, UpdateAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccommodationMutation, UpdateAccommodationMutationVariables>(UpdateAccommodationDocument, options);
      }
export type UpdateAccommodationMutationHookResult = ReturnType<typeof useUpdateAccommodationMutation>;
export type UpdateAccommodationMutationResult = Apollo.MutationResult<UpdateAccommodationMutation>;
export type UpdateAccommodationMutationOptions = Apollo.BaseMutationOptions<UpdateAccommodationMutation, UpdateAccommodationMutationVariables>;
export const UpdateAccommodationMaxRequestCountDocument = gql`
    mutation UpdateAccommodationMaxRequestCount($input: UpdateAccommodationMaxRequestCountInput!) {
  updateAccommodationMaxRequestCount(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type UpdateAccommodationMaxRequestCountMutationFn = Apollo.MutationFunction<UpdateAccommodationMaxRequestCountMutation, UpdateAccommodationMaxRequestCountMutationVariables>;

/**
 * __useUpdateAccommodationMaxRequestCountMutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationMaxRequestCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationMaxRequestCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationMaxRequestCountMutation, { data, loading, error }] = useUpdateAccommodationMaxRequestCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccommodationMaxRequestCountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccommodationMaxRequestCountMutation, UpdateAccommodationMaxRequestCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccommodationMaxRequestCountMutation, UpdateAccommodationMaxRequestCountMutationVariables>(UpdateAccommodationMaxRequestCountDocument, options);
      }
export type UpdateAccommodationMaxRequestCountMutationHookResult = ReturnType<typeof useUpdateAccommodationMaxRequestCountMutation>;
export type UpdateAccommodationMaxRequestCountMutationResult = Apollo.MutationResult<UpdateAccommodationMaxRequestCountMutation>;
export type UpdateAccommodationMaxRequestCountMutationOptions = Apollo.BaseMutationOptions<UpdateAccommodationMaxRequestCountMutation, UpdateAccommodationMaxRequestCountMutationVariables>;
export const UpdateActivityDocument = gql`
    mutation UpdateActivity($input: UpdateActivityInput!) {
  updateActivity(input: $input) {
    activity {
      ...ActivityFields
    }
  }
}
    ${ActivityFieldsFragmentDoc}`;
export type UpdateActivityMutationFn = Apollo.MutationFunction<UpdateActivityMutation, UpdateActivityMutationVariables>;

/**
 * __useUpdateActivityMutation__
 *
 * To run a mutation, you first call `useUpdateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityMutation, { data, loading, error }] = useUpdateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityMutation, UpdateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityMutation, UpdateActivityMutationVariables>(UpdateActivityDocument, options);
      }
export type UpdateActivityMutationHookResult = ReturnType<typeof useUpdateActivityMutation>;
export type UpdateActivityMutationResult = Apollo.MutationResult<UpdateActivityMutation>;
export type UpdateActivityMutationOptions = Apollo.BaseMutationOptions<UpdateActivityMutation, UpdateActivityMutationVariables>;
export const UpdateActivityPictureDocument = gql`
    mutation UpdateActivityPicture($input: UpdateActivityPictureInput!) {
  updateActivityPicture(input: $input) {
    activity {
      id
      picture {
        id
        url
      }
    }
  }
}
    `;
export type UpdateActivityPictureMutationFn = Apollo.MutationFunction<UpdateActivityPictureMutation, UpdateActivityPictureMutationVariables>;

/**
 * __useUpdateActivityPictureMutation__
 *
 * To run a mutation, you first call `useUpdateActivityPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityPictureMutation, { data, loading, error }] = useUpdateActivityPictureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityPictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityPictureMutation, UpdateActivityPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityPictureMutation, UpdateActivityPictureMutationVariables>(UpdateActivityPictureDocument, options);
      }
export type UpdateActivityPictureMutationHookResult = ReturnType<typeof useUpdateActivityPictureMutation>;
export type UpdateActivityPictureMutationResult = Apollo.MutationResult<UpdateActivityPictureMutation>;
export type UpdateActivityPictureMutationOptions = Apollo.BaseMutationOptions<UpdateActivityPictureMutation, UpdateActivityPictureMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($input: UpdateBookingInput!) {
  updateBooking(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const UpdateBookingNpsDocument = gql`
    mutation UpdateBookingNps($input: UpdateBookingNpsInput!) {
  updateBookingNps(input: $input) {
    booking {
      ...BookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}`;
export type UpdateBookingNpsMutationFn = Apollo.MutationFunction<UpdateBookingNpsMutation, UpdateBookingNpsMutationVariables>;

/**
 * __useUpdateBookingNpsMutation__
 *
 * To run a mutation, you first call `useUpdateBookingNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingNpsMutation, { data, loading, error }] = useUpdateBookingNpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingNpsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingNpsMutation, UpdateBookingNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingNpsMutation, UpdateBookingNpsMutationVariables>(UpdateBookingNpsDocument, options);
      }
export type UpdateBookingNpsMutationHookResult = ReturnType<typeof useUpdateBookingNpsMutation>;
export type UpdateBookingNpsMutationResult = Apollo.MutationResult<UpdateBookingNpsMutation>;
export type UpdateBookingNpsMutationOptions = Apollo.BaseMutationOptions<UpdateBookingNpsMutation, UpdateBookingNpsMutationVariables>;
export const UpdateBookingPriceDocument = gql`
    mutation UpdateBookingPrice($input: UpdateBookingPriceInput!) {
  updateBookingPrice(input: $input) {
    booking {
      ...BookingFields
      rental {
        ...RentalFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${RentalFieldsFragmentDoc}`;
export type UpdateBookingPriceMutationFn = Apollo.MutationFunction<UpdateBookingPriceMutation, UpdateBookingPriceMutationVariables>;

/**
 * __useUpdateBookingPriceMutation__
 *
 * To run a mutation, you first call `useUpdateBookingPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingPriceMutation, { data, loading, error }] = useUpdateBookingPriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingPriceMutation, UpdateBookingPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingPriceMutation, UpdateBookingPriceMutationVariables>(UpdateBookingPriceDocument, options);
      }
export type UpdateBookingPriceMutationHookResult = ReturnType<typeof useUpdateBookingPriceMutation>;
export type UpdateBookingPriceMutationResult = Apollo.MutationResult<UpdateBookingPriceMutation>;
export type UpdateBookingPriceMutationOptions = Apollo.BaseMutationOptions<UpdateBookingPriceMutation, UpdateBookingPriceMutationVariables>;
export const UpdateBookingReportDocument = gql`
    mutation UpdateBookingReport($input: UpdateBookingReportInput!) {
  updateBookingReport(input: $input) {
    bookingReport {
      ...BookingReportFields
    }
  }
}
    ${BookingReportFieldsFragmentDoc}`;
export type UpdateBookingReportMutationFn = Apollo.MutationFunction<UpdateBookingReportMutation, UpdateBookingReportMutationVariables>;

/**
 * __useUpdateBookingReportMutation__
 *
 * To run a mutation, you first call `useUpdateBookingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingReportMutation, { data, loading, error }] = useUpdateBookingReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingReportMutation, UpdateBookingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingReportMutation, UpdateBookingReportMutationVariables>(UpdateBookingReportDocument, options);
      }
export type UpdateBookingReportMutationHookResult = ReturnType<typeof useUpdateBookingReportMutation>;
export type UpdateBookingReportMutationResult = Apollo.MutationResult<UpdateBookingReportMutation>;
export type UpdateBookingReportMutationOptions = Apollo.BaseMutationOptions<UpdateBookingReportMutation, UpdateBookingReportMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    category {
      id
      insertedAt
      name
    }
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCharterDocument = gql`
    mutation UpdateCharter($input: UpdateCharterInput!) {
  updateCharter(input: $input) {
    charter {
      ...CharterFields
    }
  }
}
    ${CharterFieldsFragmentDoc}`;
export type UpdateCharterMutationFn = Apollo.MutationFunction<UpdateCharterMutation, UpdateCharterMutationVariables>;

/**
 * __useUpdateCharterMutation__
 *
 * To run a mutation, you first call `useUpdateCharterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCharterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCharterMutation, { data, loading, error }] = useUpdateCharterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCharterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCharterMutation, UpdateCharterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCharterMutation, UpdateCharterMutationVariables>(UpdateCharterDocument, options);
      }
export type UpdateCharterMutationHookResult = ReturnType<typeof useUpdateCharterMutation>;
export type UpdateCharterMutationResult = Apollo.MutationResult<UpdateCharterMutation>;
export type UpdateCharterMutationOptions = Apollo.BaseMutationOptions<UpdateCharterMutation, UpdateCharterMutationVariables>;
export const UpdatePlaceDocument = gql`
    mutation UpdatePlace($input: UpdatePlaceInput!) {
  updatePlace(input: $input) {
    place {
      ...PlaceFields
    }
  }
}
    ${PlaceFieldsFragmentDoc}`;
export type UpdatePlaceMutationFn = Apollo.MutationFunction<UpdatePlaceMutation, UpdatePlaceMutationVariables>;

/**
 * __useUpdatePlaceMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceMutation, { data, loading, error }] = useUpdatePlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceMutation, UpdatePlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceMutation, UpdatePlaceMutationVariables>(UpdatePlaceDocument, options);
      }
export type UpdatePlaceMutationHookResult = ReturnType<typeof useUpdatePlaceMutation>;
export type UpdatePlaceMutationResult = Apollo.MutationResult<UpdatePlaceMutation>;
export type UpdatePlaceMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceMutation, UpdatePlaceMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      ...UserFields
      role {
        ...HostFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${HostFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation UpdateUserAvatar($input: UpdateUserAvatarInput!) {
  updateUserAvatar(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, options);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const UpdateUserCompatibilityDocument = gql`
    mutation UpdateUserCompatibility($input: UpdateUserCompatibilityInput!) {
  updateUserCompatibility(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserCompatibilityMutationFn = Apollo.MutationFunction<UpdateUserCompatibilityMutation, UpdateUserCompatibilityMutationVariables>;

/**
 * __useUpdateUserCompatibilityMutation__
 *
 * To run a mutation, you first call `useUpdateUserCompatibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCompatibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCompatibilityMutation, { data, loading, error }] = useUpdateUserCompatibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCompatibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCompatibilityMutation, UpdateUserCompatibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCompatibilityMutation, UpdateUserCompatibilityMutationVariables>(UpdateUserCompatibilityDocument, options);
      }
export type UpdateUserCompatibilityMutationHookResult = ReturnType<typeof useUpdateUserCompatibilityMutation>;
export type UpdateUserCompatibilityMutationResult = Apollo.MutationResult<UpdateUserCompatibilityMutation>;
export type UpdateUserCompatibilityMutationOptions = Apollo.BaseMutationOptions<UpdateUserCompatibilityMutation, UpdateUserCompatibilityMutationVariables>;
export const UpdateUserOnboardingDocument = gql`
    mutation UpdateUserOnboarding($input: UpdateUserOnboardingInput!) {
  updateUserOnboarding(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserOnboardingMutationFn = Apollo.MutationFunction<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>;

/**
 * __useUpdateUserOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnboardingMutation, { data, loading, error }] = useUpdateUserOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>(UpdateUserOnboardingDocument, options);
      }
export type UpdateUserOnboardingMutationHookResult = ReturnType<typeof useUpdateUserOnboardingMutation>;
export type UpdateUserOnboardingMutationResult = Apollo.MutationResult<UpdateUserOnboardingMutation>;
export type UpdateUserOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnboardingMutation, UpdateUserOnboardingMutationVariables>;
export const UpdateUserReviewDocument = gql`
    mutation UpdateUserReview($input: UpdateUserReviewInput!) {
  updateUserReview(input: $input) {
    userReview {
      ...UserReviewFields
    }
  }
}
    ${UserReviewFieldsFragmentDoc}`;
export type UpdateUserReviewMutationFn = Apollo.MutationFunction<UpdateUserReviewMutation, UpdateUserReviewMutationVariables>;

/**
 * __useUpdateUserReviewMutation__
 *
 * To run a mutation, you first call `useUpdateUserReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserReviewMutation, { data, loading, error }] = useUpdateUserReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserReviewMutation, UpdateUserReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserReviewMutation, UpdateUserReviewMutationVariables>(UpdateUserReviewDocument, options);
      }
export type UpdateUserReviewMutationHookResult = ReturnType<typeof useUpdateUserReviewMutation>;
export type UpdateUserReviewMutationResult = Apollo.MutationResult<UpdateUserReviewMutation>;
export type UpdateUserReviewMutationOptions = Apollo.BaseMutationOptions<UpdateUserReviewMutation, UpdateUserReviewMutationVariables>;
export const UserAccountDocument = gql`
    query UserAccount($id: ID!) {
  user(id: $id) {
    ...UserFields
    account {
      ...AccountFields
      entries(first: 1000) {
        count
        edges {
          node {
            ...EntryFields
          }
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${EntryFieldsFragmentDoc}`;

/**
 * __useUserAccountQuery__
 *
 * To run a query within a React component, call `useUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserAccountQuery(baseOptions: Apollo.QueryHookOptions<UserAccountQuery, UserAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccountQuery, UserAccountQueryVariables>(UserAccountDocument, options);
      }
export function useUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccountQuery, UserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccountQuery, UserAccountQueryVariables>(UserAccountDocument, options);
        }
export type UserAccountQueryHookResult = ReturnType<typeof useUserAccountQuery>;
export type UserAccountLazyQueryHookResult = ReturnType<typeof useUserAccountLazyQuery>;
export type UserAccountQueryResult = Apollo.QueryResult<UserAccountQuery, UserAccountQueryVariables>;
export const ValidateAccommodationProfessionalPicturesDocument = gql`
    mutation ValidateAccommodationProfessionalPictures($input: ValidateAccommodationProfessionalPicturesInput!) {
  validateAccommodationProfessionalPictures(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type ValidateAccommodationProfessionalPicturesMutationFn = Apollo.MutationFunction<ValidateAccommodationProfessionalPicturesMutation, ValidateAccommodationProfessionalPicturesMutationVariables>;

/**
 * __useValidateAccommodationProfessionalPicturesMutation__
 *
 * To run a mutation, you first call `useValidateAccommodationProfessionalPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAccommodationProfessionalPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAccommodationProfessionalPicturesMutation, { data, loading, error }] = useValidateAccommodationProfessionalPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAccommodationProfessionalPicturesMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAccommodationProfessionalPicturesMutation, ValidateAccommodationProfessionalPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAccommodationProfessionalPicturesMutation, ValidateAccommodationProfessionalPicturesMutationVariables>(ValidateAccommodationProfessionalPicturesDocument, options);
      }
export type ValidateAccommodationProfessionalPicturesMutationHookResult = ReturnType<typeof useValidateAccommodationProfessionalPicturesMutation>;
export type ValidateAccommodationProfessionalPicturesMutationResult = Apollo.MutationResult<ValidateAccommodationProfessionalPicturesMutation>;
export type ValidateAccommodationProfessionalPicturesMutationOptions = Apollo.BaseMutationOptions<ValidateAccommodationProfessionalPicturesMutation, ValidateAccommodationProfessionalPicturesMutationVariables>;
export const VisitAccommodationDocument = gql`
    mutation VisitAccommodation($input: VisitAccommodationInput!) {
  visitAccommodation(input: $input) {
    accommodation {
      ...AccommodationFields
    }
  }
}
    ${AccommodationFieldsFragmentDoc}`;
export type VisitAccommodationMutationFn = Apollo.MutationFunction<VisitAccommodationMutation, VisitAccommodationMutationVariables>;

/**
 * __useVisitAccommodationMutation__
 *
 * To run a mutation, you first call `useVisitAccommodationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitAccommodationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitAccommodationMutation, { data, loading, error }] = useVisitAccommodationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisitAccommodationMutation(baseOptions?: Apollo.MutationHookOptions<VisitAccommodationMutation, VisitAccommodationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitAccommodationMutation, VisitAccommodationMutationVariables>(VisitAccommodationDocument, options);
      }
export type VisitAccommodationMutationHookResult = ReturnType<typeof useVisitAccommodationMutation>;
export type VisitAccommodationMutationResult = Apollo.MutationResult<VisitAccommodationMutation>;
export type VisitAccommodationMutationOptions = Apollo.BaseMutationOptions<VisitAccommodationMutation, VisitAccommodationMutationVariables>;